/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: unknown; output: unknown; }
  /**
   * Date represents a date in YYYY-MM-DD format (e.g., "2020-12-31").
   * This is used for date-only values without time information.
   */
  Date: { input: string; output: string; }
  /**
   * DateTime represents a date-time in RFC3339 format (e.g., "2006-01-02T15:04:05Z07:00").
   * This includes both date and time information with timezone.
   */
  DateTime: { input: string; output: string; }
  /**
   * DateTimeMillis represents a date-time in RFC3339 format with millisecond precision (e.g., "2006-01-02T15:04:05.999Z07:00").
   * This includes both date and time information with timezone and millisecond precision.
   */
  DateTimeMillis: { input: string; output: string; }
  /**
   * DateTimeNanos represents a date-time in RFC3339Nano format (e.g., "2006-01-02T15:04:05.999999999Z07:00").
   * This includes both date and time information with timezone and nanosecond precision.
   */
  DateTimeNanos: { input: string; output: string; }
  /** Google Protobuf Duration - represents a time duration */
  GoogleProtobuf_Duration: { input: string; output: string; }
  GoogleProtobuf_DurationInput: { input: string; output: string; }
  /** Google Protobuf Empty - represents an empty message */
  GoogleProtobuf_Empty: { input: Record<string, never>; output: Record<string, never>; }
  GoogleProtobuf_EmptyInput: { input: Record<string, never>; output: Record<string, never>; }
  /** Google Protobuf Struct - represents a structured data value */
  GoogleProtobuf_Struct: { input: Record<string, unknown>; output: Record<string, unknown>; }
  GoogleProtobuf_StructInput: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** Google Protobuf Timestamp - represents a point in time */
  GoogleProtobuf_Timestamp: { input: string; output: string; }
  GoogleProtobuf_TimestampInput: { input: string; output: string; }
  Int64: { input: string; output: string; }
  /**
   * Map represents an arbitrary map with any key and value types.
   * This is used for proto map types.
   */
  Map: { input: any; output: any; }
  /**
   * TimestampProto represents a Protocol Buffer timestamp with full nanosecond precision.
   * Serializes to/from RFC3339Nano format (e.g., "2006-01-02T15:04:05.123456789Z").
   * Use this for proto Timestamp (timestamppb.Timestamp) to preserve precision during conversion.
   */
  TimestampProto: { input: any; output: any; }
};

export type AccountRemuneration = {
  __typename?: 'AccountRemuneration';
  id: Scalars['ID']['output'];
  remuneratedMonthStartDate: Scalars['String']['output'];
};

export enum ActivityTag {
  Atm = 'ATM',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  Fallback = 'FALLBACK',
  Fees = 'FEES',
  Finance = 'FINANCE',
  FoodAndGrocery = 'FOOD_AND_GROCERY',
  GasStation = 'GAS_STATION',
  HardwareAndEquipment = 'HARDWARE_AND_EQUIPMENT',
  HotelAndLodging = 'HOTEL_AND_LODGING',
  Insurance = 'INSURANCE',
  ItAndElectronics = 'IT_AND_ELECTRONICS',
  LegalAndAccounting = 'LEGAL_AND_ACCOUNTING',
  Logistics = 'LOGISTICS',
  Manufacturing = 'MANUFACTURING',
  Marketing = 'MARKETING',
  OfficeRental = 'OFFICE_RENTAL',
  OfficeSupply = 'OFFICE_SUPPLY',
  OnlineService = 'ONLINE_SERVICE',
  OtherExpense = 'OTHER_EXPENSE',
  OtherIncome = 'OTHER_INCOME',
  OtherService = 'OTHER_SERVICE',
  Pending = 'PENDING',
  Refund = 'REFUND',
  RestaurantAndBar = 'RESTAURANT_AND_BAR',
  Salary = 'SALARY',
  Sales = 'SALES',
  Subscription = 'SUBSCRIPTION',
  Tax = 'TAX',
  Transport = 'TRANSPORT',
  TreasuryAndInterco = 'TREASURY_AND_INTERCO',
  Utility = 'UTILITY',
  Voucher = 'VOUCHER'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstLine?: Maybe<Scalars['String']['output']>;
  secondLine?: Maybe<Scalars['String']['output']>;
  thirdLine?: Maybe<Scalars['String']['output']>;
  type: CompanyAddressType;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Amount = {
  __typename?: 'Amount';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttachedFile = {
  __typename?: 'AttachedFile';
  contentType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  attachmentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  file?: Maybe<AttachedFile>;
  id: Scalars['ID']['output'];
  probativeAttachment?: Maybe<ProbativeAttachment>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Thumbnail>;
};

export enum AuthorizationType {
  Full = 'FULL',
  Remaining = 'REMAINING'
}

export type AvatarFile = {
  __typename?: 'AvatarFile';
  url: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Logo>;
  name: Scalars['String']['output'];
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType: Scalars['String']['output'];
  activityTag: Scalars['String']['output'];
  address?: Maybe<BeneficiaryAddress>;
  avatar: File;
  avatarThumb: File;
  b2b: Scalars['Boolean']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  core: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  creditBankAccountId?: Maybe<Scalars['String']['output']>;
  creditorIdentifier?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  defaultAvatar: File;
  defaultAvatarThumb: File;
  email?: Maybe<Scalars['String']['output']>;
  fx: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labelIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  qontoBankAccount: Scalars['Boolean']['output'];
  routingNumber?: Maybe<Scalars['String']['output']>;
  sct: Scalars['Boolean']['output'];
  sortCode?: Maybe<Scalars['String']['output']>;
  transferTransactionsCount?: Maybe<Scalars['Int']['output']>;
  trusted: Scalars['Boolean']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type BeneficiaryAddress = {
  __typename?: 'BeneficiaryAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstLine?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type BillingTransfer = {
  __typename?: 'BillingTransfer';
  amount: Amount;
  enrichmentData: BillingTransferEnrichmentData;
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  operationSubtype: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  totalAmount: Amount;
  vatAmount: Amount;
  vatRate: Scalars['Float']['output'];
};

export type BillingTransferEnrichmentData = {
  __typename?: 'BillingTransferEnrichmentData';
  isRecurring: Scalars['Boolean']['output'];
  logo?: Maybe<Logo>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  recurrence?: Maybe<Scalars['String']['output']>;
};

export type Card = {
  __typename?: 'Card';
  activeDays: Array<Scalars['Int']['output']>;
  appearance?: Maybe<CardAppearance>;
  atmDailyLimit: Scalars['Float']['output'];
  atmDailyLimitOption: Scalars['Boolean']['output'];
  atmDailySpent: Scalars['Float']['output'];
  atmMonthlyLimit: Scalars['Float']['output'];
  atmMonthlySpent: Scalars['Float']['output'];
  atmOption: Scalars['Boolean']['output'];
  bankAccountId: Scalars['String']['output'];
  cardDesign?: Maybe<Scalars['String']['output']>;
  cardLevel: CardLevel;
  cardType: CardType;
  categoryTags: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  cvv: Scalars['String']['output'];
  ddcUpgrade: Scalars['Boolean']['output'];
  ddcUpgraded: Scalars['Boolean']['output'];
  deferredDebitCreditProductDetails?: Maybe<DdcProductDetails>;
  discardOn?: Maybe<Scalars['String']['output']>;
  eligibleForDDCUpgrade: EligibleForDdcUpgrade;
  eligibleForRenewal: Scalars['Boolean']['output'];
  eligibleForUpsell: Scalars['Boolean']['output'];
  embossedName?: Maybe<Scalars['String']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expirationDateShort?: Maybe<Scalars['String']['output']>;
  foreignOption: Scalars['Boolean']['output'];
  forwardedAt?: Maybe<Scalars['String']['output']>;
  hadOperation: Scalars['Boolean']['output'];
  hadPinOperation: Scalars['Boolean']['output'];
  hasOnlyUserLiftableLocks: Scalars['Boolean']['output'];
  holder?: Maybe<LegacyMembership>;
  holderId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isQcp: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  lastActivityAt?: Maybe<Scalars['String']['output']>;
  lockReason?: Maybe<Scalars['String']['output']>;
  maskPan?: Maybe<Scalars['String']['output']>;
  nfcOption: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
  onlineOption: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  parentCardSummary?: Maybe<ParentCardSummary>;
  paymentDailyLimit: Scalars['Int']['output'];
  paymentDailyLimitOption: Scalars['Boolean']['output'];
  paymentDailySpent: Scalars['Float']['output'];
  paymentLifespanLimit?: Maybe<Scalars['Int']['output']>;
  paymentLifespanSpent: Scalars['Float']['output'];
  paymentMode: PaymentMode;
  paymentMonthlyLimit: Scalars['Int']['output'];
  paymentMonthlySpent: Scalars['Float']['output'];
  paymentTransactionLimit: Scalars['Int']['output'];
  paymentTransactionLimitOption: Scalars['Boolean']['output'];
  physical: Scalars['Boolean']['output'];
  pinSet: Scalars['Boolean']['output'];
  preExpiresAt?: Maybe<Scalars['String']['output']>;
  renewal: Scalars['Boolean']['output'];
  renewed: Scalars['Boolean']['output'];
  reordered: Scalars['Boolean']['output'];
  sequentialId?: Maybe<Scalars['Int']['output']>;
  shipToBusiness: Scalars['Boolean']['output'];
  shippedAt?: Maybe<Scalars['String']['output']>;
  status: CardStatus;
  statusReasons: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  upsell: Scalars['Boolean']['output'];
  upsold: Scalars['Boolean']['output'];
};

export type CardAcquirerPayout = {
  __typename?: 'CardAcquirerPayout';
  amount: Amount;
  bookTransferMovementId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  status: Status;
};

export type CardAppearance = {
  __typename?: 'CardAppearance';
  assets: CardAppearanceAssets;
  gradientHexColor?: Maybe<Scalars['String']['output']>;
  theme: CardAppearanceTheme;
};

export type CardAppearanceAssets = {
  __typename?: 'CardAppearanceAssets';
  frontLarge: Scalars['String']['output'];
  frontSmall: Scalars['String']['output'];
  frontSmallWallet: Scalars['String']['output'];
};

export enum CardAppearanceTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum CardLevel {
  Advertising = 'ADVERTISING',
  Flash = 'FLASH',
  Metal = 'METAL',
  Mirror = 'MIRROR',
  Plus = 'PLUS',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN',
  Virtual = 'VIRTUAL'
}

export enum CardStatus {
  Abusive = 'ABUSIVE',
  Deleted = 'DELETED',
  Discarded = 'DISCARDED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Lost = 'LOST',
  Onhold = 'ONHOLD',
  Ordered = 'ORDERED',
  OrderCanceled = 'ORDER_CANCELED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PinBlocked = 'PIN_BLOCKED',
  PreExpired = 'PRE_EXPIRED',
  Received = 'RECEIVED',
  Shipped = 'SHIPPED',
  ShippedLost = 'SHIPPED_LOST',
  Stolen = 'STOLEN',
  Unknown = 'UNKNOWN'
}

export enum CardStatusFilter {
  Abusive = 'ABUSIVE',
  Discarded = 'DISCARDED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Lost = 'LOST',
  Onhold = 'ONHOLD',
  OrderCanceled = 'ORDER_CANCELED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PinBlocked = 'PIN_BLOCKED',
  PreExpired = 'PRE_EXPIRED',
  ShippedLost = 'SHIPPED_LOST',
  Stolen = 'STOLEN'
}

export type CardTransaction = {
  __typename?: 'CardTransaction';
  computedStatus: Scalars['String']['output'];
  movementId: Scalars['ID']['output'];
  refusalReason?: Maybe<Scalars['String']['output']>;
  refusalReasonCategory?: Maybe<Scalars['String']['output']>;
  refusalReasonGroup?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CardTransactionStatus = {
  __typename?: 'CardTransactionStatus';
  computedStatus: Scalars['String']['output'];
  movementId: Scalars['ID']['output'];
};

export enum CardType {
  Debit = 'DEBIT',
  Flex = 'FLEX',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN'
}

export type CardsSearch = {
  filters?: InputMaybe<CardsSearchFilters>;
  pagination?: InputMaybe<Pagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type CardsSearchFilters = {
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLevels?: InputMaybe<Array<CardLevel>>;
  holderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<CardStatusFilter>>;
};

export type CashFlowCategory = {
  __typename?: 'CashFlowCategory';
  colorKey: Scalars['String']['output'];
  iconKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameKey?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Cashback = {
  __typename?: 'Cashback';
  amount: Amount;
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  referenceMonthStartDate: Scalars['String']['output'];
};

export type CategoryAssignment = {
  __typename?: 'CategoryAssignment';
  id: Scalars['String']['output'];
  ruleId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type Check = {
  __typename?: 'Check';
  amount: Amount;
  canceledAt?: Maybe<Scalars['String']['output']>;
  cmc7: Cmc7;
  createdAt: Scalars['String']['output'];
  creditDelayDays: Scalars['String']['output'];
  creditExpectedAt?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  emittedDate?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['ID']['output']>;
  movementId: Scalars['ID']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['String']['output']>;
  rlmc?: Maybe<Scalars['String']['output']>;
  shippingAddress: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  validatedAt?: Maybe<Scalars['String']['output']>;
};

export type Claim = {
  __typename?: 'Claim';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Cmc7 = {
  __typename?: 'Cmc7';
  a: Scalars['String']['output'];
  b: Scalars['String']['output'];
  c: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  activityDescription?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  contactEmail: Scalars['String']['output'];
  financialDetail?: Maybe<FinancialDetail>;
  legalCode?: Maybe<Scalars['String']['output']>;
  legalCountry: Scalars['String']['output'];
  legalForm?: Maybe<Scalars['String']['output']>;
  legalName: Scalars['String']['output'];
  legalNumber?: Maybe<Scalars['String']['output']>;
  legalRegistrationDate?: Maybe<Scalars['String']['output']>;
  legalSector?: Maybe<Scalars['String']['output']>;
  legalTvaNumber?: Maybe<Scalars['String']['output']>;
  taxResidence?: Maybe<CompanyTaxResidence>;
  tradeName?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export enum CompanyAddressType {
  Headquarter = 'HEADQUARTER',
  Standard = 'STANDARD'
}

export type CompanyTaxResidence = {
  __typename?: 'CompanyTaxResidence';
  country?: Maybe<Scalars['String']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
};

export type CostCenterAllocation = {
  __typename?: 'CostCenterAllocation';
  category?: Maybe<CostCenterCategory>;
  costCenterCode: Scalars['String']['output'];
  costCenterId: Scalars['String']['output'];
  costCenterIsActive: Scalars['Boolean']['output'];
  costCenterLabel: Scalars['String']['output'];
};

export type CostCenterCategory = {
  __typename?: 'CostCenterCategory';
  code: Scalars['String']['output'];
  colorToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Counterparty = {
  __typename?: 'Counterparty';
  accountNumber: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  contractSignedAt?: Maybe<Scalars['DateTimeNanos']['output']>;
  natureOfOperations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DdcLimits = {
  __typename?: 'DDCLimits';
  total: Amount;
  used: Amount;
};

export type DdcProductDetails = {
  __typename?: 'DDCProductDetails';
  deferredDebitCreditAccountId: Scalars['String']['output'];
  dueAmount: Amount;
  limit: DdcLimits;
  nextPayment: Scalars['String']['output'];
};

export enum DdcStatus {
  Declined = 'DECLINED',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export enum DeclinedReason {
  AccountInactive = 'ACCOUNT_INACTIVE',
  CannotVerifyPin = 'CANNOT_VERIFY_PIN',
  CardholderToContactIssuer = 'CARDHOLDER_TO_CONTACT_ISSUER',
  CustomerCancellation = 'CUSTOMER_CANCELLATION',
  DirectDebitPostponed = 'DIRECT_DEBIT_POSTPONED',
  DoNotHonor = 'DO_NOT_HONOR',
  ExceedsWithdrawalAmountLimit = 'EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT',
  ExceedsWithdrawalFrequencyLimit = 'EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT',
  ExpiredCard = 'EXPIRED_CARD',
  IncorrectPin = 'INCORRECT_PIN',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidCardNumber = 'INVALID_CARD_NUMBER',
  InvalidMerchant = 'INVALID_MERCHANT',
  IssuerOrSwitchIsInoperative = 'ISSUER_OR_SWITCH_IS_INOPERATIVE',
  LostCard = 'LOST_CARD',
  MerchantNameAndCountryUnknown = 'MERCHANT_NAME_AND_COUNTRY_UNKNOWN',
  NotPermittedToCardholder = 'NOT_PERMITTED_TO_CARDHOLDER',
  NotPermittedToTerminal = 'NOT_PERMITTED_TO_TERMINAL',
  OpsCanceled = 'OPS_CANCELED',
  PinTriesExceeded = 'PIN_TRIES_EXCEEDED',
  ResponseReceivedTooLate = 'RESPONSE_RECEIVED_TOO_LATE',
  RestrictedCard = 'RESTRICTED_CARD',
  SecurityViolation = 'SECURITY_VIOLATION',
  StolenCard = 'STOLEN_CARD',
  SystemMalfunction = 'SYSTEM_MALFUNCTION',
  Timeout = 'TIMEOUT',
  UnableToRouteTransaction = 'UNABLE_TO_ROUTE_TRANSACTION',
  UserCanceled = 'USER_CANCELED'
}

export type DeferredDebitCardRepayment = {
  __typename?: 'DeferredDebitCardRepayment';
  id: Scalars['String']['output'];
  movementId: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  repaymentStatus: DdcStatus;
  scheduledAt?: Maybe<Scalars['String']['output']>;
};

export type DirectDebit = {
  __typename?: 'DirectDebit';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  emitterBic?: Maybe<Scalars['String']['output']>;
  emitterIban?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  executionDate?: Maybe<Scalars['String']['output']>;
  governmentOrder?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mandate?: Maybe<QontoTransfersSddMandatesFirstpartyV2_Mandate>;
  reference?: Maybe<Scalars['String']['output']>;
  refundRequestedAt?: Maybe<Scalars['String']['output']>;
  refundable: Scalars['Boolean']['output'];
  refundedAt?: Maybe<Scalars['String']['output']>;
  sepaMandateId?: Maybe<Scalars['ID']['output']>;
  sequentialId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DirectDebitCollection = {
  __typename?: 'DirectDebitCollection';
  amount: Amount;
  collectionDate: Scalars['String']['output'];
  creditorSchemeId: Scalars['String']['output'];
  debitorBic?: Maybe<Scalars['String']['output']>;
  debitorIban: Scalars['String']['output'];
  debitorName: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId: Scalars['ID']['output'];
  onHoldAmount?: Maybe<Amount>;
  onHoldRate?: Maybe<Scalars['String']['output']>;
  onHoldReleaseDate?: Maybe<Scalars['String']['output']>;
  rTransactionExecutedAt?: Maybe<Scalars['String']['output']>;
  rTransactionType?: Maybe<Scalars['String']['output']>;
  recurrenceType: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusReason?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uniqueMandateReference: Scalars['String']['output'];
};

export type DirectDebitHold = {
  __typename?: 'DirectDebitHold';
  amount: Amount;
  debitorName: Scalars['String']['output'];
  executionDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  onHoldRate: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['String']['output']>;
};

export type Discrepancy = {
  __typename?: 'Discrepancy';
  attachmentId: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  pdfValue: Scalars['String']['output'];
  xmlValue: Scalars['String']['output'];
};

export type Dispute = {
  __typename?: 'Dispute';
  claim: Claim;
  transactionId: Scalars['ID']['output'];
};

export type EinvoicingLifecycleEvent = {
  __typename?: 'EinvoicingLifecycleEvent';
  createdAt: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reasonMessage?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type EligibleForDdcUpgrade = {
  __typename?: 'EligibleForDDCUpgrade';
  replacementFlow: Scalars['Boolean']['output'];
  requiresAccountSwitch: Scalars['Boolean']['output'];
  upsellFlow: Scalars['Boolean']['output'];
};

export type EnrichmentData = {
  __typename?: 'EnrichmentData';
  logo?: Maybe<Logo>;
};

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  amount: Amount;
  arrival?: Maybe<MileageAddress>;
  attachment?: Maybe<Attachment>;
  /** Attachment ID of the expense item. `null` if attachment for mileage is pending. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** Date of the expense item or trip. Format: YYYY-MM-DD. Not available for legacy reimbursements. */
  date?: Maybe<Scalars['String']['output']>;
  departure?: Maybe<MileageAddress>;
  /** Trip distance in meters */
  distanceMeters?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** Merchant name for receipt items. `null` for legacy reimbursements. */
  merchantName?: Maybe<Scalars['String']['output']>;
  mileageCalculation?: Maybe<MileageCalculation>;
  multiVat: Array<ExpenseItemMultiVat>;
  note: Scalars['String']['output'];
  /** Whether the trip was a round trip */
  roundTrip?: Maybe<Scalars['Boolean']['output']>;
  totalVatAmount: Amount;
  /** Type of the expense item (`receipt` or `mileage`) */
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vatAmount?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
  /** Vehicle used for the trip */
  vehicle?: Maybe<Vehicle>;
};

export type ExpenseItemMultiVat = {
  __typename?: 'ExpenseItemMultiVat';
  amount?: Maybe<Amount>;
  amountExcludingVat?: Maybe<Amount>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type ExpenseReport = {
  __typename?: 'ExpenseReport';
  /** Total amount of the expense report */
  amount: Amount;
  createdAt: Scalars['String']['output'];
  /** Feedback from the approver if changes were requested */
  feedback?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the expense report */
  id: Scalars['ID']['output'];
  /** ID of the membership who created the expense report */
  initiatorID: Scalars['String']['output'];
  /** List of expense report items */
  items: Array<ExpenseItem>;
  /** Current status of the expense report (`draft`, `changes_requested`, `submitted`) */
  status: Scalars['String']['output'];
  /** Expense report title */
  title: Scalars['String']['output'];
  totalVatAmount: Amount;
  updatedAt: Scalars['String']['output'];
};

export type F24Payment = {
  __typename?: 'F24Payment';
  bankAccountId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  proxied: Scalars['Boolean']['output'];
};

export type Fee = {
  __typename?: 'Fee';
  /** Base amount of the fees (all fee items summed up) */
  amount: Amount;
  /** Comment Customer Support wrote on the fee. Currently not exposed by BE. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Datetime in ISO 8601 */
  createdAt: Scalars['String']['output'];
  /** A superset of `feeType`; includes more specific domain fee types */
  eventType: Scalars['String']['output'];
  /** Translated, human readable variant of what this fee is */
  feeLabel: Scalars['String']['output'];
  /** Sums provided for a single fee's fee payments */
  feePaymentSums: FeePaymentSums;
  feeStatus: FeeStatus;
  feeType: FeeType;
  id: Scalars['ID']['output'];
  /** Base amount of the fee with discounts applied */
  totalAmount: Amount;
  /** Total amount of fee with discounts applied, including VAT */
  totalAmountVatIncluded: Amount;
  /** Datetime in ISO 8601 */
  updatedAt: Scalars['String']['output'];
  /** VAT amount of the fee, based on the totalAmount */
  vatAmount: Amount;
  /** The fees VAT, where e.g. 20% VAT is represented as 20.0 in this field. 0.0 is a valid value. */
  vatRate: Scalars['Float']['output'];
};

export type FeePaymentSums = {
  __typename?: 'FeePaymentSums';
  /** Amount that was forgiven (without VAT) */
  cancelledAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  cancelledAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was forgiven (with VAT) */
  cancelledAmountVatIncluded: Amount;
  /** Amount that was forgiven (VAT only) */
  cancelledVatAmount: Amount;
  /** Amount that was already paid (without VAT) */
  completedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  completedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was already paid (with VAT) */
  completedAmountVatIncluded: Amount;
  /** Amount that was already paid (VAT only) */
  completedVatAmount: Amount;
  /** Total amount the customer has paid or will pay (without VAT) */
  expectedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  expectedAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount the customer has paid or will pay (with VAT) */
  expectedAmountVatIncluded: Amount;
  /** Total amount the customer has paid or will pay (VAT only) */
  expectedVatAmount: Amount;
  /** Amount we are currently collecting (without VAT, transitional state) */
  orderedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transitional state) */
  orderedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we are currently collecting (with VAT, transitional state) */
  orderedAmountVatIncluded: Amount;
  /** Amount we are currently collecting (VAT only, transitional state) */
  orderedVatAmount: Amount;
  /** Amount we will attempt to collect soon (without VAT, transitional state) */
  pendingAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transition state) */
  pendingAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we will attempt to collect soon (with VAT, transitional state) */
  pendingAmountVatIncluded: Amount;
  /** Amount we will attempt to collect soon (VAT only, transitional state) */
  pendingVatAmount: Amount;
  /** Total amount that we still expect to collect (without VAT) */
  unsettledAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  unsettledAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount that we still expect to collect (with VAT) */
  unsettledAmountVatIncluded: Amount;
  /** Total amount that we still expect to collect (VAT only) */
  unsettledVatAmount: Amount;
  /** Amount that we are waiting to collect (without VAT; use unsettledAmount for user presentation to avoid race conditions) */
  waitingFundsAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transitional state) */
  waitingFundsAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that we are waiting to collect (with VAT; use unsettledAmountVatIncluded for user presentation to avoid race conditions) */
  waitingFundsAmountVatIncluded: Amount;
  /** Amount that we are waiting to collect (VAT only; use unsettledVatAmount for user presentation to avoid race conditions) */
  waitingFundsVatAmount: Amount;
};

export enum FeeStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CompletedOffered = 'COMPLETED_OFFERED',
  Pending = 'PENDING',
  WaitingFunds = 'WAITING_FUNDS'
}

export enum FeeType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  AccountClosed = 'ACCOUNT_CLOSED',
  AdditionalUser = 'ADDITIONAL_USER',
  AdvertisingCard = 'ADVERTISING_CARD',
  Atm = 'ATM',
  AtmPlus = 'ATM_PLUS',
  CapitalIncrease = 'CAPITAL_INCREASE',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashFlowManagement = 'CASH_FLOW_MANAGEMENT',
  Cheque = 'CHEQUE',
  ConfirmationLetter = 'CONFIRMATION_LETTER',
  DepositInterest = 'DEPOSIT_INTEREST',
  DirectDebitCollectionActivation = 'DIRECT_DEBIT_COLLECTION_ACTIVATION',
  DirectDebitCollectionRefund = 'DIRECT_DEBIT_COLLECTION_REFUND',
  DirectDebitCollectionRefundLate = 'DIRECT_DEBIT_COLLECTION_REFUND_LATE',
  DirectDebitCollectionReturn = 'DIRECT_DEBIT_COLLECTION_RETURN',
  DirectDebitCollectionSend = 'DIRECT_DEBIT_COLLECTION_SEND',
  EckertLaw = 'ECKERT_LAW',
  ExpenseSpendManagement = 'EXPENSE_SPEND_MANAGEMENT',
  FlashCard = 'FLASH_CARD',
  Fraud = 'FRAUD',
  FxCard = 'FX_CARD',
  FxCardPlus = 'FX_CARD_PLUS',
  FxInboundTransfer = 'FX_INBOUND_TRANSFER',
  FxOutboundTransfer = 'FX_OUTBOUND_TRANSFER',
  FxOutboundTransferEurSwiftOur = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_OUR',
  FxOutboundTransferEurSwiftSha = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_SHA',
  FxOutboundTransferLocalNonStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY',
  FxOutboundTransferLocalNonStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalNonStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalNonStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalNonStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferLocalStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY',
  FxOutboundTransferLocalStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftOur = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR',
  FxOutboundTransferOnlyVariableSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftSha = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA',
  FxOutboundTransferOnlyVariableSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_50',
  FxOutboundTransferSwiftOur = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR',
  FxOutboundTransferSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferSwiftSha = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA',
  FxOutboundTransferSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_50',
  FxRefund = 'FX_REFUND',
  GenericFee = 'GENERIC_FEE',
  JudicialRequisition = 'JUDICIAL_REQUISITION',
  Other = 'OTHER',
  Pagopa = 'PAGOPA',
  PhysicalCard = 'PHYSICAL_CARD',
  PhysicalCardDelivery = 'PHYSICAL_CARD_DELIVERY',
  PhysicalCardMetal = 'PHYSICAL_CARD_METAL',
  PhysicalCardPlus = 'PHYSICAL_CARD_PLUS',
  RejectedDebit = 'REJECTED_DEBIT',
  RejectedFxTransfer = 'REJECTED_FX_TRANSFER',
  RejectedTransfer = 'REJECTED_TRANSFER',
  ReturnedCheque = 'RETURNED_CHEQUE',
  Satd = 'SATD',
  SciNumberObtention = 'SCI_NUMBER_OBTENTION',
  SeizureForeclosure = 'SEIZURE_FORECLOSURE',
  SepaInboundTransfer = 'SEPA_INBOUND_TRANSFER',
  SepaOutboundTransfer = 'SEPA_OUTBOUND_TRANSFER',
  Shortfall = 'SHORTFALL',
  Subscription = 'SUBSCRIPTION',
  SwiftIncome = 'SWIFT_INCOME',
  SwiftIncomeFree = 'SWIFT_INCOME_FREE',
  ThirdPartyNotice = 'THIRD_PARTY_NOTICE',
  UnpaidCheque = 'UNPAID_CHEQUE',
  VirtualCard = 'VIRTUAL_CARD'
}

export type File = {
  __typename?: 'File';
  fileUrl: Scalars['String']['output'];
};

export type Filter = {
  operator: Scalars['String']['input'];
  property: Scalars['String']['input'];
  values: Array<Scalars['Any']['input']>;
};

export type FilterGroup = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterOrGroupOneFilters>>;
};

export type FilterGroupOne = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupOrExpressionOne>>;
};

export type FilterGroupOrExpressionOne = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupOrExpressionTwo>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type FilterGroupOrExpressionTwo = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupThree>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type FilterGroupThree = {
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['Any']['input']>;
};

export type FilterOrGroupOneFilters = {
  filter?: InputMaybe<Filter>;
  group?: InputMaybe<GroupOneFilters>;
};

export type FilterOrGroupTwoFilters = {
  filter?: InputMaybe<Filter>;
  group?: InputMaybe<GroupTwoFilters>;
};

export type FinancialDetail = {
  __typename?: 'FinancialDetail';
  annualTurnover?: Maybe<Scalars['String']['output']>;
  estimatedAnnualTurnover?: Maybe<Scalars['String']['output']>;
  estimatedYearlyIncome?: Maybe<Scalars['String']['output']>;
  maxSinglePaymentAmount?: Maybe<Scalars['String']['output']>;
  yearlyTransactionVolume?: Maybe<Scalars['String']['output']>;
};

export type FinancingInstallment = {
  __typename?: 'FinancingInstallment';
  accumulatedFeesAmount: Amount;
  capitalAmount: Amount;
  createdAt: Scalars['String']['output'];
  currentInstallmentNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interestAmount: Amount;
  movementId: Scalars['ID']['output'];
  totalInstallmentsNumber: Scalars['Int']['output'];
};

export enum FixedAmountType {
  Amount = 'AMOUNT',
  LocalAmount = 'LOCAL_AMOUNT'
}

export enum FlexKybStatus {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Eligible = 'ELIGIBLE',
  Rejected = 'REJECTED',
  Reviewable = 'REVIEWABLE',
  Waiting = 'WAITING'
}

export enum Frequency {
  FrequencyAnnually = 'FREQUENCY_ANNUALLY',
  FrequencyBiannually = 'FREQUENCY_BIANNUALLY',
  FrequencyBiweekly = 'FREQUENCY_BIWEEKLY',
  FrequencyDaily = 'FREQUENCY_DAILY',
  FrequencyMonthly = 'FREQUENCY_MONTHLY',
  FrequencyQuarterly = 'FREQUENCY_QUARTERLY',
  FrequencyUnspecified = 'FREQUENCY_UNSPECIFIED',
  FrequencyWeekly = 'FREQUENCY_WEEKLY'
}

export type GroupOneFilters = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterOrGroupTwoFilters>>;
};

export type GroupThreeFilter = {
  filter?: InputMaybe<Filter>;
};

export type GroupTwoFilters = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<GroupThreeFilter>>;
};

export type Income = {
  __typename?: 'Income';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  bankAccountId: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  emitterBic: Scalars['String']['output'];
  emitterIban: Scalars['String']['output'];
  emitterIdentification: Scalars['String']['output'];
  emitterName: Scalars['String']['output'];
  enrichmentData?: Maybe<EnrichmentData>;
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  sequentialId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
};

export type InvoiceTax = {
  __typename?: 'InvoiceTax';
  taxAmountCents?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
};

export type JournalEntry = {
  __typename?: 'JournalEntry';
  id: Scalars['String']['output'];
  journalEntryLines: Array<JournalEntryLine>;
  label?: Maybe<Scalars['String']['output']>;
  qontoAttachmentId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JournalEntryLine = {
  __typename?: 'JournalEntryLine';
  accountingCodeId?: Maybe<Scalars['String']['output']>;
  amount: Amount;
  costCenterAllocations: Array<CostCenterAllocation>;
  id: Scalars['String']['output'];
  taxFinancialAccount?: Maybe<TaxFinancialAccount>;
  taxFinancialAccountId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum KycStatus {
  Accepted = 'ACCEPTED',
  KycNotApplicable = 'KYC_NOT_APPLICABLE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refused = 'REFUSED',
  Reviewable = 'REVIEWABLE',
  SubmissionError = 'SUBMISSION_ERROR',
  Submitted = 'SUBMITTED',
  WaitingDocument = 'WAITING_DOCUMENT'
}

export enum KybStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Refused = 'REFUSED'
}

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID']['output'];
  labelList: LabelList;
  listId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LabelList = {
  __typename?: 'LabelList';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type LegacyMembership = {
  __typename?: 'LegacyMembership';
  avatar: AvatarFile;
  avatarThumb: AvatarFile;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  role: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['String']['output'];
};

export type Logo = {
  __typename?: 'Logo';
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export type Membership = {
  __typename?: 'Membership';
  avatar?: Maybe<UserAvatar>;
  id: Scalars['ID']['output'];
  invitation?: Maybe<Invite>;
  kyc: MembershipKycStatus;
  organizationId: Scalars['String']['output'];
  person?: Maybe<Person>;
  role: MembershipRole;
  status: MembershipStatus;
  teamId?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MembershipKycStatus = {
  __typename?: 'MembershipKycStatus';
  kycStatus: KycStatus;
  membershipId: Scalars['String']['output'];
};

export enum MembershipRole {
  Accountant = 'ACCOUNTANT',
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  Owner = 'OWNER'
}

export enum MembershipStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED'
}

export type MembershipsSearch = {
  filterGroup?: InputMaybe<FilterGroup>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type Message = {
  __typename?: 'Message';
  author?: Maybe<Participant>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type MileageAddress = {
  __typename?: 'MileageAddress';
  formattedAddress: Scalars['String']['output'];
  googlePlaceId: Scalars['String']['output'];
};

export type MileageCalculation = {
  __typename?: 'MileageCalculation';
  /** Bonus amount for electric vehicles */
  ElectricBonusAmount?: Maybe<Amount>;
  /** Number of metrics driven in the current trip */
  distanceMeters: Scalars['Int']['output'];
  /** List of rates applied to the trip */
  rates: Array<MileageRate>;
  /** Number of metrics driven in a year's trip for the vehicle when item was created */
  yearlyDistanceMeters?: Maybe<Scalars['Int']['output']>;
};

export type MileageRate = {
  __typename?: 'MileageRate';
  distanceMeters: Scalars['Int']['output'];
  endMeters?: Maybe<Scalars['Int']['output']>;
  startMeters: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MyBankDetails = {
  __typename?: 'MyBankDetails';
  createdAt: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type MyBankDetailsResult = {
  __typename?: 'MyBankDetailsResult';
  /** Bank details of the current user */
  bankDetails?: Maybe<MyBankDetails>;
};

export type MyBankDetailsSearch = {
  _note?: InputMaybe<Scalars['String']['input']>;
};

export type NrcPayment = {
  __typename?: 'NrcPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  nrc: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
  taxDescription: Scalars['String']['output'];
};

export type OnboardingPartner = {
  __typename?: 'OnboardingPartner';
  code: Scalars['String']['output'];
  type: OnboardingPartnerType;
};

export enum OnboardingPartnerType {
  Accountant = 'ACCOUNTANT',
  BylawProvider = 'BYLAW_PROVIDER',
  ExistingCompanyProvider = 'EXISTING_COMPANY_PROVIDER',
  Shelf = 'SHELF'
}

export enum OperationMethod {
  Biller = 'BILLER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  Cashback = 'CASHBACK',
  Cheque = 'CHEQUE',
  Ddc = 'DDC',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  Investment = 'INVESTMENT',
  Other = 'OTHER',
  Overdraft = 'OVERDRAFT',
  PagopaPayment = 'PAGOPA_PAYMENT',
  PayLater = 'PAY_LATER',
  Remuneration = 'REMUNERATION',
  RibaPayment = 'RIBA_PAYMENT',
  Tax = 'TAX',
  Transfer = 'TRANSFER'
}

export enum OperationType {
  AccountRemuneration = 'ACCOUNT_REMUNERATION',
  Biller = 'BILLER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashbackAdjustment = 'CASHBACK_ADJUSTMENT',
  CashbackPayout = 'CASHBACK_PAYOUT',
  Cheque = 'CHEQUE',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitCollection = 'DIRECT_DEBIT_COLLECTION',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  ExternalFees = 'EXTERNAL_FEES',
  F24 = 'F24',
  FinancingInstallment = 'FINANCING_INSTALLMENT',
  Income = 'INCOME',
  Investment = 'INVESTMENT',
  NrcPayment = 'NRC_PAYMENT',
  Other = 'OTHER',
  PagopaPayment = 'PAGOPA_PAYMENT',
  PayLater = 'PAY_LATER',
  Recall = 'RECALL',
  RibaPayment = 'RIBA_PAYMENT',
  SwiftIncome = 'SWIFT_INCOME',
  Transfer = 'TRANSFER'
}

export type Organization = {
  __typename?: 'Organization';
  avatar: OrganizationAvatar;
  company: Company;
  createdAt: Scalars['DateTimeNanos']['output'];
  customer: Customer;
  features?: Maybe<OrganizationFeature>;
  id: Scalars['ID']['output'];
  kyb?: Maybe<OrganizationKyb>;
  name: Scalars['String']['output'];
  onboardingPartner?: Maybe<OnboardingPartner>;
  slug: Scalars['String']['output'];
  status: OrganizationStatus;
  suspensionReason?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAvatar = {
  __typename?: 'OrganizationAvatar';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  thumbUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrganizationFeature = {
  __typename?: 'OrganizationFeature';
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrganizationKyb = {
  __typename?: 'OrganizationKyb';
  associationTypeformFileFilledAt?: Maybe<Scalars['DateTimeNanos']['output']>;
  associationTypeformUrl?: Maybe<Scalars['String']['output']>;
  flexKybStatus?: Maybe<FlexKybStatus>;
  kybStatus: KybStatus;
  ongoingKycKybUpdateProcessId?: Maybe<Scalars['ID']['output']>;
  typeformUrl?: Maybe<Scalars['String']['output']>;
  unreferenced: Scalars['Boolean']['output'];
};

export enum OrganizationStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  KybWaiting = 'KYB_WAITING',
  Suspended = 'SUSPENDED'
}

export type OrganizationsSearch = {
  _note?: InputMaybe<Scalars['String']['input']>;
};

export type OverdraftInterestPayment = {
  __typename?: 'OverdraftInterestPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  periodEndDate: Scalars['String']['output'];
  periodStartDate: Scalars['String']['output'];
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PagopaPayment = {
  __typename?: 'PagopaPayment';
  amount: Amount;
  creditorName?: Maybe<Scalars['String']['output']>;
  fiscalCode?: Maybe<Scalars['String']['output']>;
  iuv?: Maybe<Scalars['String']['output']>;
  movementId: Scalars['ID']['output'];
  noticeNumber?: Maybe<Scalars['String']['output']>;
};

export type ParentCardSummary = {
  __typename?: 'ParentCardSummary';
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type Participant = {
  __typename?: 'Participant';
  id: Scalars['ID']['output'];
  lastReadAt?: Maybe<Scalars['String']['output']>;
  membership: LegacyMembership;
  membershipId: Scalars['ID']['output'];
};

export enum PaymentMode {
  DeferredDebit = 'DEFERRED_DEBIT',
  ImmediateDebit = 'IMMEDIATE_DEBIT',
  Unknown = 'UNKNOWN'
}

export type Person = {
  __typename?: 'Person';
  displayName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ProbativeAttachment = {
  __typename?: 'ProbativeAttachment';
  downloadUrl: Scalars['String']['output'];
  fileContentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum Purpose {
  Payroll = 'PAYROLL'
}

/** Enum for authentication methods (used by both OTP and MFA). */
export enum QontoAccountManagementUsersFirstpartyV2_AuthMethod {
  /** Unspecified authentication method. */
  AuthMethodUnspecified = 'AUTH_METHOD_UNSPECIFIED',
  /**
   * Authentication by app.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ByApp = 'by_app',
  /**
   * Authentication by SMS.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  BySms = 'by_sms'
}

/** Message for avatar/image objects. */
export type QontoAccountManagementUsersFirstpartyV2_Avatar = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_Avatar';
  /** The URL of the file. */
  fileUrl: Scalars['String']['output'];
};

/** Message for avatar/image objects. */
export type QontoAccountManagementUsersFirstpartyV2_AvatarInput = {
  /** The URL of the file. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for gender. */
export enum QontoAccountManagementUsersFirstpartyV2_Gender {
  /** Unspecified gender. */
  GenderUnspecified = 'GENDER_UNSPECIFIED',
  /**
   * Female gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Female = 'female',
  /**
   * Male gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Male = 'male',
  /**
   * Other gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Other = 'other'
}

/** Message for the user. */
export type QontoAccountManagementUsersFirstpartyV2_User = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_User';
  /** Avatar of the user. */
  avatar?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Avatar thumbnail of the user. */
  avatarThumb?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Birth city of the user. */
  birthCity?: Maybe<Scalars['String']['output']>;
  /** Birth country of the user. */
  birthCountry?: Maybe<Scalars['String']['output']>;
  /** Birth zipcode of the user. */
  birthZipcode?: Maybe<Scalars['String']['output']>;
  /** Birth date of the user (YYYY-MM-DD format). */
  birthdate?: Maybe<Scalars['String']['output']>;
  /** Whether the user can enroll trusted device using SMS OTP. */
  canEnrollTrustedDeviceUsingSmsOtp: Scalars['Boolean']['output'];
  /** Default avatar of the user. */
  defaultAvatar?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Default avatar thumbnail of the user. */
  defaultAvatarThumb?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Email address of the user. */
  email: Scalars['String']['output'];
  /** First name of the user. */
  firstName: Scalars['String']['output'];
  /** User flags containing additional boolean settings. */
  flags?: Maybe<QontoAccountManagementUsersFirstpartyV2_UserFlags>;
  /** Full name of the user. */
  fullName: Scalars['String']['output'];
  /** Futurae user identifier. */
  futuraeUserId?: Maybe<Scalars['String']['output']>;
  /** Gender of the user. */
  gender?: Maybe<QontoAccountManagementUsersFirstpartyV2_Gender>;
  /** Whether the user has a default avatar. */
  hasDefaultAvatar: Scalars['Boolean']['output'];
  /** Unique identifier for the user. */
  id: Scalars['String']['output'];
  /** Last name of the user. */
  lastName: Scalars['String']['output'];
  /** Locale preference of the user. */
  locale: Scalars['String']['output'];
  /** Whether MFA is enabled. */
  mfaEnabled: Scalars['Boolean']['output'];
  /** MFA method preference. */
  mfaMethod?: Maybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Whether the user has completed onboarding. */
  onboarded: Scalars['Boolean']['output'];
  /** Whether OTP is enabled. */
  otpEnabled: Scalars['Boolean']['output'];
  /** OTP method preference. */
  otpMethod?: Maybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Pending email change. */
  pendingEmail?: Maybe<Scalars['String']['output']>;
  /** Pending phone number change. */
  pendingPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Phone number of the user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the phone number is verified. */
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** Whether SCA is enabled. */
  scaEnabled: Scalars['Boolean']['output'];
  /** Whether SCA enrollment is available. */
  scaEnrollmentAvailable: Scalars['Boolean']['output'];
  /** Segment identifier for analytics. */
  segmentId: Scalars['String']['output'];
  /** Timezone of the user. */
  timezone: Scalars['String']['output'];
  /** Whether tougher SCA approach is enabled. */
  tougherScaApproachEnabled: Scalars['Boolean']['output'];
  /** Zendesk integration data. */
  zendesk?: Maybe<QontoAccountManagementUsersFirstpartyV2_Zendesk>;
};

/** Message for user flags. */
export type QontoAccountManagementUsersFirstpartyV2_UserFlags = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_UserFlags';
  /** Whether the user has a password set. */
  hasPassword: Scalars['Boolean']['output'];
};

/** Message for user flags. */
export type QontoAccountManagementUsersFirstpartyV2_UserFlagsInput = {
  /** Whether the user has a password set. */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Message for the user. */
export type QontoAccountManagementUsersFirstpartyV2_UserInput = {
  /** Avatar of the user. */
  avatar?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Avatar thumbnail of the user. */
  avatarThumb?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Birth city of the user. */
  birthCity?: InputMaybe<Scalars['String']['input']>;
  /** Birth country of the user. */
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** Birth zipcode of the user. */
  birthZipcode?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the user (YYYY-MM-DD format). */
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user can enroll trusted device using SMS OTP. */
  canEnrollTrustedDeviceUsingSmsOtp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default avatar of the user. */
  defaultAvatar?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Default avatar thumbnail of the user. */
  defaultAvatarThumb?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User flags containing additional boolean settings. */
  flags?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_UserFlagsInput>;
  /** Full name of the user. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Futurae user identifier. */
  futuraeUserId?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the user. */
  gender?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_Gender>;
  /** Whether the user has a default avatar. */
  hasDefaultAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the user. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Locale preference of the user. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whether MFA is enabled. */
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** MFA method preference. */
  mfaMethod?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Whether the user has completed onboarding. */
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether OTP is enabled. */
  otpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** OTP method preference. */
  otpMethod?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Pending email change. */
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  /** Pending phone number change. */
  pendingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the phone number is verified. */
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SCA is enabled. */
  scaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SCA enrollment is available. */
  scaEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Segment identifier for analytics. */
  segmentId?: InputMaybe<Scalars['String']['input']>;
  /** Timezone of the user. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Whether tougher SCA approach is enabled. */
  tougherScaApproachEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zendesk integration data. */
  zendesk?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_ZendeskInput>;
};

/** Message for Zendesk integration data. */
export type QontoAccountManagementUsersFirstpartyV2_Zendesk = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_Zendesk';
  /** JWT token for messaging widget. */
  messagingWidgetJwt: Scalars['String']['output'];
  /** JWT token for SSO. */
  ssoJwt: Scalars['String']['output'];
};

/** Message for Zendesk integration data. */
export type QontoAccountManagementUsersFirstpartyV2_ZendeskInput = {
  /** JWT token for messaging widget. */
  messagingWidgetJwt?: InputMaybe<Scalars['String']['input']>;
  /** JWT token for SSO. */
  ssoJwt?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single accounting account. */
export type QontoAccountingAccountsFirstpartyV2_Account = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_Account';
  /**
   * Category of the account.
   * -- For non auxiliary accounts, e.g. "Asset", "Liability", "Equity", "Revenue", "Expense"
   * -- For auxiliary accounts: "Revenue" for a customer account, "Expense" for a supplier/employee account
   */
  category: Scalars['String']['output'];
  /**
   * Code of the account.
   * -- For non auxiliary accounts, e.g.: "401000","411000","606100"
   * -- For auxiliary accounts, e.g.: "S-SupplierName", '401-SupplierName'
   */
  code: Scalars['String']['output'];
  /** Creation timestamp. */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the account. */
  id: Scalars['String']['output'];
  integrationStatus?: Maybe<QontoAccountingIntegrationsAccountsFirstpartyV1_Account>;
  /** Whether the account is auxiliary */
  isAuxiliary: Scalars['Boolean']['output'];
  /** Whether the account is postable -- FALSE for header/roll-up nodes */
  isPostable: Scalars['Boolean']['output'];
  /**
   * Label of the account.
   * -- For non auxiliary accounts, e.g.: "Suppliers","Clients","Unstocked Purchases"
   * -- For auxiliary accounts, e.g.: "Supplier/customer Name"
   */
  label: Scalars['String']['output'];
  /** Origin of the account. */
  source: QontoAccountingAccountsFirstpartyV2_AccountSource;
  /** Update timestamp. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
};

/** Represents a single accounting account. */
export type QontoAccountingAccountsFirstpartyV2_AccountInput = {
  /**
   * Category of the account.
   * -- For non auxiliary accounts, e.g. "Asset", "Liability", "Equity", "Revenue", "Expense"
   * -- For auxiliary accounts: "Revenue" for a customer account, "Expense" for a supplier/employee account
   */
  category?: InputMaybe<Scalars['String']['input']>;
  /**
   * Code of the account.
   * -- For non auxiliary accounts, e.g.: "401000","411000","606100"
   * -- For auxiliary accounts, e.g.: "S-SupplierName", '401-SupplierName'
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Creation timestamp. */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the account. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is auxiliary */
  isAuxiliary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the account is postable -- FALSE for header/roll-up nodes */
  isPostable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Label of the account.
   * -- For non auxiliary accounts, e.g.: "Suppliers","Clients","Unstocked Purchases"
   * -- For auxiliary accounts, e.g.: "Supplier/customer Name"
   */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the account. */
  source?: InputMaybe<QontoAccountingAccountsFirstpartyV2_AccountSource>;
  /** Update timestamp. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
};

/** Indicates the origin of an account. */
export enum QontoAccountingAccountsFirstpartyV2_AccountSource {
  /** Account created via automatic provisioning. */
  AccountSourceProvisioning = 'ACCOUNT_SOURCE_PROVISIONING',
  /** Account created from a default template. */
  AccountSourceTemplate = 'ACCOUNT_SOURCE_TEMPLATE',
  /** No source specified or unknown. */
  AccountSourceUnspecified = 'ACCOUNT_SOURCE_UNSPECIFIED',
  /** Account created manually by the user. */
  AccountSourceUser = 'ACCOUNT_SOURCE_USER'
}

/**
 * Request to list accounts for the given active accounting period with filter 'is_auxiliary' and pagination.
 * Organization ID is extracted from PASETO of the authenticated user.
 * If there is no active accounting period, returns an empty list.
 */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsRequest = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_ListAccountsRequest';
  /** Filter by category. Is string format since is coming from query params. */
  category?: Maybe<Scalars['String']['output']>;
  /** Filter by given account ids. */
  ids?: Maybe<Scalars['String']['output']>;
  /** Whether the account is auxiliary. */
  isAuxiliary?: Maybe<Scalars['String']['output']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Search query for code or label (case and accent insensitive, min 2 chars). */
  search?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to list accounts for the given active accounting period with filter 'is_auxiliary' and pagination.
 * Organization ID is extracted from PASETO of the authenticated user.
 * If there is no active accounting period, returns an empty list.
 */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsRequestInput = {
  /** Filter by category. Is string format since is coming from query params. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Filter by given account ids. */
  ids?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is auxiliary. */
  isAuxiliary?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Search query for code or label (case and accent insensitive, min 2 chars). */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a list of accounts and pagination metadata. */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsResponse = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_ListAccountsResponse';
  /** List of accounting accounts matching the request criteria. */
  accounts: Array<QontoAccountingAccountsFirstpartyV2_Account>;
  /** Pagination metadata. */
  meta?: Maybe<QontoAccountingAccountsFirstpartyV2_Meta>;
};

/** Response containing a list of accounts and pagination metadata. */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsResponseInput = {
  /** List of accounting accounts matching the request criteria. */
  accounts?: InputMaybe<Array<QontoAccountingAccountsFirstpartyV2_AccountInput>>;
  /** Pagination metadata. */
  meta?: InputMaybe<QontoAccountingAccountsFirstpartyV2_MetaInput>;
};

/** Metadata for pagination. */
export type QontoAccountingAccountsFirstpartyV2_Meta = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_Meta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number (null if last page). */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of records per page. */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if first page). */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of records matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Metadata for pagination. */
export type QontoAccountingAccountsFirstpartyV2_MetaInput = {
  /** Current page number. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Next page number (null if last page). */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if first page). */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of records matching the filters. */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages. */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Minimal Account information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_Account = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Account';
  /** Account category (e.g., "asset", "liability", "equity", "revenue", "expense"). */
  category: Scalars['String']['output'];
  /** Account code (e.g., "411FOO", "401BAR"). */
  code: Scalars['String']['output'];
  /** Timestamp when this account was created. */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the account (UUID). */
  id: Scalars['String']['output'];
  /** Indicates if this is an auxiliary account. TRUE when third_party is required (e.g., AR/AP) */
  isAuxiliary: Scalars['Boolean']['output'];
  /** Indicates if this account was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if this account can be used for posting entries. DEFAULT TRUE, FALSE for header/roll-up nodes */
  isPostable: Scalars['Boolean']['output'];
  /** Account label/name (e.g., "FOO SARL", "BAR SAS"). */
  label: Scalars['String']['output'];
  /** Timestamp when this account was last updated. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
};

/**
 * Minimal Account information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_AccountInput = {
  /** Account category (e.g., "asset", "liability", "equity", "revenue", "expense"). */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Account code (e.g., "411FOO", "401BAR"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this account was created. */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the account (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this is an auxiliary account. TRUE when third_party is required (e.g., AR/AP) */
  isAuxiliary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this account was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this account can be used for posting entries. DEFAULT TRUE, FALSE for header/roll-up nodes */
  isPostable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account label/name (e.g., "FOO SARL", "BAR SAS"). */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this account was last updated. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
};

/** State of a ledger entry in its lifecycle. */
export enum QontoAccountingEntriesFirstpartyV2_EntryStatus {
  /** Draft status. */
  EntryStatusDraft = 'ENTRY_STATUS_DRAFT',
  /** Exported status. */
  EntryStatusExported = 'ENTRY_STATUS_EXPORTED',
  /** Exporting status. */
  EntryStatusExporting = 'ENTRY_STATUS_EXPORTING',
  /** Rejected status - the export was attempted but failed. */
  EntryStatusRejected = 'ENTRY_STATUS_REJECTED',
  /** Unspecified status. */
  EntryStatusUnspecified = 'ENTRY_STATUS_UNSPECIFIED',
  /** Validated status. TODO - MVP transition - This status will be removed in the future (once the contract is fully implemented). */
  EntryStatusValidated = 'ENTRY_STATUS_VALIDATED',
  /** Verified status - replacing VALIDATED status. */
  EntryStatusVerified = 'ENTRY_STATUS_VERIFIED'
}

/** Custom errors for the GetEntries endpoint. */
export enum QontoAccountingEntriesFirstpartyV2_GetEntriesError {
  /** Invalid pagination parameters (page < 1 or per_page > 100). */
  GetEntriesErrorInvalidPagination = 'GET_ENTRIES_ERROR_INVALID_PAGINATION',
  /** invalid status filter. */
  GetEntriesErrorInvalidStatusFilter = 'GET_ENTRIES_ERROR_INVALID_STATUS_FILTER',
  /** The user does not have permission to view entries for this organization. */
  GetEntriesErrorPermissionDenied = 'GET_ENTRIES_ERROR_PERMISSION_DENIED',
  /** Unspecified error. */
  GetEntriesErrorUnspecified = 'GET_ENTRIES_ERROR_UNSPECIFIED'
}

/**
 * Request to retrieve ledger entries with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesRequest = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesRequest';
  /** Filter by given account ids. */
  accountIds?: Maybe<Scalars['String']['output']>;
  /** Filter by given journal ids. */
  journalIds?: Maybe<Scalars['String']['output']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Filter by record date range start (YYYY-MM-DD). Inclusive. */
  recordDateFrom?: Maybe<Scalars['String']['output']>;
  /** Filter by record date range end (YYYY-MM-DD). Inclusive. */
  recordDateTo?: Maybe<Scalars['String']['output']>;
  /** Sorting option for the entries. */
  sortBy?: Maybe<QontoAccountingEntriesFirstpartyV2_SortBy>;
  /** Filter by entries status. */
  status?: Maybe<QontoAccountingEntriesFirstpartyV2_StatusFilter>;
  /** Comma separated statuses to filter from */
  statuses?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to retrieve ledger entries with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput = {
  /** Filter by given account ids. */
  accountIds?: InputMaybe<Scalars['String']['input']>;
  /** Filter by given journal ids. */
  journalIds?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by record date range start (YYYY-MM-DD). Inclusive. */
  recordDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by record date range end (YYYY-MM-DD). Inclusive. */
  recordDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Sorting option for the entries. */
  sortBy?: InputMaybe<QontoAccountingEntriesFirstpartyV2_SortBy>;
  /** Filter by entries status. */
  status?: InputMaybe<QontoAccountingEntriesFirstpartyV2_StatusFilter>;
  /** Comma separated statuses to filter from */
  statuses?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response containing ledger entries with enriched data.
 * All entries include embedded Account and Journal objects.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesResponse = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesResponse';
  /**
   * List of ledger entries with enriched data.
   * Each entry includes:
   * - Embedded Journal object (id, code, name, type)
   * - Embedded Account objects in all lines (id, code, label, category)
   */
  entries: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched>;
  /** Pagination metadata. */
  meta?: Maybe<QontoAccountingEntriesFirstpartyV2_Meta>;
};

/**
 * Response containing ledger entries with enriched data.
 * All entries include embedded Account and Journal objects.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesResponseInput = {
  /**
   * List of ledger entries with enriched data.
   * Each entry includes:
   * - Embedded Journal object (id, code, name, type)
   * - Embedded Account objects in all lines (id, code, label, category)
   */
  entries?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryEnrichedInput>>;
  /** Pagination metadata. */
  meta?: InputMaybe<QontoAccountingEntriesFirstpartyV2_MetaInput>;
};

/**
 * Minimal Journal information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_Journal = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Journal';
  /** Journal code (e.g., "VE", "AC"). */
  code: Scalars['String']['output'];
  /** Timestamp when this journal was created. */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the Journal (UUID). */
  id: Scalars['String']['output'];
  /** Indicates if this journal was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Journal name (e.g., "Ventes"). */
  name: Scalars['String']['output'];
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type: Scalars['String']['output'];
  /** Timestamp when this journal was last updated. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
};

/**
 * Minimal Journal information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_JournalInput = {
  /** Journal code (e.g., "VE", "AC"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was created. */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the Journal (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this journal was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Journal name (e.g., "Ventes"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was last updated. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
};

/**
 * Enriched ledger entry with embedded Journal and Account objects.
 * Used in responses for new endpoints that provide GraphQL-ready data.
 * Facilitates frontend consumption and future GraphQL migration.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched';
  /**
   * Accounting date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by record_date.
   */
  accountingDate: Scalars['String']['output'];
  /** Accounting gross amount (total including tax) in accounting currency. */
  accountingIncludingTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Accounting period this entry belongs to (e.g., "2025 Fiscal Year").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  accountingPeriodId: Scalars['String']['output'];
  /** Total VAT amount in accounting currency. */
  accountingTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: Attachment (PDF/image) linked to this entry.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Counter party name, either third party name or bank account name. */
  counterPartyName: Scalars['String']['output'];
  /** Timestamp when this entry was created. */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Accounts shown in the UI "Account" column for this entry.
   * Derived from non-deleted entry lines (lines[].account), filtered by journal type and account category:
   * - journal.type = "cash_bank": asset/liability/equity
   * - otherwise: expense/revenue
   */
  displayedAccounts: Array<QontoAccountingEntriesFirstpartyV2_Account>;
  /**
   * Optional: Document currency (ISO 4217). Example: "EUR".
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentCurrency?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Date on the original document.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDate?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Due date from the original document (for AR/AP tracking).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDueDate?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Document gross amount (total including tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by document_including_tax_amount.
   */
  documentGrossAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Including tax amount (total including tax) - signed amount. */
  documentIncludingTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: Document net amount (total excluding tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNetAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: Document reference number (e.g., invoice number "INV-2025-042").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Total VAT amount for this entry (sum of all tax amounts from lines).
   * Required for UI display and export (e.g., FEC, IDEA).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Type of document this entry is based on (e.g., "invoice", "receipt"). */
  documentType: Scalars['String']['output'];
  /**
   * Entry title shown in the UI, derived from counter_party_name or transaction_title of bank operation.
   * TODO: remove nullability in the Post-QA phase of https://www.notion.so/qonto/VE-Entries-detail-view-iteration-31e31ee4c6968023a4b6dac0c3012e84?source=copy_link
   */
  entryTitle?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the ledger entry (UUID). */
  id: Scalars['String']['output'];
  integrationStatus?: Maybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry>;
  /**
   * Internal reference within the period (e.g., "2025-001", "2025-002").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  internalReference?: Maybe<Scalars['String']['output']>;
  /**
   * Journal this entry belongs to.
   * Embedded journal object with code, name, type, etc.
   */
  journal?: Maybe<QontoAccountingEntriesFirstpartyV2_Journal>;
  /**
   * All accounting lines (postings) with embedded account details.
   * In double-entry bookkeeping: sum(debit lines) = sum(credit lines).
   */
  lines: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched>;
  /** Organization that owns this entry. */
  organizationId: Scalars['String']['output'];
  /**
   * Validation/booking date (FEC ValidDate). Must be filled when state='completed' (DB check below).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  postingDate?: Maybe<Scalars['String']['output']>;
  /**
   * Record date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  recordDate: Scalars['String']['output'];
  /**
   * Reference content based on entry type, generated in the following way:
   *  - Bank entries == Transaction title + Operation date + Total amount in original Currency
   *  - Sales entry == Client name + Invoice date + Total amount in original Currency
   *  - Purchase entry == Supplier name + Invoice date + Total amount in original Currency
   *  - Expense entry == Expense title + Request date + Total amount in original Currency
   * Can be modified by the user.
   */
  reference?: Maybe<Scalars['String']['output']>;
  /**
   * Current status of the entry (draft, validated, verified, exporting, exported).
   * Reuses EntryStatus enum from ledger_entry.proto
   * TODO - MVP transition - the ENUM status will be updated to remove the validated status - replaced by verified status.
   */
  status: QontoAccountingEntriesFirstpartyV2_EntryStatus;
  /** Timestamp when this entry was last updated. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Optional: Timestamp when completion occurred.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Optional: Who completed (user/email/system).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedBy?: Maybe<Scalars['String']['output']>;
};

/**
 * Enriched ledger entry with embedded Journal and Account objects.
 * Used in responses for new endpoints that provide GraphQL-ready data.
 * Facilitates frontend consumption and future GraphQL migration.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryEnrichedInput = {
  /**
   * Accounting date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by record_date.
   */
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  /** Accounting gross amount (total including tax) in accounting currency. */
  accountingIncludingTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Accounting period this entry belongs to (e.g., "2025 Fiscal Year").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  accountingPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Total VAT amount in accounting currency. */
  accountingTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: Attachment (PDF/image) linked to this entry.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  /** Counter party name, either third party name or bank account name. */
  counterPartyName?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this entry was created. */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Accounts shown in the UI "Account" column for this entry.
   * Derived from non-deleted entry lines (lines[].account), filtered by journal type and account category:
   * - journal.type = "cash_bank": asset/liability/equity
   * - otherwise: expense/revenue
   */
  displayedAccounts?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_AccountInput>>;
  /**
   * Optional: Document currency (ISO 4217). Example: "EUR".
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentCurrency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Date on the original document.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Due date from the original document (for AR/AP tracking).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDueDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Document gross amount (total including tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by document_including_tax_amount.
   */
  documentGrossAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Including tax amount (total including tax) - signed amount. */
  documentIncludingTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: Document net amount (total excluding tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNetAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: Document reference number (e.g., invoice number "INV-2025-042").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Total VAT amount for this entry (sum of all tax amounts from lines).
   * Required for UI display and export (e.g., FEC, IDEA).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Type of document this entry is based on (e.g., "invoice", "receipt"). */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Entry title shown in the UI, derived from counter_party_name or transaction_title of bank operation.
   * TODO: remove nullability in the Post-QA phase of https://www.notion.so/qonto/VE-Entries-detail-view-iteration-31e31ee4c6968023a4b6dac0c3012e84?source=copy_link
   */
  entryTitle?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the ledger entry (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Internal reference within the period (e.g., "2025-001", "2025-002").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  internalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Journal this entry belongs to.
   * Embedded journal object with code, name, type, etc.
   */
  journal?: InputMaybe<QontoAccountingEntriesFirstpartyV2_JournalInput>;
  /**
   * All accounting lines (postings) with embedded account details.
   * In double-entry bookkeeping: sum(debit lines) = sum(credit lines).
   */
  lines?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnrichedInput>>;
  /** Organization that owns this entry. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Validation/booking date (FEC ValidDate). Must be filled when state='completed' (DB check below).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  postingDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Record date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  recordDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference content based on entry type, generated in the following way:
   *  - Bank entries == Transaction title + Operation date + Total amount in original Currency
   *  - Sales entry == Client name + Invoice date + Total amount in original Currency
   *  - Purchase entry == Supplier name + Invoice date + Total amount in original Currency
   *  - Expense entry == Expense title + Request date + Total amount in original Currency
   * Can be modified by the user.
   */
  reference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Current status of the entry (draft, validated, verified, exporting, exported).
   * Reuses EntryStatus enum from ledger_entry.proto
   * TODO - MVP transition - the ENUM status will be updated to remove the validated status - replaced by verified status.
   */
  status?: InputMaybe<QontoAccountingEntriesFirstpartyV2_EntryStatus>;
  /** Timestamp when this entry was last updated. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Optional: Timestamp when completion occurred.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Optional: Who completed (user/email/system).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Enriched ledger entry line with embedded Account objects.
 * Used in responses to provide immediate account details without additional fetches.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched';
  /**
   * Account this line posts to (charge account from chart of accounts).
   * Optional in response to cover cases where account cannot be assigned.
   * Embedded account object with code, label, category, etc.
   */
  account?: Maybe<QontoAccountingEntriesFirstpartyV2_Account>;
  /**
   * Amount for this line.
   * Positive = Debit, Negative = Credit.
   * TODO - MVP transition - Update comments - this field won't be signed anymore (will use the new way fields instead).
   */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Auxiliary account (subledger account, e.g., for AR/AP tracking).
   * Optional in response as some lines may not have an auxiliary account.
   * Embedded account object with code, label, category, etc.
   */
  auxiliaryAccount?: Maybe<QontoAccountingEntriesFirstpartyV2_Account>;
  /** Unique identifier for the line (UUID). */
  id: Scalars['String']['output'];
  /**
   * Optional: Line label (used as FEC EcritureLib when present). Example: "Translations French to Italian"
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Signed amount: debit > 0, credit < 0. Examples: +3500.00 (debit expense), -4025.00 (credit AP)
   * TODO - MVP transition - Update comments - this field won't be signed anymore (will use the new way fields instead).
   */
  taxBaseAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: VAT/withholding/other tax code for this line (nullable)
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  taxCodeId?: Maybe<Scalars['String']['output']>;
  /** Used to determine the tax rate percent for the line - only for tax lines. */
  taxRatePercent?: Maybe<Scalars['String']['output']>;
  /** Used to determine the way of the line (D - for debit or C - for credit). */
  way: Scalars['String']['output'];
};

/**
 * Enriched ledger entry line with embedded Account objects.
 * Used in responses to provide immediate account details without additional fetches.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnrichedInput = {
  /**
   * Account this line posts to (charge account from chart of accounts).
   * Optional in response to cover cases where account cannot be assigned.
   * Embedded account object with code, label, category, etc.
   */
  account?: InputMaybe<QontoAccountingEntriesFirstpartyV2_AccountInput>;
  /**
   * Amount for this line.
   * Positive = Debit, Negative = Credit.
   * TODO - MVP transition - Update comments - this field won't be signed anymore (will use the new way fields instead).
   */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Auxiliary account (subledger account, e.g., for AR/AP tracking).
   * Optional in response as some lines may not have an auxiliary account.
   * Embedded account object with code, label, category, etc.
   */
  auxiliaryAccount?: InputMaybe<QontoAccountingEntriesFirstpartyV2_AccountInput>;
  /** Unique identifier for the line (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Line label (used as FEC EcritureLib when present). Example: "Translations French to Italian"
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Signed amount: debit > 0, credit < 0. Examples: +3500.00 (debit expense), -4025.00 (credit AP)
   * TODO - MVP transition - Update comments - this field won't be signed anymore (will use the new way fields instead).
   */
  taxBaseAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: VAT/withholding/other tax code for this line (nullable)
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  taxCodeId?: InputMaybe<Scalars['String']['input']>;
  /** Used to determine the tax rate percent for the line - only for tax lines. */
  taxRatePercent?: InputMaybe<Scalars['String']['input']>;
  /** Used to determine the way of the line (D - for debit or C - for credit). */
  way?: InputMaybe<Scalars['String']['input']>;
};

/** Metadata for pagination. */
export type QontoAccountingEntriesFirstpartyV2_Meta = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Meta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number (null if last page). */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of records per page. */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if first page). */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of records matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Metadata for pagination. */
export type QontoAccountingEntriesFirstpartyV2_MetaInput = {
  /** Current page number. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Next page number (null if last page). */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if first page). */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of records matching the filters. */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages. */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/** SortBy enum - describes the sort order of the ledger entries. */
export enum QontoAccountingEntriesFirstpartyV2_SortBy {
  /** sort entries by account_code:asc */
  SortByAccountCodeAsc = 'SORT_BY_ACCOUNT_CODE_ASC',
  /** sort entries by account_code:desc */
  SortByAccountCodeDesc = 'SORT_BY_ACCOUNT_CODE_DESC',
  /** sort entries by journal_code:asc */
  SortByJournalCodeAsc = 'SORT_BY_JOURNAL_CODE_ASC',
  /** sort entries by journal_code:desc */
  SortByJournalCodeDesc = 'SORT_BY_JOURNAL_CODE_DESC',
  /** sort entries by record_date:asc */
  SortByRecordDateAsc = 'SORT_BY_RECORD_DATE_ASC',
  /** sort entries by record_date:desc */
  SortByRecordDateDesc = 'SORT_BY_RECORD_DATE_DESC',
  /** default */
  SortByUnspecified = 'SORT_BY_UNSPECIFIED'
}

/** Filter metadata. */
export enum QontoAccountingEntriesFirstpartyV2_StatusFilter {
  /** Filter by draft entries. */
  StatusFilterDraft = 'STATUS_FILTER_DRAFT',
  /** Filter by exported entries. */
  StatusFilterExported = 'STATUS_FILTER_EXPORTED',
  /** Filter by exporting entries. */
  StatusFilterExporting = 'STATUS_FILTER_EXPORTING',
  /** Filter by rejected entries. */
  StatusFilterRejected = 'STATUS_FILTER_REJECTED',
  /** Default - no filter applied. */
  StatusFilterUnspecified = 'STATUS_FILTER_UNSPECIFIED',
  /** Filter by verified entries (Exporting entries are considered as verified) */
  StatusFilterVerified = 'STATUS_FILTER_VERIFIED'
}

/** Account representing a synchronized accounting account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_Account = {
  __typename?: 'QontoAccountingIntegrationsAccountsFirstpartyV1_Account';
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Account identifier */
  id: Scalars['String']['output'];
  /** Account number (e.g., "401000", "512000") */
  number: Scalars['String']['output'];
  /** Rejection log message */
  rejectionLog?: Maybe<Scalars['String']['output']>;
  /** Rejection type identifier */
  rejectionType?: Maybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType>;
  /** Current state of the account */
  state: QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState;
};

/** Account representing a synchronized accounting account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountInput = {
  /** Creation timestamp */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Account identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Account number (e.g., "401000", "512000") */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Rejection log message */
  rejectionLog?: InputMaybe<Scalars['String']['input']>;
  /** Rejection type identifier */
  rejectionType?: InputMaybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionTypeInput>;
  /** Current state of the account */
  state?: InputMaybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState>;
};

/** Rejection information for the account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType = {
  __typename?: 'QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType';
  /** Howtofix indication to handle the rejection */
  howToFix?: Maybe<Scalars['String']['output']>;
  /** Description of the rejection */
  label: Scalars['String']['output'];
};

/** Rejection information for the account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionTypeInput = {
  /** Howtofix indication to handle the rejection */
  howToFix?: InputMaybe<Scalars['String']['input']>;
  /** Description of the rejection */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** State for the Account */
export enum QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState {
  /** Account was processed successfully */
  AccountStateProcessed = 'ACCOUNT_STATE_PROCESSED',
  /** Account is being processed by the accounting software */
  AccountStateProcessing = 'ACCOUNT_STATE_PROCESSING',
  /** Account was rejected */
  AccountStateRejected = 'ACCOUNT_STATE_REJECTED',
  /** Account will soon be processed */
  AccountStateToSync = 'ACCOUNT_STATE_TO_SYNC',
  /** Not possible */
  AccountStateUnspecified = 'ACCOUNT_STATE_UNSPECIFIED'
}

/** Ledger entry representing a synchronization batch */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry = {
  __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry';
  /** ACK validation status (reconciled) */
  ackValidation: Scalars['Boolean']['output'];
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Ledger entry identifier */
  id: Scalars['String']['output'];
  /** Rejection log message */
  rejectionLog?: Maybe<Scalars['String']['output']>;
  /** Rejection type identifier */
  rejectionType?: Maybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType>;
  /** Current state of the batch */
  state: QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState;
};

/** Ledger entry representing a synchronization batch */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryInput = {
  /** ACK validation status (reconciled) */
  ackValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Creation timestamp */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Ledger entry identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Rejection log message */
  rejectionLog?: InputMaybe<Scalars['String']['input']>;
  /** Rejection type identifier */
  rejectionType?: InputMaybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionTypeInput>;
  /** Current state of the batch */
  state?: InputMaybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState>;
};

/** Rejection information for the ledger entry */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType = {
  __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType';
  /** Howtofix indication to handle the rejection */
  howToFix?: Maybe<Scalars['String']['output']>;
  /** Description of the rejection */
  label: Scalars['String']['output'];
};

/** Rejection information for the ledger entry */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionTypeInput = {
  /** Howtofix indication to handle the rejection */
  howToFix?: InputMaybe<Scalars['String']['input']>;
  /** Description of the rejection */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** State for the LedgerEntry */
export enum QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState {
  /** Ledger entry is pre-filetered */
  LedgerEntryStatePrefiltered = 'LEDGER_ENTRY_STATE_PREFILTERED',
  /** Ledger entry was processed successfully */
  LedgerEntryStateProcessed = 'LEDGER_ENTRY_STATE_PROCESSED',
  /** Ledger entry is being processed by the accouting software */
  LedgerEntryStateProcessing = 'LEDGER_ENTRY_STATE_PROCESSING',
  /** Ledger entry was rejected */
  LedgerEntryStateRejected = 'LEDGER_ENTRY_STATE_REJECTED',
  /** Ledger entry will soon be processed */
  LedgerEntryStateToSync = 'LEDGER_ENTRY_STATE_TO_SYNC',
  /** Not possible */
  LedgerEntryStateUnspecified = 'LEDGER_ENTRY_STATE_UNSPECIFIED'
}

/** Represents a journal entity. */
export type QontoAccountingJournalsFirstpartyV2_Journal = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_Journal';
  account?: Maybe<QontoAccountingAccountsFirstpartyV2_Account>;
  /** Optional: Account ID associated with this journal (for cash_bank journal type only). */
  accountId?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  /** Optional: Bank account ID associated with this journal (for cash_bank journal type only). */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** Journal code (e.g., "VE", "AC"). */
  code: Scalars['String']['output'];
  /** Timestamp when this journal was created. */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the Journal (UUID). */
  id: Scalars['String']['output'];
  /** Journal name (e.g., "Ventes"). */
  name: Scalars['String']['output'];
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type: Scalars['String']['output'];
  /** Timestamp when this journal was last updated. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
};

/** Represents a journal entity. */
export type QontoAccountingJournalsFirstpartyV2_JournalInput = {
  /** Optional: Account ID associated with this journal (for cash_bank journal type only). */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Bank account ID associated with this journal (for cash_bank journal type only). */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Journal code (e.g., "VE", "AC"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was created. */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the Journal (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Journal name (e.g., "Ventes"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was last updated. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
};

/**
 * Request to list journals for the given organization.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsRequest = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsRequest';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Request to list journals for the given organization.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response containing a list of journals for organization. */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsResponse = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsResponse';
  /** List of journals for organization. */
  journals: Array<QontoAccountingJournalsFirstpartyV2_Journal>;
};

/** Response containing a list of journals for organization. */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsResponseInput = {
  /** List of journals for organization. */
  journals?: InputMaybe<Array<QontoAccountingJournalsFirstpartyV2_JournalInput>>;
};

/** Custom application error codes for update journal */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalErrors = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_UpdateJournalErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes for update journal */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom application error codes for 409 HTTP errors. */
export enum QontoAccountingJournalsFirstpartyV2_UpdateJournalErrors_ConflictError {
  /** No or unknown application specific error code was given, fallback using the error's status field as guidance. */
  ConflictErrorUnspecified = 'CONFLICT_ERROR_UNSPECIFIED',
  /**
   * Journal code already exists for this organization
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  JournalCodeAlreadyExists = 'journal_code_already_exists',
  /**
   * Journal code already exists but is soft-deleted
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  JournalCodeAlreadyExistsDeleted = 'journal_code_already_exists_deleted'
}

/** Custom application error codes for 404 HTTP errors. */
export enum QontoAccountingJournalsFirstpartyV2_UpdateJournalErrors_NotFoundError {
  /** No or unknown application specific error code was given, fallback using the error's status field as guidance. */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED',
  /**
   * Journal not found
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  JournalNotFound = 'journal_not_found'
}

/** Request to update a journal. */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalRequest = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_UpdateJournalRequest';
  /** Account ID associated with this journal. */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Code of the journal. */
  code: Scalars['String']['output'];
  /** The journal ID to update (UUID). */
  journalId: Scalars['String']['output'];
  /** Name of the journal. */
  name: Scalars['String']['output'];
};

/** Request to update a journal. */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalRequestInput = {
  /** Account ID associated with this journal. */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Code of the journal. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The journal ID to update (UUID). */
  journalId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the journal. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Response when a journal is successfully updated. */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalResponse = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_UpdateJournalResponse';
  /** The updated journal. */
  journal?: Maybe<QontoAccountingJournalsFirstpartyV2_Journal>;
};

/** Response when a journal is successfully updated. */
export type QontoAccountingJournalsFirstpartyV2_UpdateJournalResponseInput = {
  /** The updated journal. */
  journal?: InputMaybe<QontoAccountingJournalsFirstpartyV2_JournalInput>;
};

/** GetEnrichmentsRequest is the request for batch enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequest = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequest';
  /** transaction_ids is the list of transaction IDs to fetch enrichment for */
  transactionParams: Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams>;
};

/** GetEnrichmentsRequest is the request for batch enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequestInput = {
  /** transaction_ids is the list of transaction IDs to fetch enrichment for */
  transactionParams?: InputMaybe<Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParamsInput>>;
};

/** GetEnrichmentsResponse is the response containing enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponse = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponse';
  /** enrichments is the list of enrichment data per transaction */
  enrichments: Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment>;
};

/** GetEnrichmentsResponse is the response containing enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponseInput = {
  /** enrichments is the list of enrichment data per transaction */
  enrichments?: InputMaybe<Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichmentInput>>;
};

/** Logo contains logo image URLs */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo';
  /** medium is the medium logo URL */
  medium: Scalars['String']['output'];
  /** small is the small logo URL */
  small: Scalars['String']['output'];
};

/** Logo contains logo image URLs */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_LogoInput = {
  /** medium is the medium logo URL */
  medium?: InputMaybe<Scalars['String']['input']>;
  /** small is the small logo URL */
  small?: InputMaybe<Scalars['String']['input']>;
};

/** TransactionEnrichment contains enrichment data for a single transaction */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment';
  /** counterparty_name is the enriched and cleaned counterparty name, i.e. Google, Spotify */
  counterpartyName: Scalars['String']['output'];
  /** id is the enrichment identifier */
  id: Scalars['String']['output'];
  /** logo contains the logo URLs */
  logo?: Maybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo>;
  /** transaction_id is the transaction this enrichment belongs to */
  transactionId: Scalars['String']['output'];
};

/** TransactionEnrichment contains enrichment data for a single transaction */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichmentInput = {
  /** counterparty_name is the enriched and cleaned counterparty name, i.e. Google, Spotify */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** id is the enrichment identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** logo contains the logo URLs */
  logo?: InputMaybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_LogoInput>;
  /** transaction_id is the transaction this enrichment belongs to */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** TransactionParams represent the tuple of transaction_id, operation_type that is required to properly compute and serialize the response */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams';
  /** operation_type is the operation type of the transaction, used to compute the logo for Qonto-originated transactions - biller, etc. */
  operationType: Scalars['String']['output'];
  /** transaction_id is the transaction ID to fetch enrichment for */
  transactionId: Scalars['String']['output'];
};

/** TransactionParams represent the tuple of transaction_id, operation_type that is required to properly compute and serialize the response */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParamsInput = {
  /** operation_type is the operation type of the transaction, used to compute the logo for Qonto-originated transactions - biller, etc. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  /** transaction_id is the transaction ID to fetch enrichment for */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** ActivityTag defines the merchant activity classification of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_ActivityTag {
  /** ACTIVITY_TAG_ATM is for ATM withdrawals */
  ActivityTagAtm = 'ACTIVITY_TAG_ATM',
  /** ACTIVITY_TAG_DIRECT_DEBIT_HOLD is for direct debit hold transactions */
  ActivityTagDirectDebitHold = 'ACTIVITY_TAG_DIRECT_DEBIT_HOLD',
  /** ACTIVITY_TAG_FALLBACK is the fallback classification */
  ActivityTagFallback = 'ACTIVITY_TAG_FALLBACK',
  /** ACTIVITY_TAG_FEES is for fee transactions */
  ActivityTagFees = 'ACTIVITY_TAG_FEES',
  /** ACTIVITY_TAG_FINANCE is for finance-related transactions */
  ActivityTagFinance = 'ACTIVITY_TAG_FINANCE',
  /** ACTIVITY_TAG_FOOD_AND_GROCERY is for food and grocery expenses */
  ActivityTagFoodAndGrocery = 'ACTIVITY_TAG_FOOD_AND_GROCERY',
  /** ACTIVITY_TAG_GAS_STATION is for gas station expenses */
  ActivityTagGasStation = 'ACTIVITY_TAG_GAS_STATION',
  /** ACTIVITY_TAG_HARDWARE_AND_EQUIPMENT is for hardware and equipment expenses */
  ActivityTagHardwareAndEquipment = 'ACTIVITY_TAG_HARDWARE_AND_EQUIPMENT',
  /** ACTIVITY_TAG_HOTEL_AND_LODGING is for hotel and lodging expenses */
  ActivityTagHotelAndLodging = 'ACTIVITY_TAG_HOTEL_AND_LODGING',
  /** ACTIVITY_TAG_INSURANCE is for insurance expenses */
  ActivityTagInsurance = 'ACTIVITY_TAG_INSURANCE',
  /** ACTIVITY_TAG_IT_AND_ELECTRONICS is for IT and electronics expenses */
  ActivityTagItAndElectronics = 'ACTIVITY_TAG_IT_AND_ELECTRONICS',
  /** ACTIVITY_TAG_LEGAL_AND_ACCOUNTING is for legal and accounting expenses */
  ActivityTagLegalAndAccounting = 'ACTIVITY_TAG_LEGAL_AND_ACCOUNTING',
  /** ACTIVITY_TAG_LOGISTICS is for logistics expenses */
  ActivityTagLogistics = 'ACTIVITY_TAG_LOGISTICS',
  /** ACTIVITY_TAG_MANUFACTURING is for manufacturing expenses */
  ActivityTagManufacturing = 'ACTIVITY_TAG_MANUFACTURING',
  /** ACTIVITY_TAG_MARKETING is for marketing expenses */
  ActivityTagMarketing = 'ACTIVITY_TAG_MARKETING',
  /** ACTIVITY_TAG_OFFICE_RENTAL is for office rental expenses */
  ActivityTagOfficeRental = 'ACTIVITY_TAG_OFFICE_RENTAL',
  /** ACTIVITY_TAG_OFFICE_SUPPLY is for office supply expenses */
  ActivityTagOfficeSupply = 'ACTIVITY_TAG_OFFICE_SUPPLY',
  /** ACTIVITY_TAG_ONLINE_SERVICE is for online service expenses */
  ActivityTagOnlineService = 'ACTIVITY_TAG_ONLINE_SERVICE',
  /** ACTIVITY_TAG_OTHER_EXPENSE is for other miscellaneous expenses */
  ActivityTagOtherExpense = 'ACTIVITY_TAG_OTHER_EXPENSE',
  /** ACTIVITY_TAG_OTHER_INCOME is for other income */
  ActivityTagOtherIncome = 'ACTIVITY_TAG_OTHER_INCOME',
  /** ACTIVITY_TAG_OTHER_SERVICE is for other service expenses */
  ActivityTagOtherService = 'ACTIVITY_TAG_OTHER_SERVICE',
  /** ACTIVITY_TAG_PENDING is for transactions pending classification */
  ActivityTagPending = 'ACTIVITY_TAG_PENDING',
  /** ACTIVITY_TAG_REFUND is for refund transactions */
  ActivityTagRefund = 'ACTIVITY_TAG_REFUND',
  /** ACTIVITY_TAG_RESTAURANT_AND_BAR is for restaurant and bar expenses */
  ActivityTagRestaurantAndBar = 'ACTIVITY_TAG_RESTAURANT_AND_BAR',
  /** ACTIVITY_TAG_SALARY is for salary payments */
  ActivityTagSalary = 'ACTIVITY_TAG_SALARY',
  /** ACTIVITY_TAG_SALES is for sales income */
  ActivityTagSales = 'ACTIVITY_TAG_SALES',
  /** ACTIVITY_TAG_SUBSCRIPTION is for subscription payments */
  ActivityTagSubscription = 'ACTIVITY_TAG_SUBSCRIPTION',
  /** ACTIVITY_TAG_TAX is for tax payments */
  ActivityTagTax = 'ACTIVITY_TAG_TAX',
  /** ACTIVITY_TAG_TRANSPORT is for transport expenses */
  ActivityTagTransport = 'ACTIVITY_TAG_TRANSPORT',
  /** ACTIVITY_TAG_TREASURY_AND_INTERCO is for treasury and intercompany transactions */
  ActivityTagTreasuryAndInterco = 'ACTIVITY_TAG_TREASURY_AND_INTERCO',
  /** ACTIVITY_TAG_UNSPECIFIED is the default unspecified value */
  ActivityTagUnspecified = 'ACTIVITY_TAG_UNSPECIFIED',
  /** ACTIVITY_TAG_UTILITY is for utility expenses */
  ActivityTagUtility = 'ACTIVITY_TAG_UTILITY',
  /** ACTIVITY_TAG_VOUCHER is for voucher transactions */
  ActivityTagVoucher = 'ACTIVITY_TAG_VOUCHER'
}

/** AttachmentRequest groups the attachment request state for a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest';
  /** requested indicates whether an attachment was requested */
  requested: Scalars['Boolean']['output'];
  /** requested_at is when an attachment was requested */
  requestedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** requested_by_id is the ID of the user who requested the attachment */
  requestedById: Scalars['String']['output'];
};

/** AttachmentRequest groups the attachment request state for a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequestInput = {
  /** requested indicates whether an attachment was requested */
  requested?: InputMaybe<Scalars['Boolean']['input']>;
  /** requested_at is when an attachment was requested */
  requestedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** requested_by_id is the ID of the user who requested the attachment */
  requestedById?: InputMaybe<Scalars['String']['input']>;
};

/** AuthorizationType defines the type of card authorization for a pending transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_AuthorizationType {
  /** AUTHORIZATION_TYPE_FULL is a full authorization for the total transaction amount */
  AuthorizationTypeFull = 'AUTHORIZATION_TYPE_FULL',
  /** AUTHORIZATION_TYPE_REMAINING is an authorization for the remaining outstanding amount */
  AuthorizationTypeRemaining = 'AUTHORIZATION_TYPE_REMAINING',
  /** AUTHORIZATION_TYPE_UNSPECIFIED is the default unspecified value */
  AuthorizationTypeUnspecified = 'AUTHORIZATION_TYPE_UNSPECIFIED'
}

/** Conditional defines the logical operator for combining filter groups */
export enum QontoAppSystemsTransactionsFirstpartyV8_Conditional {
  /** CONDITIONAL_AND combines expressions with logical AND */
  ConditionalAnd = 'CONDITIONAL_AND',
  /** CONDITIONAL_AND_NOT combines expressions with logical AND NOT */
  ConditionalAndNot = 'CONDITIONAL_AND_NOT',
  /** CONDITIONAL_OR combines expressions with logical OR */
  ConditionalOr = 'CONDITIONAL_OR',
  /** CONDITIONAL_UNSPECIFIED is the default unspecified value */
  ConditionalUnspecified = 'CONDITIONAL_UNSPECIFIED'
}

/** Counterparty contains the counterparty (recipient/sender) details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_Counterparty = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Counterparty';
  /** counterparty_account_number is the counterparty account number */
  accountNumber: Scalars['String']['output'];
  /** counterparty_bic is the counterparty BIC */
  bic: Scalars['String']['output'];
  /** counterparty_iban is the counterparty IBAN (only for external transactions: income, swift_income, direct_debit, transfer) */
  iban: Scalars['String']['output'];
};

/** Counterparty contains the counterparty (recipient/sender) details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_CounterpartyInput = {
  /** counterparty_account_number is the counterparty account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** counterparty_bic is the counterparty BIC */
  bic?: InputMaybe<Scalars['String']['input']>;
  /** counterparty_iban is the counterparty IBAN (only for external transactions: income, swift_income, direct_debit, transfer) */
  iban?: InputMaybe<Scalars['String']['input']>;
};

/** DeclinedReason defines the reason a transaction was declined */
export enum QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason {
  /** DECLINED_REASON_ACCOUNT_INACTIVE is declined because the account is inactive */
  DeclinedReasonAccountInactive = 'DECLINED_REASON_ACCOUNT_INACTIVE',
  /** DECLINED_REASON_CANNOT_VERIFY_PIN is declined because the PIN cannot be verified */
  DeclinedReasonCannotVerifyPin = 'DECLINED_REASON_CANNOT_VERIFY_PIN',
  /** DECLINED_REASON_CARDHOLDER_TO_CONTACT_ISSUER is declined and the cardholder must contact the issuer */
  DeclinedReasonCardholderToContactIssuer = 'DECLINED_REASON_CARDHOLDER_TO_CONTACT_ISSUER',
  /** DECLINED_REASON_CUSTOMER_CANCELLATION is declined due to customer cancellation */
  DeclinedReasonCustomerCancellation = 'DECLINED_REASON_CUSTOMER_CANCELLATION',
  /** DECLINED_REASON_DIRECT_DEBIT_POSTPONED is declined because the direct debit was postponed */
  DeclinedReasonDirectDebitPostponed = 'DECLINED_REASON_DIRECT_DEBIT_POSTPONED',
  /** DECLINED_REASON_DO_NOT_HONOR is declined by the issuer without specific reason */
  DeclinedReasonDoNotHonor = 'DECLINED_REASON_DO_NOT_HONOR',
  /** DECLINED_REASON_EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT is declined because the withdrawal amount limit was exceeded */
  DeclinedReasonExceedsWithdrawalAmountLimit = 'DECLINED_REASON_EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT',
  /** DECLINED_REASON_EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT is declined because the withdrawal frequency limit was exceeded */
  DeclinedReasonExceedsWithdrawalFrequencyLimit = 'DECLINED_REASON_EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT',
  /** DECLINED_REASON_EXPIRED_CARD is declined because the card has expired */
  DeclinedReasonExpiredCard = 'DECLINED_REASON_EXPIRED_CARD',
  /** DECLINED_REASON_INCORRECT_PIN is declined due to an incorrect PIN */
  DeclinedReasonIncorrectPin = 'DECLINED_REASON_INCORRECT_PIN',
  /** DECLINED_REASON_INSUFFICIENT_FUNDS is declined due to insufficient funds */
  DeclinedReasonInsufficientFunds = 'DECLINED_REASON_INSUFFICIENT_FUNDS',
  /** DECLINED_REASON_INVALID_AMOUNT is declined due to an invalid amount */
  DeclinedReasonInvalidAmount = 'DECLINED_REASON_INVALID_AMOUNT',
  /** DECLINED_REASON_INVALID_CARD_NUMBER is declined due to an invalid card number */
  DeclinedReasonInvalidCardNumber = 'DECLINED_REASON_INVALID_CARD_NUMBER',
  /** DECLINED_REASON_INVALID_MERCHANT is declined due to an invalid merchant */
  DeclinedReasonInvalidMerchant = 'DECLINED_REASON_INVALID_MERCHANT',
  /** DECLINED_REASON_ISSUER_OR_SWITCH_IS_INOPERATIVE is declined because the issuer or switch is inoperative */
  DeclinedReasonIssuerOrSwitchIsInoperative = 'DECLINED_REASON_ISSUER_OR_SWITCH_IS_INOPERATIVE',
  /** DECLINED_REASON_LOST_CARD is declined because the card was reported lost */
  DeclinedReasonLostCard = 'DECLINED_REASON_LOST_CARD',
  /** DECLINED_REASON_MERCHANT_NAME_AND_COUNTRY_UNKNOWN is declined because merchant name and country are unknown */
  DeclinedReasonMerchantNameAndCountryUnknown = 'DECLINED_REASON_MERCHANT_NAME_AND_COUNTRY_UNKNOWN',
  /** DECLINED_REASON_NOT_PERMITTED_TO_CARDHOLDER is declined because the transaction is not permitted to the cardholder */
  DeclinedReasonNotPermittedToCardholder = 'DECLINED_REASON_NOT_PERMITTED_TO_CARDHOLDER',
  /** DECLINED_REASON_NOT_PERMITTED_TO_TERMINAL is declined because the transaction is not permitted to the terminal */
  DeclinedReasonNotPermittedToTerminal = 'DECLINED_REASON_NOT_PERMITTED_TO_TERMINAL',
  /** DECLINED_REASON_OPS_CANCELED is declined because operations canceled */
  DeclinedReasonOpsCanceled = 'DECLINED_REASON_OPS_CANCELED',
  /** DECLINED_REASON_OTHER_REASON is declined for another reason not listed */
  DeclinedReasonOtherReason = 'DECLINED_REASON_OTHER_REASON',
  /** DECLINED_REASON_PIN_TRIES_EXCEEDED is declined because the PIN attempt limit was exceeded */
  DeclinedReasonPinTriesExceeded = 'DECLINED_REASON_PIN_TRIES_EXCEEDED',
  /** DECLINED_REASON_RESPONSE_RECEIVED_TOO_LATE is declined because the response was received too late */
  DeclinedReasonResponseReceivedTooLate = 'DECLINED_REASON_RESPONSE_RECEIVED_TOO_LATE',
  /** DECLINED_REASON_RESTRICTED_CARD is declined because the card is restricted */
  DeclinedReasonRestrictedCard = 'DECLINED_REASON_RESTRICTED_CARD',
  /** DECLINED_REASON_SECURITY_VIOLATION is declined due to a security violation */
  DeclinedReasonSecurityViolation = 'DECLINED_REASON_SECURITY_VIOLATION',
  /** DECLINED_REASON_STOLEN_CARD is declined because the card was reported stolen */
  DeclinedReasonStolenCard = 'DECLINED_REASON_STOLEN_CARD',
  /** DECLINED_REASON_SYSTEM_MALFUNCTION is declined due to a system malfunction */
  DeclinedReasonSystemMalfunction = 'DECLINED_REASON_SYSTEM_MALFUNCTION',
  /** DECLINED_REASON_TIMEOUT is declined due to a timeout */
  DeclinedReasonTimeout = 'DECLINED_REASON_TIMEOUT',
  /** DECLINED_REASON_UNABLE_TO_ROUTE_TRANSACTION is declined because the transaction could not be routed */
  DeclinedReasonUnableToRouteTransaction = 'DECLINED_REASON_UNABLE_TO_ROUTE_TRANSACTION',
  /** DECLINED_REASON_UNSPECIFIED is the default unspecified value */
  DeclinedReasonUnspecified = 'DECLINED_REASON_UNSPECIFIED',
  /** DECLINED_REASON_USER_CANCELED is declined because the user canceled */
  DeclinedReasonUserCanceled = 'DECLINED_REASON_USER_CANCELED'
}

/** FilterExpression defines a single filter condition */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterExpression = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_FilterExpression';
  /** operator is the comparison operator */
  operator: QontoAppSystemsTransactionsFirstpartyV8_Operator;
  /** property is the field to filter on */
  property: QontoAppSystemsTransactionsFirstpartyV8_FilterProperty;
  /** values are the values to compare against */
  values: Array<QontoAppSystemsTransactionsFirstpartyV8_Value>;
};

/** FilterExpression defines a single filter condition */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterExpressionInput = {
  /** operator is the comparison operator */
  operator?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_Operator>;
  /** property is the field to filter on */
  property?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterProperty>;
  /** values are the values to compare against */
  values?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_ValueInput>>;
};

/** FilterGroup defines a logical group of filter expressions */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroup = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_FilterGroup';
  /** conditional is the logical operator for combining expressions */
  conditional: QontoAppSystemsTransactionsFirstpartyV8_Conditional;
  /** expressions are the filter conditions in this group */
  expressions: Array<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpression>;
};

/** FilterGroup defines a logical group of filter expressions */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput = {
  /** conditional is the logical operator for combining expressions */
  conditional?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_Conditional>;
  /** expressions are the filter conditions in this group */
  expressions?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpressionInput>>;
};

/** FilterGroupOrExpression is a union of a filter expression or a nested filter group */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpression = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpression';
  /** filter_expression is a single filter condition */
  filterExpression?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_FilterExpression>;
  /** filter_group is a nested filter group */
  filterGroup?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroup>;
};

/** FilterGroupOrExpression is a union of a filter expression or a nested filter group */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpressionInput = {
  /** filter_expression is a single filter condition */
  filterExpression?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterExpressionInput>;
  /** filter_group is a nested filter group */
  filterGroup?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput>;
};

/** FilterProperty defines the available transaction fields for filtering */
export enum QontoAppSystemsTransactionsFirstpartyV8_FilterProperty {
  /** FILTER_PROPERTY_ACTIVITY_TAG filters by activity tag */
  FilterPropertyActivityTag = 'FILTER_PROPERTY_ACTIVITY_TAG',
  /** FILTER_PROPERTY_AMOUNT filters by amount (remapped to amount.raw by API adapter) */
  FilterPropertyAmount = 'FILTER_PROPERTY_AMOUNT',
  /** FILTER_PROPERTY_ATTACHMENT_STATUS filters by attachment status (remapped to has_attachment + attachment_lost_or_not_required) */
  FilterPropertyAttachmentStatus = 'FILTER_PROPERTY_ATTACHMENT_STATUS',
  /** FILTER_PROPERTY_BANK_ACCOUNT_ID filters by bank account ID */
  FilterPropertyBankAccountId = 'FILTER_PROPERTY_BANK_ACCOUNT_ID',
  /** FILTER_PROPERTY_CATEGORY_ID filters by category ID */
  FilterPropertyCategoryId = 'FILTER_PROPERTY_CATEGORY_ID',
  /** FILTER_PROPERTY_COUNTERPARTY_BANK_ACCOUNT_ID filters by counterparty bank account ID (complex nested query) */
  FilterPropertyCounterpartyBankAccountId = 'FILTER_PROPERTY_COUNTERPARTY_BANK_ACCOUNT_ID',
  /** FILTER_PROPERTY_CREATED_AT filters by creation date */
  FilterPropertyCreatedAt = 'FILTER_PROPERTY_CREATED_AT',
  /** FILTER_PROPERTY_DISPLAY_AT filters by display date (remapped with timezone formatting) */
  FilterPropertyDisplayAt = 'FILTER_PROPERTY_DISPLAY_AT',
  /** FILTER_PROPERTY_DISPLAY_NAME filters by display name (remapped to counterparty_name + clean_counterparty_name) */
  FilterPropertyDisplayName = 'FILTER_PROPERTY_DISPLAY_NAME',
  /** FILTER_PROPERTY_EMITTED_AT filters by emission date */
  FilterPropertyEmittedAt = 'FILTER_PROPERTY_EMITTED_AT',
  /** FILTER_PROPERTY_EXCLUDED_FROM_ANALYTICS filters by analytics exclusion status */
  FilterPropertyExcludedFromAnalytics = 'FILTER_PROPERTY_EXCLUDED_FROM_ANALYTICS',
  /** FILTER_PROPERTY_INITIATOR_ID filters by initiator user ID */
  FilterPropertyInitiatorId = 'FILTER_PROPERTY_INITIATOR_ID',
  /** FILTER_PROPERTY_LABEL_IDS filters by label IDs */
  FilterPropertyLabelIds = 'FILTER_PROPERTY_LABEL_IDS',
  /** FILTER_PROPERTY_NOTE filters by note content */
  FilterPropertyNote = 'FILTER_PROPERTY_NOTE',
  /** FILTER_PROPERTY_OPERATION_METHOD filters by payment method */
  FilterPropertyOperationMethod = 'FILTER_PROPERTY_OPERATION_METHOD',
  /** FILTER_PROPERTY_OPERATION_TYPE filters by operation type */
  FilterPropertyOperationType = 'FILTER_PROPERTY_OPERATION_TYPE',
  /** FILTER_PROPERTY_REFERENCE filters by reference */
  FilterPropertyReference = 'FILTER_PROPERTY_REFERENCE',
  /** FILTER_PROPERTY_SETTLED_AT filters by settlement date */
  FilterPropertySettledAt = 'FILTER_PROPERTY_SETTLED_AT',
  /** FILTER_PROPERTY_SIDE filters by transaction side (debit/credit) */
  FilterPropertySide = 'FILTER_PROPERTY_SIDE',
  /** FILTER_PROPERTY_SLUG filters by transaction slug */
  FilterPropertySlug = 'FILTER_PROPERTY_SLUG',
  /** FILTER_PROPERTY_STATUS filters by transaction status */
  FilterPropertyStatus = 'FILTER_PROPERTY_STATUS',
  /** FILTER_PROPERTY_TEAM_ID filters by team ID (remapped to initiator_id via membership lookup) */
  FilterPropertyTeamId = 'FILTER_PROPERTY_TEAM_ID',
  /** FILTER_PROPERTY_TRANSACTION_FEES filters by transaction fee status (remapped to is_related_fee) */
  FilterPropertyTransactionFees = 'FILTER_PROPERTY_TRANSACTION_FEES',
  /** FILTER_PROPERTY_UNSPECIFIED is the default unspecified value */
  FilterPropertyUnspecified = 'FILTER_PROPERTY_UNSPECIFIED',
  /** FILTER_PROPERTY_UPDATED_AT filters by last update date */
  FilterPropertyUpdatedAt = 'FILTER_PROPERTY_UPDATED_AT',
  /** FILTER_PROPERTY_VAT_COMPLETENESS filters by VAT completeness status */
  FilterPropertyVatCompleteness = 'FILTER_PROPERTY_VAT_COMPLETENESS'
}

/** GetChildTransactionsRequest is the request message for fetching child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsRequest';
  /** parent_ids is the list of parent transaction IDs whose children to fetch */
  parentIds: Array<Scalars['String']['output']>;
};

/** GetChildTransactionsRequest is the request message for fetching child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsRequestInput = {
  /** parent_ids is the list of parent transaction IDs whose children to fetch */
  parentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetChildTransactionsResponse is the response message containing child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsResponse';
  /** transactions is the list of child transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** GetChildTransactionsResponse is the response message containing child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsResponseInput = {
  /** transactions is the list of child transactions */
  transactions?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionInput>>;
};

/** GetParentTransactionsRequest is the request message for fetching parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsRequest';
  /** child_ids is the list of child transaction IDs whose parents to fetch */
  childIds: Array<Scalars['String']['output']>;
};

/** GetParentTransactionsRequest is the request message for fetching parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsRequestInput = {
  /** child_ids is the list of child transaction IDs whose parents to fetch */
  childIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetParentTransactionsResponse is the response message containing parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsResponse';
  /** transactions is the list of parent transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** GetParentTransactionsResponse is the response message containing parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsResponseInput = {
  /** transactions is the list of parent transactions */
  transactions?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionInput>>;
};

/** GetTransactionAttachmentStatusesRequest is the request for batch attachment status */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesRequest';
  /** transaction_ids is the list of transaction IDs to fetch attachment status for */
  transactionIds: Array<Scalars['String']['output']>;
};

/** GetTransactionAttachmentStatusesRequest is the request for batch attachment status */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesRequestInput = {
  /** transaction_ids is the list of transaction IDs to fetch attachment status for */
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetTransactionAttachmentStatusesResponse is the response containing attachment status data */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesResponse';
  /** attachment_statuses is the list of attachment status data per transaction */
  attachmentStatuses: Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus>;
};

/** GetTransactionAttachmentStatusesResponse is the response containing attachment status data */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesResponseInput = {
  /** attachment_statuses is the list of attachment status data per transaction */
  attachmentStatuses?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatusInput>>;
};

/** OperationMethod defines the payment method used for a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_OperationMethod {
  /** OPERATION_METHOD_BILLER is a billing fee transaction */
  OperationMethodBiller = 'OPERATION_METHOD_BILLER',
  /** OPERATION_METHOD_CARD is a card payment */
  OperationMethodCard = 'OPERATION_METHOD_CARD',
  /** OPERATION_METHOD_CARD_ACQUIRER_PAYOUT is a card acquirer payout */
  OperationMethodCardAcquirerPayout = 'OPERATION_METHOD_CARD_ACQUIRER_PAYOUT',
  /** OPERATION_METHOD_CASHBACK is a card cashback payout or adjustment */
  OperationMethodCashback = 'OPERATION_METHOD_CASHBACK',
  /** OPERATION_METHOD_CHEQUE is a cheque payment */
  OperationMethodCheque = 'OPERATION_METHOD_CHEQUE',
  /** OPERATION_METHOD_DDC is a deferred debit card payment */
  OperationMethodDdc = 'OPERATION_METHOD_DDC',
  /** OPERATION_METHOD_DIRECT_DEBIT is a direct debit (also covers direct debit collections) */
  OperationMethodDirectDebit = 'OPERATION_METHOD_DIRECT_DEBIT',
  /** OPERATION_METHOD_DIRECT_DEBIT_HOLD is a hold for a future direct debit */
  OperationMethodDirectDebitHold = 'OPERATION_METHOD_DIRECT_DEBIT_HOLD',
  /** OPERATION_METHOD_INVESTMENT is an investment transaction */
  OperationMethodInvestment = 'OPERATION_METHOD_INVESTMENT',
  /** OPERATION_METHOD_OTHER is an uncategorized transaction type */
  OperationMethodOther = 'OPERATION_METHOD_OTHER',
  /** OPERATION_METHOD_OVERDRAFT is a transaction that got a short-term credit when the amount was bigger than the available balance */
  OperationMethodOverdraft = 'OPERATION_METHOD_OVERDRAFT',
  /** OPERATION_METHOD_PAGOPA_PAYMENT is a PagoPA payment */
  OperationMethodPagopaPayment = 'OPERATION_METHOD_PAGOPA_PAYMENT',
  /** OPERATION_METHOD_PAY_LATER is a deferred pay later payment */
  OperationMethodPayLater = 'OPERATION_METHOD_PAY_LATER',
  /** OPERATION_METHOD_REMUNERATION is an account remuneration */
  OperationMethodRemuneration = 'OPERATION_METHOD_REMUNERATION',
  /** OPERATION_METHOD_RIBA_PAYMENT is an Italian RIBA payment */
  OperationMethodRibaPayment = 'OPERATION_METHOD_RIBA_PAYMENT',
  /** OPERATION_METHOD_TAX is a tax payment (covers f24 and nrc payment types) */
  OperationMethodTax = 'OPERATION_METHOD_TAX',
  /** OPERATION_METHOD_TRANSFER is a bank transfer (also covers income, recall, swift income, and international outgoing transfers) */
  OperationMethodTransfer = 'OPERATION_METHOD_TRANSFER',
  /** OPERATION_METHOD_UNSPECIFIED is the default unspecified value */
  OperationMethodUnspecified = 'OPERATION_METHOD_UNSPECIFIED'
}

/** OperationType defines the fine-grained type of a transaction operation */
export enum QontoAppSystemsTransactionsFirstpartyV8_OperationType {
  /** OPERATION_TYPE_ACCOUNT_REMUNERATION is an account remuneration */
  OperationTypeAccountRemuneration = 'OPERATION_TYPE_ACCOUNT_REMUNERATION',
  /** OPERATION_TYPE_BILLER is a billing fee transaction */
  OperationTypeBiller = 'OPERATION_TYPE_BILLER',
  /** OPERATION_TYPE_CARD is a card payment */
  OperationTypeCard = 'OPERATION_TYPE_CARD',
  /** OPERATION_TYPE_CARD_ACQUIRER_PAYOUT is a card acquirer payout */
  OperationTypeCardAcquirerPayout = 'OPERATION_TYPE_CARD_ACQUIRER_PAYOUT',
  /** OPERATION_TYPE_CASHBACK_ADJUSTMENT is a cashback adjustment */
  OperationTypeCashbackAdjustment = 'OPERATION_TYPE_CASHBACK_ADJUSTMENT',
  /** OPERATION_TYPE_CASHBACK_PAYOUT is a cashback payout */
  OperationTypeCashbackPayout = 'OPERATION_TYPE_CASHBACK_PAYOUT',
  /** OPERATION_TYPE_CHEQUE is a cheque payment */
  OperationTypeCheque = 'OPERATION_TYPE_CHEQUE',
  /** OPERATION_TYPE_DIRECT_DEBIT is a direct debit payment */
  OperationTypeDirectDebit = 'OPERATION_TYPE_DIRECT_DEBIT',
  /** OPERATION_TYPE_DIRECT_DEBIT_COLLECTION is a direct debit collection */
  OperationTypeDirectDebitCollection = 'OPERATION_TYPE_DIRECT_DEBIT_COLLECTION',
  /** OPERATION_TYPE_DIRECT_DEBIT_HOLD is a hold for a future direct debit */
  OperationTypeDirectDebitHold = 'OPERATION_TYPE_DIRECT_DEBIT_HOLD',
  /** OPERATION_TYPE_EXTERNAL_FEES is fees transactions from external banks */
  OperationTypeExternalFees = 'OPERATION_TYPE_EXTERNAL_FEES',
  /** OPERATION_TYPE_F24 is an Italian F24 tax payment */
  OperationTypeF24 = 'OPERATION_TYPE_F24',
  /** OPERATION_TYPE_FINANCING_INSTALLMENT is a financing installment payment */
  OperationTypeFinancingInstallment = 'OPERATION_TYPE_FINANCING_INSTALLMENT',
  /** OPERATION_TYPE_INCOME is an incoming transfer */
  OperationTypeIncome = 'OPERATION_TYPE_INCOME',
  /** OPERATION_TYPE_INVESTMENT is an investment transaction */
  OperationTypeInvestment = 'OPERATION_TYPE_INVESTMENT',
  /** OPERATION_TYPE_NRC_PAYMENT is an Italian NRC tax payment */
  OperationTypeNrcPayment = 'OPERATION_TYPE_NRC_PAYMENT',
  /** OPERATION_TYPE_OTHER is an uncategorized operation type */
  OperationTypeOther = 'OPERATION_TYPE_OTHER',
  /** OPERATION_TYPE_PAGOPA_PAYMENT is an Italian PagoPA payment */
  OperationTypePagopaPayment = 'OPERATION_TYPE_PAGOPA_PAYMENT',
  /** OPERATION_TYPE_PAY_LATER is a deferred pay later payment */
  OperationTypePayLater = 'OPERATION_TYPE_PAY_LATER',
  /** OPERATION_TYPE_RECALL is a recalled transfer */
  OperationTypeRecall = 'OPERATION_TYPE_RECALL',
  /** OPERATION_TYPE_RIBA_PAYMENT is an Italian RIBA payment */
  OperationTypeRibaPayment = 'OPERATION_TYPE_RIBA_PAYMENT',
  /** OPERATION_TYPE_SWIFT_INCOME is an incoming SWIFT transfer */
  OperationTypeSwiftIncome = 'OPERATION_TYPE_SWIFT_INCOME',
  /** OPERATION_TYPE_TRANSFER is a bank transfer */
  OperationTypeTransfer = 'OPERATION_TYPE_TRANSFER',
  /** OPERATION_TYPE_UNSPECIFIED is the default unspecified value */
  OperationTypeUnspecified = 'OPERATION_TYPE_UNSPECIFIED'
}

/** Operator defines the comparison operators for filter expressions */
export enum QontoAppSystemsTransactionsFirstpartyV8_Operator {
  /** OPERATOR_CALENDAR_INTERVAL matches values within a calendar interval */
  OperatorCalendarInterval = 'OPERATOR_CALENDAR_INTERVAL',
  /** OPERATOR_EQ matches exact equality */
  OperatorEq = 'OPERATOR_EQ',
  /** OPERATOR_EXISTS matches fields that exist */
  OperatorExists = 'OPERATOR_EXISTS',
  /** OPERATOR_GT matches greater than */
  OperatorGt = 'OPERATOR_GT',
  /** OPERATOR_GTE matches greater than or equal */
  OperatorGte = 'OPERATOR_GTE',
  /** OPERATOR_IN matches any value in a list */
  OperatorIn = 'OPERATOR_IN',
  /** OPERATOR_INTERVAL matches values within an interval */
  OperatorInterval = 'OPERATOR_INTERVAL',
  /** OPERATOR_LT matches less than */
  OperatorLt = 'OPERATOR_LT',
  /** OPERATOR_LTE matches less than or equal */
  OperatorLte = 'OPERATOR_LTE',
  /** OPERATOR_MATCH matches text using full-text search */
  OperatorMatch = 'OPERATOR_MATCH',
  /** OPERATOR_NOT_EQ matches inequality */
  OperatorNotEq = 'OPERATOR_NOT_EQ',
  /** OPERATOR_NOT_EXISTS matches fields that do not exist */
  OperatorNotExists = 'OPERATOR_NOT_EXISTS',
  /** OPERATOR_NOT_IN matches values not in a list */
  OperatorNotIn = 'OPERATOR_NOT_IN',
  /** OPERATOR_NOT_MATCH excludes text using full-text search */
  OperatorNotMatch = 'OPERATOR_NOT_MATCH',
  /** OPERATOR_UNSPECIFIED is the default unspecified value */
  OperatorUnspecified = 'OPERATOR_UNSPECIFIED',
  /** OPERATOR_WITHIN matches values within a range */
  OperatorWithin = 'OPERATOR_WITHIN'
}

/** SearchTransactionsRequest is the request message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequest';
  /** filter_group defines the filter criteria */
  filterGroup?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroup>;
  /** pagination defines the pagination parameters */
  pagination?: Maybe<QontoCommon_PaginationInput>;
  /** search is a free-text search query */
  search?: Maybe<Scalars['String']['output']>;
  /** sort defines the sort criteria */
  sort: Array<QontoAppSystemsTransactionsFirstpartyV8_Sort>;
};

/** SearchTransactionsRequest is the request message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput = {
  /** filter_group defines the filter criteria */
  filterGroup?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput>;
  /** pagination defines the pagination parameters */
  pagination?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** search is a free-text search query */
  search?: InputMaybe<Scalars['String']['input']>;
  /** sort defines the sort criteria */
  sort?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_SortInput>>;
};

/** SearchTransactionsResponse is the response message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse';
  /** meta contains pagination metadata */
  meta?: Maybe<QontoCommon_PaginationMeta>;
  /** transactions is the list of matching transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** SearchTransactionsResponse is the response message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponseInput = {
  /** meta contains pagination metadata */
  meta?: InputMaybe<QontoCommon_PaginationMetaInput>;
  /** transactions is the list of matching transactions */
  transactions?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionInput>>;
};

/** Side defines the direction of a transaction relative to the account */
export enum QontoAppSystemsTransactionsFirstpartyV8_Side {
  /** SIDE_CREDIT is a credit (incoming) transaction */
  SideCredit = 'SIDE_CREDIT',
  /** SIDE_DEBIT is a debit (outgoing) transaction */
  SideDebit = 'SIDE_DEBIT',
  /** SIDE_UNSPECIFIED is the default unspecified value */
  SideUnspecified = 'SIDE_UNSPECIFIED'
}

/** Sort defines the sort criteria for a transaction query */
export type QontoAppSystemsTransactionsFirstpartyV8_Sort = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Sort';
  /** direction is the sort order */
  direction: QontoAppSystemsTransactionsFirstpartyV8_SortDirection;
  /** property is the field to sort by */
  property: QontoAppSystemsTransactionsFirstpartyV8_SortProperty;
};

/** SortDirection defines the sort order direction */
export enum QontoAppSystemsTransactionsFirstpartyV8_SortDirection {
  /** SORT_DIRECTION_ASC sorts in ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** SORT_DIRECTION_DESC sorts in descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  /** SORT_DIRECTION_UNSPECIFIED is the default unspecified value */
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

/** Sort defines the sort criteria for a transaction query */
export type QontoAppSystemsTransactionsFirstpartyV8_SortInput = {
  /** direction is the sort order */
  direction?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SortDirection>;
  /** property is the field to sort by */
  property?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SortProperty>;
};

/** SortProperty defines the available transaction fields for sorting */
export enum QontoAppSystemsTransactionsFirstpartyV8_SortProperty {
  /** SORT_PROPERTY_AMOUNT sorts by transaction amount */
  SortPropertyAmount = 'SORT_PROPERTY_AMOUNT',
  /** SORT_PROPERTY_COUNTERPARTY_NAME sorts by counterparty name */
  SortPropertyCounterpartyName = 'SORT_PROPERTY_COUNTERPARTY_NAME',
  /** SORT_PROPERTY_CREATED_AT sorts by creation date (default) */
  SortPropertyCreatedAt = 'SORT_PROPERTY_CREATED_AT',
  /** SORT_PROPERTY_DISPLAY_AT sorts by display date */
  SortPropertyDisplayAt = 'SORT_PROPERTY_DISPLAY_AT',
  /** SORT_PROPERTY_EMITTED_AT sorts by emission date */
  SortPropertyEmittedAt = 'SORT_PROPERTY_EMITTED_AT',
  /** SORT_PROPERTY_OPERATION_METHOD sorts by payment method */
  SortPropertyOperationMethod = 'SORT_PROPERTY_OPERATION_METHOD',
  /** SORT_PROPERTY_SETTLED_AT sorts by settlement date */
  SortPropertySettledAt = 'SORT_PROPERTY_SETTLED_AT',
  /** SORT_PROPERTY_STATUS sorts by transaction status */
  SortPropertyStatus = 'SORT_PROPERTY_STATUS',
  /** SORT_PROPERTY_UNSPECIFIED is the default unspecified value */
  SortPropertyUnspecified = 'SORT_PROPERTY_UNSPECIFIED',
  /** SORT_PROPERTY_UPDATED_AT sorts by last update date */
  SortPropertyUpdatedAt = 'SORT_PROPERTY_UPDATED_AT'
}

/** StatusHistory represents a status transition event */
export type QontoAppSystemsTransactionsFirstpartyV8_StatusHistory = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_StatusHistory';
  /** created_at is when this status was recorded */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** status is the status value (e.g. "authorized", "settled") */
  status: QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus;
};

/** StatusHistory represents a status transition event */
export type QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryInput = {
  /** created_at is when this status was recorded */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** status is the status value (e.g. "authorized", "settled") */
  status?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus>;
};

/** StatusHistoryStatus defines the status values recorded in a transaction's status history */
export enum QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus {
  /** STATUS_HISTORY_STATUS_AUTHORIZED is the authorized status in the transaction lifecycle */
  StatusHistoryStatusAuthorized = 'STATUS_HISTORY_STATUS_AUTHORIZED',
  /** STATUS_HISTORY_STATUS_SETTLED is the settled status in the transaction lifecycle */
  StatusHistoryStatusSettled = 'STATUS_HISTORY_STATUS_SETTLED',
  /** STATUS_HISTORY_STATUS_UNSPECIFIED is the default unspecified value */
  StatusHistoryStatusUnspecified = 'STATUS_HISTORY_STATUS_UNSPECIFIED'
}

/**
 * SubjectReference groups the depolymorphized subject ids — they are serialized depending on the subject_type
 * Some types can have multiple fields, like Card
 */
export type QontoAppSystemsTransactionsFirstpartyV8_SubjectReference = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SubjectReference';
  /** account_remuneration_id is the AccountRemuneration subject ID (when subject_type == AccountRemuneration) */
  accountRemunerationId?: Maybe<Scalars['String']['output']>;
  /** billing_transfer_id is the provider_object_id (when subject_type == BillingTransfer, subject_type remapped to WalletToWallet) */
  billingTransferId?: Maybe<Scalars['String']['output']>;
  /** card_acquirer_payout_id is the CardAcquirerPayout subject ID (when subject_type == CardAcquirerPayout) */
  cardAcquirerPayoutId?: Maybe<Scalars['String']['output']>;
  /** card_id is the Card subject ID (when subject_type == Card) */
  cardId?: Maybe<Scalars['String']['output']>;
  /** card_transaction_movement_id is the provider_object_id (when subject_type == Card) */
  cardTransactionMovementId?: Maybe<Scalars['String']['output']>;
  /** cashback_id is the Cashback subject ID (when subject_type == Cashback) */
  cashbackId?: Maybe<Scalars['String']['output']>;
  /** check_id is the provider_object_id (when subject_type == Check) */
  checkId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_collection_id is the DirectDebitCollection subject ID (when subject_type == DirectDebitCollection) */
  directDebitCollectionId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_hold_id is the DirectDebitHold subject ID (when subject_type == DirectDebitHold) */
  directDebitHoldId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_id is the DirectDebit subject ID (when subject_type == DirectDebit) */
  directDebitId?: Maybe<Scalars['String']['output']>;
  /** dispute_id is the transaction ID for which we need to fetch the dispyte (when subject_type == Card) */
  disputeId?: Maybe<Scalars['String']['output']>;
  /** f24_payment_id is the F24Payment subject ID (when subject_type == F24Payment) */
  f24PaymentId?: Maybe<Scalars['String']['output']>;
  /** financing_installment_id is the provider_object_id (when subject_type == FinancingInstallment) */
  financingInstallmentId?: Maybe<Scalars['String']['output']>;
  /** income_id is the Income subject ID (when subject_type == Income) */
  incomeId?: Maybe<Scalars['String']['output']>;
  /** nrc_payment_id is the provider_object_id (when subject_type == NrcPayment) */
  nrcPaymentId?: Maybe<Scalars['String']['output']>;
  /** pagopa_payment_id is the provider_object_id (when subject_type == PagopaPayment) */
  pagopaPaymentId?: Maybe<Scalars['String']['output']>;
  /** riba_payment_id is the provider_object_id (when subject_type == RibaPayment) */
  ribaPaymentId?: Maybe<Scalars['String']['output']>;
  /** swift_income_id is the provider_object_id (when subject_type == SwiftIncome) */
  swiftIncomeId?: Maybe<Scalars['String']['output']>;
  /** transfer_id is the Transfer subject ID (when subject_type == Transfer) */
  transferId?: Maybe<Scalars['String']['output']>;
  /** wallet_to_wallet_id is the WalletToWallet subject ID (when subject_type == WalletToWallet) */
  walletToWalletId?: Maybe<Scalars['String']['output']>;
};

/**
 * SubjectReference groups the depolymorphized subject ids — they are serialized depending on the subject_type
 * Some types can have multiple fields, like Card
 */
export type QontoAppSystemsTransactionsFirstpartyV8_SubjectReferenceInput = {
  /** account_remuneration_id is the AccountRemuneration subject ID (when subject_type == AccountRemuneration) */
  accountRemunerationId?: InputMaybe<Scalars['String']['input']>;
  /** billing_transfer_id is the provider_object_id (when subject_type == BillingTransfer, subject_type remapped to WalletToWallet) */
  billingTransferId?: InputMaybe<Scalars['String']['input']>;
  /** card_acquirer_payout_id is the CardAcquirerPayout subject ID (when subject_type == CardAcquirerPayout) */
  cardAcquirerPayoutId?: InputMaybe<Scalars['String']['input']>;
  /** card_id is the Card subject ID (when subject_type == Card) */
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** card_transaction_movement_id is the provider_object_id (when subject_type == Card) */
  cardTransactionMovementId?: InputMaybe<Scalars['String']['input']>;
  /** cashback_id is the Cashback subject ID (when subject_type == Cashback) */
  cashbackId?: InputMaybe<Scalars['String']['input']>;
  /** check_id is the provider_object_id (when subject_type == Check) */
  checkId?: InputMaybe<Scalars['String']['input']>;
  /** direct_debit_collection_id is the DirectDebitCollection subject ID (when subject_type == DirectDebitCollection) */
  directDebitCollectionId?: InputMaybe<Scalars['String']['input']>;
  /** direct_debit_hold_id is the DirectDebitHold subject ID (when subject_type == DirectDebitHold) */
  directDebitHoldId?: InputMaybe<Scalars['String']['input']>;
  /** direct_debit_id is the DirectDebit subject ID (when subject_type == DirectDebit) */
  directDebitId?: InputMaybe<Scalars['String']['input']>;
  /** dispute_id is the transaction ID for which we need to fetch the dispyte (when subject_type == Card) */
  disputeId?: InputMaybe<Scalars['String']['input']>;
  /** f24_payment_id is the F24Payment subject ID (when subject_type == F24Payment) */
  f24PaymentId?: InputMaybe<Scalars['String']['input']>;
  /** financing_installment_id is the provider_object_id (when subject_type == FinancingInstallment) */
  financingInstallmentId?: InputMaybe<Scalars['String']['input']>;
  /** income_id is the Income subject ID (when subject_type == Income) */
  incomeId?: InputMaybe<Scalars['String']['input']>;
  /** nrc_payment_id is the provider_object_id (when subject_type == NrcPayment) */
  nrcPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** pagopa_payment_id is the provider_object_id (when subject_type == PagopaPayment) */
  pagopaPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** riba_payment_id is the provider_object_id (when subject_type == RibaPayment) */
  ribaPaymentId?: InputMaybe<Scalars['String']['input']>;
  /** swift_income_id is the provider_object_id (when subject_type == SwiftIncome) */
  swiftIncomeId?: InputMaybe<Scalars['String']['input']>;
  /** transfer_id is the Transfer subject ID (when subject_type == Transfer) */
  transferId?: InputMaybe<Scalars['String']['input']>;
  /** wallet_to_wallet_id is the WalletToWallet subject ID (when subject_type == WalletToWallet) */
  walletToWalletId?: InputMaybe<Scalars['String']['input']>;
};

/** SubjectType defines the type of a transaction subject. */
export enum QontoAppSystemsTransactionsFirstpartyV8_SubjectType {
  /** Account remuneration (interest on deposits). */
  SubjectTypeAccountRemuneration = 'SUBJECT_TYPE_ACCOUNT_REMUNERATION',
  /** Billing transfer (Qonto fees, subscription charges). */
  SubjectTypeBillingTransfer = 'SUBJECT_TYPE_BILLING_TRANSFER',
  /** Capital deposit transfer. */
  SubjectTypeCapitalDepositTransfer = 'SUBJECT_TYPE_CAPITAL_DEPOSIT_TRANSFER',
  /** Card payment transaction. */
  SubjectTypeCard = 'SUBJECT_TYPE_CARD',
  /** Card acquirer payout (merchant settlement). */
  SubjectTypeCardAcquirerPayout = 'SUBJECT_TYPE_CARD_ACQUIRER_PAYOUT',
  /** Card cashback payout or adjustment. */
  SubjectTypeCashback = 'SUBJECT_TYPE_CASHBACK',
  /** Cheque deposit. */
  SubjectTypeCheck = 'SUBJECT_TYPE_CHECK',
  /** SEPA direct debit. */
  SubjectTypeDirectDebit = 'SUBJECT_TYPE_DIRECT_DEBIT',
  /** SEPA direct debit collection (creditor-initiated). */
  SubjectTypeDirectDebitCollection = 'SUBJECT_TYPE_DIRECT_DEBIT_COLLECTION',
  /** SEPA direct debit hold (pending collection). */
  SubjectTypeDirectDebitHold = 'SUBJECT_TYPE_DIRECT_DEBIT_HOLD',
  /** Italian F24 tax payment. */
  SubjectTypeF24Payment = 'SUBJECT_TYPE_F24_PAYMENT',
  /** Financing income (pay later disbursement). */
  SubjectTypeFinancingIncome = 'SUBJECT_TYPE_FINANCING_INCOME',
  /** Financing installment repayment. */
  SubjectTypeFinancingInstallment = 'SUBJECT_TYPE_FINANCING_INSTALLMENT',
  /** Incoming SEPA credit transfer. */
  SubjectTypeIncome = 'SUBJECT_TYPE_INCOME',
  /** Spanish NRC tax payment. */
  SubjectTypeNrcPayment = 'SUBJECT_TYPE_NRC_PAYMENT',
  /** Italian PagoPA payment. */
  SubjectTypePagopaPayment = 'SUBJECT_TYPE_PAGOPA_PAYMENT',
  /** Italian RiBa (Ricevuta Bancaria) payment. */
  SubjectTypeRibaPayment = 'SUBJECT_TYPE_RIBA_PAYMENT',
  /** Incoming SWIFT international transfer. */
  SubjectTypeSwiftIncome = 'SUBJECT_TYPE_SWIFT_INCOME',
  /** Outgoing transfer (SEPA, international, internal). */
  SubjectTypeTransfer = 'SUBJECT_TYPE_TRANSFER',
  /** Unspecified subject type, default zero value. */
  SubjectTypeUnspecified = 'SUBJECT_TYPE_UNSPECIFIED',
  /** Internal wallet-to-wallet transfer between Qonto accounts. */
  SubjectTypeWalletToWallet = 'SUBJECT_TYPE_WALLET_TO_WALLET'
}

/** Transaction represents a slim transaction record with core fields only */
export type QontoAppSystemsTransactionsFirstpartyV8_Transaction = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction';
  accountRemuneration?: Maybe<AccountRemuneration>;
  /** activity_tag is the activity classification */
  activityTag: QontoAppSystemsTransactionsFirstpartyV8_ActivityTag;
  /** amount is the transaction amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** attachment_ids is the list of attachment IDs (from ES) */
  attachmentIds: Array<Scalars['String']['output']>;
  /** attachment_request groups the attachment request state (requested, requested_at, requested_by_id) */
  attachmentRequest?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest>;
  attachmentStatus?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus>;
  attachments: Array<Attachment>;
  /** authorization_type is the authorization type (only present for pending transactions) */
  authorizationType?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_AuthorizationType>;
  bankAccount?: Maybe<BankAccount>;
  /** bank_account_id is the associated bank account ID */
  bankAccountId: Scalars['String']['output'];
  billingTransfer?: Maybe<BillingTransfer>;
  card?: Maybe<Card>;
  cardAcquirerPayout?: Maybe<CardAcquirerPayout>;
  cardTransaction?: Maybe<CardTransaction>;
  cardTransactionStatus?: Maybe<CardTransactionStatus>;
  cashback?: Maybe<Cashback>;
  category?: Maybe<CashFlowCategory>;
  check?: Maybe<Check>;
  childTransactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
  /** counterparty contains the counterparty (recipient/sender) details */
  counterparty?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_Counterparty>;
  /** counterparty_name returns the clean counterparty name or a translated counterparty name for system transactions, like biller fees */
  counterpartyName: Scalars['String']['output'];
  /** created_at is the timestamp of when the transaction record was created in the DB */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** declined_reason is the reason for decline (if applicable) */
  declinedReason: QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason;
  deferredDebitCardRepayment?: Maybe<DeferredDebitCardRepayment>;
  /** description is the transaction description */
  description?: Maybe<Scalars['String']['output']>;
  directDebit?: Maybe<DirectDebit>;
  directDebitCollection?: Maybe<DirectDebitCollection>;
  directDebitHold?: Maybe<DirectDebitHold>;
  /** display_at is the display timestamp = settled_at || emitted_at */
  displayAt?: Maybe<Scalars['TimestampProto']['output']>;
  disputes: Array<Dispute>;
  /** emitted_at is when the movement that the transaction represents was emitted in the CBS */
  emittedAt?: Maybe<Scalars['TimestampProto']['output']>;
  enrichment?: Maybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment>;
  /** excluded_from_analytics indicates exclusion from analytics (from ES) */
  excludedFromAnalytics: Scalars['Boolean']['output'];
  f24Payment?: Maybe<F24Payment>;
  financingInstallment?: Maybe<FinancingInstallment>;
  /** fx indicates whether the transaction involves foreign exchange */
  fx: Scalars['Boolean']['output'];
  /** fx_rate is the foreign exchange rate (if applicable) */
  fxRate?: Maybe<Scalars['Float']['output']>;
  /** has_attachment indicates whether the transaction has an attachment (from ES) */
  hasAttachment: Scalars['Boolean']['output'];
  /** id is the unique identifier */
  id: Scalars['String']['output'];
  income?: Maybe<Income>;
  initiator?: Maybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership>;
  /** initiator_id is the ID of the initiating user */
  initiatorId?: Maybe<Scalars['String']['output']>;
  /** is_atm indicates whether this is an ATM transaction */
  isAtm: Scalars['Boolean']['output'];
  /** is_external_transaction indicates whether this is an external transaction */
  isExternalTransaction: Scalars['Boolean']['output'];
  /** is_merged_fee indicates whether this is a merged fee transaction (from ES) */
  isMergedFee: Scalars['Boolean']['output'];
  /** is_pos indicates whether this is a point-of-sale transaction */
  isPos: Scalars['Boolean']['output'];
  /** is_proxied indicates whether this is a proxied F24 payment */
  isProxied: Scalars['Boolean']['output'];
  /** label_ids is the list of label IDs (from ES) */
  labelIds: Array<Scalars['String']['output']>;
  labels: Array<Label>;
  /** local_amount is the amount in local currency */
  localAmount?: Maybe<QontoCommon_CurrencyAmount>;
  mergedFees?: Maybe<RelatedFees>;
  /** merged_fees_id is the ID of merged fees (if applicable) */
  mergedFeesId?: Maybe<Scalars['String']['output']>;
  /** note is a user-provided note */
  note?: Maybe<Scalars['String']['output']>;
  nrcPayment?: Maybe<NrcPayment>;
  /** operation_method is the payment method */
  operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod;
  /** operation_type is the operation classification */
  operationType: QontoAppSystemsTransactionsFirstpartyV8_OperationType;
  /** organization_id is sourced from Elasticsearch response */
  organizationId: Scalars['String']['output'];
  overdraftInterestPayment?: Maybe<OverdraftInterestPayment>;
  pagopaPayment?: Maybe<PagopaPayment>;
  parentTransactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
  /** provider_object_id is the provider's object identifier */
  providerObjectId: Scalars['String']['output'];
  /** qualified_for_accounting indicates accounting eligibility (from ES) */
  qualifiedForAccounting: Scalars['Boolean']['output'];
  /** raw_counterparty_name is the unprocessed counterparty name */
  rawCounterpartyName: Scalars['String']['output'];
  /** related_transaction_id is the ID of a related transaction */
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  ribaPayment?: Maybe<RibaPayment>;
  /** settled_at is when the transaction was settled in the CBS */
  settledAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** settled_balance is the account balance after settlement */
  settledBalance?: Maybe<QontoCommon_CurrencyAmount>;
  /** side is the transaction direction (debit/credit) */
  side: QontoAppSystemsTransactionsFirstpartyV8_Side;
  /** slug is the human-readable identifier */
  slug: Scalars['String']['output'];
  /** status is the transaction status */
  status: QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus;
  /** status_history is the list of status transitions (computed from emitted_at/settled_at) */
  statusHistory: Array<QontoAppSystemsTransactionsFirstpartyV8_StatusHistory>;
  /** Depolymorphized subject fields — each maps to subject_id or provider_object_id based on subject_type */
  subjectReference?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_SubjectReference>;
  /** subject_type is the subject entity type (note: BillingTransfer is remapped to WalletToWallet) */
  subjectType: QontoAppSystemsTransactionsFirstpartyV8_SubjectType;
  suggestedCategory?: Maybe<SuggestedCategory>;
  supplierInvoices: Array<SupplierInvoice>;
  supplierSubscription?: Maybe<SupplierSubscription>;
  supplierSubscriptionMeta?: Maybe<SupplierSubscriptionMeta>;
  supportedInvoiceCollector?: Maybe<SupportedInvoiceCollector>;
  swiftIncome?: Maybe<SwiftIncome>;
  thread?: Maybe<Thread>;
  transfer?: Maybe<Transfer>;
  /** updated_at is the last update timestamp */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** vat_status is the VAT completeness status (from ES) */
  vatDetails?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_VatDetails>;
  walletToWallet?: Maybe<WalletToWallet>;
};

/** TransactionAttachmentStatus contains attachment status for a single transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus';
  /** attachment_lost indicates whether attachment was lost or not required (from ES) */
  attachmentLost: Scalars['Boolean']['output'];
  /** attachment_required indicates whether an attachment is required */
  attachmentRequired: Scalars['Boolean']['output'];
  /** attachment_suggestion_ids is the list of suggested attachment IDs (top 5 matches) */
  attachmentSuggestionIds: Array<Scalars['String']['output']>;
  /** automatically_added_attachment_ids is the list of automatically added attachment IDs */
  automaticallyAddedAttachmentIds: Array<Scalars['String']['output']>;
  /** transaction_id is the transaction this status belongs to */
  transactionId: Scalars['String']['output'];
};

/** TransactionAttachmentStatus contains attachment status for a single transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatusInput = {
  /** attachment_lost indicates whether attachment was lost or not required (from ES) */
  attachmentLost?: InputMaybe<Scalars['Boolean']['input']>;
  /** attachment_required indicates whether an attachment is required */
  attachmentRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** attachment_suggestion_ids is the list of suggested attachment IDs (top 5 matches) */
  attachmentSuggestionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** automatically_added_attachment_ids is the list of automatically added attachment IDs */
  automaticallyAddedAttachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** transaction_id is the transaction this status belongs to */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Transaction represents a slim transaction record with core fields only */
export type QontoAppSystemsTransactionsFirstpartyV8_TransactionInput = {
  /** activity_tag is the activity classification */
  activityTag?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_ActivityTag>;
  /** amount is the transaction amount */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** attachment_ids is the list of attachment IDs (from ES) */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** attachment_request groups the attachment request state (requested, requested_at, requested_by_id) */
  attachmentRequest?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequestInput>;
  /** authorization_type is the authorization type (only present for pending transactions) */
  authorizationType?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_AuthorizationType>;
  /** bank_account_id is the associated bank account ID */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** counterparty contains the counterparty (recipient/sender) details */
  counterparty?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_CounterpartyInput>;
  /** counterparty_name returns the clean counterparty name or a translated counterparty name for system transactions, like biller fees */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** created_at is the timestamp of when the transaction record was created in the DB */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** declined_reason is the reason for decline (if applicable) */
  declinedReason?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason>;
  /** description is the transaction description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** display_at is the display timestamp = settled_at || emitted_at */
  displayAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** emitted_at is when the movement that the transaction represents was emitted in the CBS */
  emittedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** excluded_from_analytics indicates exclusion from analytics (from ES) */
  excludedFromAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  /** fx indicates whether the transaction involves foreign exchange */
  fx?: InputMaybe<Scalars['Boolean']['input']>;
  /** fx_rate is the foreign exchange rate (if applicable) */
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  /** has_attachment indicates whether the transaction has an attachment (from ES) */
  hasAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  /** id is the unique identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** initiator_id is the ID of the initiating user */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** is_atm indicates whether this is an ATM transaction */
  isAtm?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_external_transaction indicates whether this is an external transaction */
  isExternalTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_merged_fee indicates whether this is a merged fee transaction (from ES) */
  isMergedFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_pos indicates whether this is a point-of-sale transaction */
  isPos?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_proxied indicates whether this is a proxied F24 payment */
  isProxied?: InputMaybe<Scalars['Boolean']['input']>;
  /** label_ids is the list of label IDs (from ES) */
  labelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** local_amount is the amount in local currency */
  localAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** merged_fees_id is the ID of merged fees (if applicable) */
  mergedFeesId?: InputMaybe<Scalars['String']['input']>;
  /** note is a user-provided note */
  note?: InputMaybe<Scalars['String']['input']>;
  /** operation_method is the payment method */
  operationMethod?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_OperationMethod>;
  /** operation_type is the operation classification */
  operationType?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_OperationType>;
  /** organization_id is sourced from Elasticsearch response */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** provider_object_id is the provider's object identifier */
  providerObjectId?: InputMaybe<Scalars['String']['input']>;
  /** qualified_for_accounting indicates accounting eligibility (from ES) */
  qualifiedForAccounting?: InputMaybe<Scalars['Boolean']['input']>;
  /** raw_counterparty_name is the unprocessed counterparty name */
  rawCounterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** related_transaction_id is the ID of a related transaction */
  relatedTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** settled_at is when the transaction was settled in the CBS */
  settledAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** settled_balance is the account balance after settlement */
  settledBalance?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** side is the transaction direction (debit/credit) */
  side?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_Side>;
  /** slug is the human-readable identifier */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** status is the transaction status */
  status?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus>;
  /** status_history is the list of status transitions (computed from emitted_at/settled_at) */
  statusHistory?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryInput>>;
  /** Depolymorphized subject fields — each maps to subject_id or provider_object_id based on subject_type */
  subjectReference?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SubjectReferenceInput>;
  /** subject_type is the subject entity type (note: BillingTransfer is remapped to WalletToWallet) */
  subjectType?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SubjectType>;
  /** updated_at is the last update timestamp */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** vat_status is the VAT completeness status (from ES) */
  vatDetails?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_VatDetailsInput>;
};

/** TransactionStatus defines the lifecycle status of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus {
  /** TRANSACTION_STATUS_COMPLETED is a successfully completed transaction */
  TransactionStatusCompleted = 'TRANSACTION_STATUS_COMPLETED',
  /** TRANSACTION_STATUS_DECLINED is a declined transaction */
  TransactionStatusDeclined = 'TRANSACTION_STATUS_DECLINED',
  /** TRANSACTION_STATUS_PENDING is a transaction awaiting settlement */
  TransactionStatusPending = 'TRANSACTION_STATUS_PENDING',
  /** TRANSACTION_STATUS_REVERSED is a reversed transaction */
  TransactionStatusReversed = 'TRANSACTION_STATUS_REVERSED',
  /** TRANSACTION_STATUS_UNSPECIFIED is the default unspecified value */
  TransactionStatusUnspecified = 'TRANSACTION_STATUS_UNSPECIFIED'
}

/** Value represents a filter value of any supported primitive type */
export type QontoAppSystemsTransactionsFirstpartyV8_Value = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Value';
  /** boolean_value is a boolean value */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  /** float_value is a float value */
  floatValue?: Maybe<Scalars['Float']['output']>;
  /** integer_value is an integer value */
  integerValue?: Maybe<Scalars['Int64']['output']>;
  /** string_value is a string value */
  stringValue?: Maybe<Scalars['String']['output']>;
};

/** Value represents a filter value of any supported primitive type */
export type QontoAppSystemsTransactionsFirstpartyV8_ValueInput = {
  /** boolean_value is a boolean value */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** float_value is a float value */
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  /** integer_value is an integer value */
  integerValue?: InputMaybe<Scalars['Int64']['input']>;
  /** string_value is a string value */
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** VatDetails contains VAT details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_VatDetails = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatDetails';
  /** items is the list of VAT line items */
  items: Array<QontoAppSystemsTransactionsFirstpartyV8_VatItem>;
  /** status is the VAT status of the transaction */
  status: QontoAppSystemsTransactionsFirstpartyV8_VatStatus;
  /** total_amount is the total VAT amount */
  totalAmount?: Maybe<QontoCommon_CurrencyAmount>;
};

/** VatDetails contains VAT details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_VatDetailsInput = {
  /** items is the list of VAT line items */
  items?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_VatItemInput>>;
  /** status is the VAT status of the transaction */
  status?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_VatStatus>;
  /** total_amount is the total VAT amount */
  totalAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
};

/** VatItem represents a single VAT line item */
export type QontoAppSystemsTransactionsFirstpartyV8_VatItem = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatItem';
  /** amount is the VAT amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** amount_excluding_vat is the amount excluding VAT */
  amountExcludingVat?: Maybe<QontoCommon_CurrencyAmount>;
  /** id is the VAT item ID */
  id: Scalars['String']['output'];
  /** rate is the VAT rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** source is the source of the VAT item */
  source?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_VatItemSource>;
};

/** VatItem represents a single VAT line item */
export type QontoAppSystemsTransactionsFirstpartyV8_VatItemInput = {
  /** amount is the VAT amount */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** amount_excluding_vat is the amount excluding VAT */
  amountExcludingVat?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** id is the VAT item ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** rate is the VAT rate */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** source is the source of the VAT item */
  source?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_VatItemSource>;
};

/** VatItemSource defines how a vat item was created */
export enum QontoAppSystemsTransactionsFirstpartyV8_VatItemSource {
  /** VAT_ITEM_SOURCE_FROM_RECEIVABLE_INVOICING is a source from receivable invoicing */
  VatItemSourceFromReceivableInvoicing = 'VAT_ITEM_SOURCE_FROM_RECEIVABLE_INVOICING',
  /** VAT_ITEM_SOURCE_OCR is an OCR source */
  VatItemSourceOcr = 'VAT_ITEM_SOURCE_OCR',
  /** VAT_ITEM_SOURCE_QONTO is a Qonto source */
  VatItemSourceQonto = 'VAT_ITEM_SOURCE_QONTO',
  /** VAT_ITEM_SOURCE_TAX_AUTHORITY is a tax authority source */
  VatItemSourceTaxAuthority = 'VAT_ITEM_SOURCE_TAX_AUTHORITY',
  /** VAT_ITEM_SOURCE_UNKNOWN is an unknown source */
  VatItemSourceUnknown = 'VAT_ITEM_SOURCE_UNKNOWN',
  /** VAT_ITEM_SOURCE_UNSPECIFIED is the default unspecified value */
  VatItemSourceUnspecified = 'VAT_ITEM_SOURCE_UNSPECIFIED',
  /** VAT_ITEM_SOURCE_USER is a user-provided source */
  VatItemSourceUser = 'VAT_ITEM_SOURCE_USER'
}

/** VatStatus defines the VAT detection completeness status of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_VatStatus {
  /** VAT_STATUS_AUTO is an automatically detected VAT value */
  VatStatusAuto = 'VAT_STATUS_AUTO',
  /** VAT_STATUS_CONFIRMED is a confirmed VAT value */
  VatStatusConfirmed = 'VAT_STATUS_CONFIRMED',
  /** VAT_STATUS_DETECTING is VAT detection in progress */
  VatStatusDetecting = 'VAT_STATUS_DETECTING',
  /** VAT_STATUS_DETECTION_ERROR is the status when VAT detection failed */
  VatStatusDetectionError = 'VAT_STATUS_DETECTION_ERROR',
  /** VAT_STATUS_INHERITED_FROM_BENEFICIARY is a VAT value inherited from the beneficiary */
  VatStatusInheritedFromBeneficiary = 'VAT_STATUS_INHERITED_FROM_BENEFICIARY',
  /** VAT_STATUS_MANUAL is a manually set VAT status */
  VatStatusManual = 'VAT_STATUS_MANUAL',
  /** VAT_STATUS_NOT_FOUND is the status when no VAT rate was found */
  VatStatusNotFound = 'VAT_STATUS_NOT_FOUND',
  /** VAT_STATUS_OVERRIDDEN is a VAT value that was overridden by the user */
  VatStatusOverridden = 'VAT_STATUS_OVERRIDDEN',
  /** VAT_STATUS_SUGGESTED is a VAT value suggested by the system */
  VatStatusSuggested = 'VAT_STATUS_SUGGESTED',
  /** VAT_STATUS_UNSPECIFIED is the default unspecified value */
  VatStatusUnspecified = 'VAT_STATUS_UNSPECIFIED'
}

/** Request to cancel a subscription by ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionRequest';
  /** The payment link ID (from path parameter) */
  paymentLinkId: Scalars['String']['output'];
  /** The subscription ID to terminate (from path parameter) */
  subscriptionId: Scalars['String']['output'];
};

/** Request to cancel a subscription by ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionRequestInput = {
  /** The payment link ID (from path parameter) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription ID to terminate (from path parameter) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Response when a subscription is successfully canceled */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionResponse';
  /** Subscription data */
  subscription?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription>;
};

/** Response when a subscription is successfully canceled */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionResponseInput = {
  /** Subscription data */
  subscription?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriptionInput>;
};

/** Request to create a checkout link for a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutRequest';
  /** Token if the selected payment method is a credit card. Required if the payment method is credit_card. */
  creditCardToken?: Maybe<Scalars['String']['output']>;
  /** Locale for the checkout link (BCP 47 language tag format) */
  locale: Scalars['String']['output'];
  /** Payment method for the checkout link (Bank transfer is not allowed here) */
  paymentMethod: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod;
  /** ID of the resource associated with the payment link */
  resourceId: Scalars['String']['output'];
  /**
   * Shopper Info
   * Email of the shopper (required if payment link is of type basket)
   */
  shopperEmail?: Maybe<Scalars['String']['output']>;
  /** First name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperLastName?: Maybe<Scalars['String']['output']>;
};

/** Request to create a checkout link for a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutRequestInput = {
  /** Token if the selected payment method is a credit card. Required if the payment method is credit_card. */
  creditCardToken?: InputMaybe<Scalars['String']['input']>;
  /** Locale for the checkout link (BCP 47 language tag format) */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Payment method for the checkout link (Bank transfer is not allowed here) */
  paymentMethod?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** ID of the resource associated with the payment link */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Shopper Info
   * Email of the shopper (required if payment link is of type basket)
   */
  shopperEmail?: InputMaybe<Scalars['String']['input']>;
  /** First name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperLastName?: InputMaybe<Scalars['String']['input']>;
};

/** Response when a checkout link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutResponse';
  /** URL of the checkout link */
  paymentLink: Scalars['String']['output'];
};

/** Response when a checkout link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutResponseInput = {
  /** URL of the checkout link */
  paymentLink?: InputMaybe<Scalars['String']['input']>;
};

/** Request to create a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkRequest';
  /** Payment amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Debitor name (can be null, required if resource_type is Invoice) */
  debitorName?: Maybe<Scalars['String']['output']>;
  /** Items in the basket (can be null, required if resource_type is Basket) */
  items: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreate>;
  /** Organization name (can be null) */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Payment initiator information */
  paymentInitiator?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreate>;
  /** List of potential payment methods (at least one required) */
  potentialPaymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Recurrency settings (can be nullable if not a recurrent payment link) */
  recurrenceSettings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings>;
  /** Payment link settings (can be null) */
  settings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings>;
};

/** Request to create a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkRequestInput = {
  /** Payment amount */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Debitor name (can be null, required if resource_type is Invoice) */
  debitorName?: InputMaybe<Scalars['String']['input']>;
  /** Items in the basket (can be null, required if resource_type is Basket) */
  items?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreateInput>>;
  /** Organization name (can be null) */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Payment initiator information */
  paymentInitiator?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreateInput>;
  /** List of potential payment methods (at least one required) */
  potentialPaymentMethods?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>>;
  /** Recurrency settings (can be nullable if not a recurrent payment link) */
  recurrenceSettings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettingsInput>;
  /** Payment link settings (can be null) */
  settings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettingsInput>;
};

/** Response when a payment link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkResponse';
  /** The created payment link */
  paymentLink?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Response when a payment link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkResponseInput = {
  /** The created payment link */
  paymentLink?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>;
};

/** Request message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkRequest';
  /** The unique identifier for the payment link (from path parameter) */
  paymentLinkId: Scalars['String']['output'];
};

/** Request message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkRequestInput = {
  /** The unique identifier for the payment link (from path parameter) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkResponse';
  /** The deactivated payment link */
  paymentLink?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Response message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkResponseInput = {
  /** The deactivated payment link */
  paymentLink?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>;
};

/** Enum for subscription recurrency */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence {
  /** monthly frequency */
  FrequencyRecurrenceMonthly = 'FREQUENCY_RECURRENCE_MONTHLY',
  /** quarterly frequency */
  FrequencyRecurrenceQuarterly = 'FREQUENCY_RECURRENCE_QUARTERLY',
  /** semesterly frequency */
  FrequencyRecurrenceSemesterly = 'FREQUENCY_RECURRENCE_SEMESTERLY',
  /** Default unspecified value for unknown or unrecognized frequency */
  FrequencyRecurrenceUnspecified = 'FREQUENCY_RECURRENCE_UNSPECIFIED',
  /** weekly frequency */
  FrequencyRecurrenceWeekly = 'FREQUENCY_RECURRENCE_WEEKLY',
  /** yearly frequency */
  FrequencyRecurrenceYearly = 'FREQUENCY_RECURRENCE_YEARLY'
}

/** Request message for GetPaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIDRequest';
  /** Payment link ID (UUID format) */
  paymentLinkId: Scalars['String']['output'];
};

/** Request message for GetPaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdRequestInput = {
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for retrieving a single payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIDResponse';
  /** Payment link data */
  paymentLink?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Response message for retrieving a single payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdResponseInput = {
  /** Payment link data */
  paymentLink?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>;
};

/** Request message for retrieving a payment link by resource scope and resource ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest';
  /** The ID of the resource */
  resourceId: Scalars['String']['output'];
  /** Scope of the resource */
  resourceScope: QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest_ResourceScope;
};

/** Request message for retrieving a payment link by resource scope and resource ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequestInput = {
  /** The ID of the resource */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Scope of the resource */
  resourceScope?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest_ResourceScope>;
};

/** Represents the type of a resource in path. */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest_ResourceScope {
  /** Default unspecified value for unknown or unrecognized resource type */
  ResourceScopeUnspecified = 'RESOURCE_SCOPE_UNSPECIFIED',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Basket resource.
   */
  Baskets = 'baskets',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Invoice resource.
   */
  Invoices = 'invoices'
}

/** Message for payment link attributes */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdResponse';
  /** Payment link details */
  paymentLink?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Message for payment link attributes */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdResponseInput = {
  /** Payment link details */
  paymentLink?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>;
};

/** Message for payment link checkout */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutRequest';
  /** The unique identifier for the checkout */
  resourceId: Scalars['String']['output'];
};

/** Message for payment link checkout */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutRequestInput = {
  /** The unique identifier for the checkout */
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

/** Message for payment link checkout response */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutResponse';
  /** The payment link */
  paymentLink?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
  /** ID of the profile associated with the payment link */
  profileId: Scalars['String']['output'];
};

/** Message for payment link checkout response */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutResponseInput = {
  /** The payment link */
  paymentLink?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>;
  /** ID of the profile associated with the payment link */
  profileId?: InputMaybe<Scalars['String']['input']>;
};

/** Request message for GetSubscriptionByID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIDRequest';
  /** Payment link ID (UUID format) */
  paymentLinkId: Scalars['String']['output'];
  /** Subscription ID (UUID format) */
  subscriptionId: Scalars['String']['output'];
};

/** Request message for GetSubscriptionByID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdRequestInput = {
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /** Subscription ID (UUID format) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for retrieving a single subscription of a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIDResponse';
  /** Subscription data */
  subscription?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription>;
};

/** Response message for retrieving a single subscription of a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdResponseInput = {
  /** Subscription data */
  subscription?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriptionInput>;
};

/** Enum for item type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType {
  /** Good item type */
  ItemTypeGood = 'ITEM_TYPE_GOOD',
  /** Service item type */
  ItemTypeService = 'ITEM_TYPE_SERVICE',
  /** Default unspecified value for unknown or unrecognized item type */
  ItemTypeUnspecified = 'ITEM_TYPE_UNSPECIFIED'
}

/** Message for payment method */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Method = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Method';
  /** Whether the payment method is eligible based on the input resource type + is_recurrent. */
  eligible: Scalars['Boolean']['output'];
  /** Whether the payment method is enabled for the provided filters. */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier for the payment method. */
  id: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod;
  /** The activation status of the payment method. */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethodStatus;
};

/** Message for payment method */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_MethodInput = {
  /** Whether the payment method is eligible based on the input resource type + is_recurrent. */
  eligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the payment method is enabled for the provided filters. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the payment method. */
  id?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** The activation status of the payment method. */
  status?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethodStatus>;
};

/** Message for a payment */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment';
  /** Payment amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Payment ID */
  id: Scalars['String']['output'];
  /** Payment completion timestamp */
  paidAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Payment method used */
  paymentMethod: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod;
  /** Payment status */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus;
};

/** Message for payment initiator information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator';
  /** Resource ID */
  resourceId: Scalars['String']['output'];
  /** Resource number (can be null) */
  resourceNumber?: Maybe<Scalars['String']['output']>;
  /** Resource type */
  resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType;
};

/** Payment initiator data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreate = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreate';
  /** Resource ID (can be null, required if resource_type is Invoice) */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Resource number (can be null) */
  resourceNumber?: Maybe<Scalars['String']['output']>;
  /** Resource type */
  resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType;
};

/** Payment initiator data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreateInput = {
  /** Resource ID (can be null, required if resource_type is Invoice) */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Resource number (can be null) */
  resourceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
};

/** Message for payment initiator information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorInput = {
  /** Resource ID */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Resource number (can be null) */
  resourceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
};

/** Message for a payment */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInput = {
  /** Payment amount */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Creation timestamp */
  createdAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Payment ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Payment completion timestamp */
  paidAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Payment method used */
  paymentMethod?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Payment status */
  status?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus>;
};

/** Message for payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink';
  /** Payment amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Debitor name (can be null) */
  debitorName?: Maybe<Scalars['String']['output']>;
  /** Expiration date */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the payment link */
  id: Scalars['String']['output'];
  /** Payment link items */
  items: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem>;
  /** Latest payment method used (can be null) */
  latestPaymentMethod?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Payment link name */
  name: Scalars['String']['output'];
  /** Organization name (can be null) */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Payment initiator information */
  paymentInitiator?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator>;
  /** List of potential payment methods */
  potentialPaymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Recurrence settings (required when it is a recurrent payment link) */
  recurrenceSettings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings>;
  /** Payment link recurrence type */
  recurrenceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType;
  /** Payment link settings (can be null) */
  settings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings>;
  /** Payment link status */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus;
};

/** Message for payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput = {
  /** Payment amount */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Creation timestamp */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Debitor name (can be null) */
  debitorName?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date */
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the payment link */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Payment link items */
  items?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemInput>>;
  /** Latest payment method used (can be null) */
  latestPaymentMethod?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Payment link name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization name (can be null) */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Payment initiator information */
  paymentInitiator?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorInput>;
  /** List of potential payment methods */
  potentialPaymentMethods?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>>;
  /** Recurrence settings (required when it is a recurrent payment link) */
  recurrenceSettings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettingsInput>;
  /** Payment link recurrence type */
  recurrenceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>;
  /** Payment link settings (can be null) */
  settings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettingsInput>;
  /** Payment link status */
  status?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus>;
};

/** Message for payment link item */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem';
  /** Item description */
  description?: Maybe<Scalars['String']['output']>;
  /** Item ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Measurement unit */
  measureUnit?: Maybe<Scalars['String']['output']>;
  /** Item quantity */
  quantity: Scalars['Float']['output'];
  /** Item title */
  title: Scalars['String']['output'];
  /** Item type */
  type?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice?: Maybe<QontoCommon_CurrencyAmount>;
  /** VAT rate */
  vatRate: Scalars['String']['output'];
};

/** Payment link item data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreate = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreate';
  /** Item description (can be null) */
  description?: Maybe<Scalars['String']['output']>;
  /** Measurement unit (can be null) */
  measureUnit?: Maybe<Scalars['String']['output']>;
  /** Item quantity */
  quantity: Scalars['Float']['output'];
  /** Item title */
  title: Scalars['String']['output'];
  /** Item type (can be null) */
  type?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice?: Maybe<QontoCommon_CurrencyAmount>;
  /** VAT rate */
  vatRate: Scalars['String']['output'];
};

/** Payment link item data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreateInput = {
  /** Item description (can be null) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Measurement unit (can be null) */
  measureUnit?: InputMaybe<Scalars['String']['input']>;
  /** Item quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Item title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Item type (can be null) */
  type?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** VAT rate */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** Message for payment link item */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemInput = {
  /** Item description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Item ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Measurement unit */
  measureUnit?: InputMaybe<Scalars['String']['input']>;
  /** Item quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Item title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Item type */
  type?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** VAT rate */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for Payment Link recurrence type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType {
  /** One-off payment link recurrence type */
  PaymentLinkRecurrenceTypeOneOff = 'PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF',
  /** Recurring payment link recurrence type */
  PaymentLinkRecurrenceTypeRecurring = 'PAYMENT_LINK_RECURRENCE_TYPE_RECURRING',
  /** Default unspecified value for unknown or unrecognized payment link recurrence type */
  PaymentLinkRecurrenceTypeUnspecified = 'PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED'
}

/** Message for payment link settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings';
  /** How many number of payments/subscriptions can be done out of a payment link. If not provided: reusable payment link */
  limit?: Maybe<Scalars['Int']['output']>;
  /** URL to redirect to after payment */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Message for payment link settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettingsInput = {
  /** How many number of payments/subscriptions can be done out of a payment link. If not provided: reusable payment link */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** URL to redirect to after payment */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for payment link status */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus {
  /** Payment link has been canceled */
  PaymentLinkStatusCanceled = 'PAYMENT_LINK_STATUS_CANCELED',
  /** Payment link has expired */
  PaymentLinkStatusExpired = 'PAYMENT_LINK_STATUS_EXPIRED',
  /** Payment link is open for payments */
  PaymentLinkStatusOpen = 'PAYMENT_LINK_STATUS_OPEN',
  /** Payment link has been paid */
  PaymentLinkStatusPaid = 'PAYMENT_LINK_STATUS_PAID',
  /** Payment link is processing */
  PaymentLinkStatusProcessing = 'PAYMENT_LINK_STATUS_PROCESSING',
  /** Default unspecified value for unknown or unrecognized status */
  PaymentLinkStatusUnspecified = 'PAYMENT_LINK_STATUS_UNSPECIFIED'
}

/** Enum for payment methods */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod {
  /** Apple Pay payment method */
  PaymentMethodApplePay = 'PAYMENT_METHOD_APPLE_PAY',
  /** Bank transfer payment method */
  PaymentMethodBankTransfer = 'PAYMENT_METHOD_BANK_TRANSFER',
  /** Credit card payment method */
  PaymentMethodCreditCard = 'PAYMENT_METHOD_CREDIT_CARD',
  /** iDEAL payment method */
  PaymentMethodIdeal = 'PAYMENT_METHOD_IDEAL',
  /** PayPal payment method */
  PaymentMethodPaypal = 'PAYMENT_METHOD_PAYPAL',
  /** Default unspecified value for unknown or unrecognized payment method */
  PaymentMethodUnspecified = 'PAYMENT_METHOD_UNSPECIFIED'
}

/** The status of the payment method. */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethodStatus {
  /** Method is active. */
  PaymentMethodStatusActive = 'PAYMENT_METHOD_STATUS_ACTIVE',
  /** Method is inactive. */
  PaymentMethodStatusInactive = 'PAYMENT_METHOD_STATUS_INACTIVE',
  /** Method is pending external processing. */
  PaymentMethodStatusPendingExternal = 'PAYMENT_METHOD_STATUS_PENDING_EXTERNAL',
  /** Method is pending onboarding. */
  PaymentMethodStatusPendingOnboarding = 'PAYMENT_METHOD_STATUS_PENDING_ONBOARDING',
  /** Method is pending review. */
  PaymentMethodStatusPendingReview = 'PAYMENT_METHOD_STATUS_PENDING_REVIEW',
  /** Method was rejected. */
  PaymentMethodStatusRejected = 'PAYMENT_METHOD_STATUS_REJECTED',
  /** Unspecified method status. */
  PaymentMethodStatusUnspecified = 'PAYMENT_METHOD_STATUS_UNSPECIFIED'
}

/** Enum for payment status */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus {
  /** Payment canceled */
  PaymentStatusCanceled = 'PAYMENT_STATUS_CANCELED',
  /** Payment expired */
  PaymentStatusExpired = 'PAYMENT_STATUS_EXPIRED',
  /** Payment failed */
  PaymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  /** Payment is open */
  PaymentStatusOpen = 'PAYMENT_STATUS_OPEN',
  /** Payment is paid */
  PaymentStatusPaid = 'PAYMENT_STATUS_PAID',
  /** Payment status Default unspecified value */
  PaymentStatusUnspecified = 'PAYMENT_STATUS_UNSPECIFIED'
}

/** Message for recurrence settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings';
  /** Frequency recurrence - required when payment link type is recurring */
  frequencyRecurrence: QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence;
  /** Frequency value - required when payment link type is recurring, min=1 */
  frequencyValue: Scalars['Int']['output'];
  /** Total number of payments for the subscription - optional, min=1, max=9999 */
  times?: Maybe<Scalars['Int']['output']>;
};

/** Message for recurrence settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettingsInput = {
  /** Frequency recurrence - required when payment link type is recurring */
  frequencyRecurrence?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence>;
  /** Frequency value - required when payment link type is recurring, min=1 */
  frequencyValue?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of payments for the subscription - optional, min=1, max=9999 */
  times?: InputMaybe<Scalars['Int']['input']>;
};

/** Enum for resource type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType {
  /** Basket resource type */
  ResourceTypeBasket = 'RESOURCE_TYPE_BASKET',
  /** Invoice resource type */
  ResourceTypeInvoice = 'RESOURCE_TYPE_INVOICE',
  /** Default unspecified value for unknown or unrecognized resource type */
  ResourceTypeUnspecified = 'RESOURCE_TYPE_UNSPECIFIED'
}

/** Request message for GetPaymentLinks */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest';
  /** Filters parameters for payment links (can be null) */
  filters?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFilters>;
  /** Pagination parameters (can be null) */
  paginationInput?: Maybe<QontoCommon_PaginationInput>;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest_SortField>;
};

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFilters = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFilters';
  /** Filter by payment link type. */
  paymentLinkRecurrenceType: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>;
  /** Filter by resource IDs (from payment initiator) */
  resourceIds: Array<Scalars['String']['output']>;
  /** Filter by resource type (from payment initiator) */
  resourceType?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
  /** Filters by payment link status - array of statuses */
  status: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus>;
};

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFiltersInput = {
  /** Filter by payment link type. */
  paymentLinkRecurrenceType?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>>;
  /** Filter by resource IDs (from payment initiator) */
  resourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by resource type (from payment initiator) */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
  /** Filters by payment link status - array of statuses */
  status?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus>>;
};

/** Request message for GetPaymentLinks */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestInput = {
  /** Filters parameters for payment links (can be null) */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFiltersInput>;
  /** Pagination parameters (can be null) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest_SortField>>;
};

/** Enum for sort fields */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest_SortField {
  /** Sort by amount ASC */
  SortFieldAmountAsc = 'SORT_FIELD_AMOUNT_ASC',
  /** Sort by amount DESC */
  SortFieldAmountDesc = 'SORT_FIELD_AMOUNT_DESC',
  /** Sort by created at ASC */
  SortFieldCreatedAtAsc = 'SORT_FIELD_CREATED_AT_ASC',
  /** Sort by created at DESC */
  SortFieldCreatedAtDesc = 'SORT_FIELD_CREATED_AT_DESC',
  /** Sort by name ASC */
  SortFieldNameAsc = 'SORT_FIELD_NAME_ASC',
  /** Sort by name DESC */
  SortFieldNameDesc = 'SORT_FIELD_NAME_DESC',
  /** Default unspecified value for unknown or unrecognized sort field */
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

/** Response message for retrieving payment links */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksResponse';
  /** Pagination metadata */
  pagination?: Maybe<QontoCommon_PaginationMeta>;
  /** Array of payment links */
  paymentLinks: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Response message for retrieving payment links */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksResponseInput = {
  /** Pagination metadata */
  pagination?: InputMaybe<QontoCommon_PaginationMetaInput>;
  /** Array of payment links */
  paymentLinks?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkInput>>;
};

/** Request message to retrieve available payment methods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequest';
  /** Filter for payment methods. */
  filters?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFilters>;
};

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFilters = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFilters';
  /** Filter by amount. */
  amount?: Maybe<Scalars['String']['output']>;
  /** Filter by currency. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Filter by locale. */
  locale?: Maybe<Scalars['String']['output']>;
  /** Filter by payment link recurrence type. */
  paymentLinkRecurrenceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType;
  /** Filter by resource type. */
  resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType;
};

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFiltersInput = {
  /** Filter by amount. */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Filter by currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Filter by locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment link recurrence type. */
  paymentLinkRecurrenceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>;
  /** Filter by resource type. */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
};

/** Request message to retrieve available payment methods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestInput = {
  /** Filter for payment methods. */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFiltersInput>;
};

/** Response message for ListPaymentMethods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsResponse';
  /** List of payment methods. */
  paymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Method>;
};

/** Response message for ListPaymentMethods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsResponseInput = {
  /** List of payment methods. */
  paymentMethods?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_MethodInput>>;
};

/** Request message for SearchSubscriptionPayments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest';
  /** Filters parameters (optional) */
  filters?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFilters>;
  /** Pagination parameters (optional) */
  paginationInput?: Maybe<QontoCommon_PaginationInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId: Scalars['String']['output'];
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest_SortField>;
  /** Subscription ID (UUID format) */
  subscriptionId: Scalars['String']['output'];
};

/** Message for search subscription payments filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFilters = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFilters';
  /** Filter by payment status - array of statuses. The absence of value, will return everything. */
  status: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus>;
};

/** Message for search subscription payments filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFiltersInput = {
  /** Filter by payment status - array of statuses. The absence of value, will return everything. */
  status?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus>>;
};

/** Request message for SearchSubscriptionPayments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestInput = {
  /** Filters parameters (optional) */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFiltersInput>;
  /** Pagination parameters (optional) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest_SortField>>;
  /** Subscription ID (UUID format) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for sort fields for search subscription payments request */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest_SortField {
  /** Sort by created at ASC */
  SortFieldCreatedAtAsc = 'SORT_FIELD_CREATED_AT_ASC',
  /** Sort by created at DESC */
  SortFieldCreatedAtDesc = 'SORT_FIELD_CREATED_AT_DESC',
  /** Default unspecified value for unknown or unrecognized sort field */
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

/** Response message for searching subscription payments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsResponse';
  /** Pagination metadata */
  pagination?: Maybe<QontoCommon_PaginationMeta>;
  /** Array of payments related to the subscription */
  payments: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment>;
};

/** Response message for searching subscription payments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsResponseInput = {
  /** Pagination metadata */
  pagination?: InputMaybe<QontoCommon_PaginationMetaInput>;
  /** Array of payments related to the subscription */
  payments?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInput>>;
};

/** Request message for SearchSubscriptions */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsRequest = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsRequest';
  /** Pagination parameters (optional) */
  paginationInput?: Maybe<QontoCommon_PaginationInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId: Scalars['String']['output'];
};

/** Request message for SearchSubscriptions */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsRequestInput = {
  /** Pagination parameters (optional) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response message for retrieving subscriptions
 * By default it is sorted by: active DESC, first_name ASC, last_name ASC
 */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsResponse';
  /** Pagination metadata */
  pagination?: Maybe<QontoCommon_PaginationMeta>;
  /** Array of subscriptions */
  subscriptions: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription>;
};

/**
 * Response message for retrieving subscriptions
 * By default it is sorted by: active DESC, first_name ASC, last_name ASC
 */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsResponseInput = {
  /** Pagination metadata */
  pagination?: InputMaybe<QontoCommon_PaginationMetaInput>;
  /** Array of subscriptions */
  subscriptions?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriptionInput>>;
};

/** Message for subscription subscriber information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber';
  /** Subscriber's email address */
  email: Scalars['String']['output'];
  /** Subscriber's first name */
  firstName: Scalars['String']['output'];
  /** Subscriber's last name */
  lastName: Scalars['String']['output'];
};

/** Message for subscription subscriber information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriberInput = {
  /** Subscriber's email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Message for subscription */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription';
  /** Whether the subscription is active */
  active: Scalars['Boolean']['output'];
  /** Subscription ID */
  id: Scalars['String']['output'];
  /** Subscriber information */
  subscriber?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber>;
};

/** Message for subscription */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriptionInput = {
  /** Whether the subscription is active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subscription ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Subscriber information */
  subscriber?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SubscriberInput>;
};

/**
 * Represents a currency amount according to
 * https://www.w3.org/TR/payment-request/#paymentcurrencyamount-dictionary.
 */
export type QontoCommon_CurrencyAmount = {
  __typename?: 'QontoCommon_CurrencyAmount';
  /** The ISO 4217 currency code of the currency in which `value` is denoted. */
  currency: Scalars['String']['output'];
  /** The value in major units of `currency`, as a decimal string. */
  value: Scalars['String']['output'];
};

/**
 * Represents a currency amount according to
 * https://www.w3.org/TR/payment-request/#paymentcurrencyamount-dictionary.
 */
export type QontoCommon_CurrencyAmountInput = {
  /** The ISO 4217 currency code of the currency in which `value` is denoted. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The value in major units of `currency`, as a decimal string. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Pagination option for controlling result set size and position */
export type QontoCommon_PaginationInput = {
  __typename?: 'QontoCommon_PaginationInput';
  /** Cursor token for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Page number for page-based pagination (starts at 1) */
  page?: Maybe<Scalars['Int64']['output']>;
  /** Number of results to return per page */
  perPage: Scalars['Int']['output'];
};

/** Pagination option for controlling result set size and position */
export type QontoCommon_PaginationInputInput = {
  /** Cursor token for cursor-based pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page number for page-based pagination (starts at 1) */
  page?: InputMaybe<Scalars['Int64']['input']>;
  /** Number of results to return per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Represents pagination metadata
 * It uses camel case so it may not be suitable for endpoints defined before proto standard
 */
export type QontoCommon_PaginationMeta = {
  __typename?: 'QontoCommon_PaginationMeta';
  /** Current page number */
  currentPage: Scalars['Int']['output'];
  /** Cursor token for fetching the next set of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Next page number (null if no next page) */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of results per page */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if no previous page) */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of orders */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/**
 * Represents pagination metadata
 * It uses camel case so it may not be suitable for endpoints defined before proto standard
 */
export type QontoCommon_PaginationMetaInput = {
  /** Current page number */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor token for fetching the next set of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Next page number (null if no next page) */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if no previous page) */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of orders */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/** Individual error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_Error = {
  __typename?: 'QontoHttpJson_Error';
  /** An application-specific error code, expressed as a string value. */
  code?: Maybe<Scalars['String']['output']>;
  /** A human-readable explanation specific to this occurrence of the problem. Like title, this field’s value can be localized. */
  detail?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for this particular occurrence of the problem. */
  id?: Maybe<Scalars['String']['output']>;
  /** An object containing non-standard meta-information about the error. */
  meta?: Maybe<Scalars['GoogleProtobuf_Struct']['output']>;
  /** A Source message containing references to the primary source of the error. */
  source?: Maybe<QontoHttpJson_Error_Source>;
  /** The HTTP status code applicable to this problem, expressed as a string value. This SHOULD be provided. */
  status?: Maybe<Scalars['String']['output']>;
  /** A short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Individual error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_ErrorInput = {
  /** An application-specific error code, expressed as a string value. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** A human-readable explanation specific to this occurrence of the problem. Like title, this field’s value can be localized. */
  detail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for this particular occurrence of the problem. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** An object containing non-standard meta-information about the error. */
  meta?: InputMaybe<Scalars['GoogleProtobuf_StructInput']['input']>;
  /** A Source message containing references to the primary source of the error. */
  source?: InputMaybe<QontoHttpJson_Error_SourceInput>;
  /** The HTTP status code applicable to this problem, expressed as a string value. This SHOULD be provided. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** A short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Source objects provide references to the source of an error in the request document. */
export type QontoHttpJson_Error_Source = {
  __typename?: 'QontoHttpJson_Error_Source';
  /** A string indicating the name of a single request header which caused the error. */
  header?: Maybe<Scalars['String']['output']>;
  /** A string indicating which URI query parameter caused the error. */
  parameter?: Maybe<Scalars['String']['output']>;
  /** A JSON Pointer [RFC6901] to the value in the request document that caused the error [e.g. "/data" for a primary data object, or "/data/attributes/title" for a specific attribute]. This MUST point to a value in the request document that exists; if it doesn’t, the client SHOULD simply ignore the pointer. */
  pointer?: Maybe<Scalars['String']['output']>;
};

/** Source objects provide references to the source of an error in the request document. */
export type QontoHttpJson_Error_SourceInput = {
  /** A string indicating the name of a single request header which caused the error. */
  header?: InputMaybe<Scalars['String']['input']>;
  /** A string indicating which URI query parameter caused the error. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** A JSON Pointer [RFC6901] to the value in the request document that caused the error [e.g. "/data" for a primary data object, or "/data/attributes/title" for a specific attribute]. This MUST point to a value in the request document that exists; if it doesn’t, the client SHOULD simply ignore the pointer. */
  pointer?: InputMaybe<Scalars['String']['input']>;
};

/** Error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_JsonApiError = {
  __typename?: 'QontoHttpJson_JSONApiError';
  /** Array of error objects that occurred during the request */
  errors: Array<QontoHttpJson_Error>;
};

/** Error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_JsonApiErrorInput = {
  /** Array of error objects that occurred during the request */
  errors?: InputMaybe<Array<QontoHttpJson_ErrorInput>>;
};

/** Metadata for describing the HTTP routes. */
export type QontoHttp_Route = {
  __typename?: 'QontoHttp_Route';
  /** To be used with DELETE requests */
  delete?: Maybe<Scalars['String']['output']>;
  /** To be used with GET requests */
  get?: Maybe<Scalars['String']['output']>;
  /** To be used with PATCH requests */
  patch?: Maybe<Scalars['String']['output']>;
  /** To be used with POST requests */
  post?: Maybe<Scalars['String']['output']>;
  /** To be used with PUT requests */
  put?: Maybe<Scalars['String']['output']>;
};

/** Metadata for describing the HTTP routes. */
export type QontoHttp_RouteInput = {
  /** To be used with DELETE requests */
  delete?: InputMaybe<Scalars['String']['input']>;
  /** To be used with GET requests */
  get?: InputMaybe<Scalars['String']['input']>;
  /** To be used with PATCH requests */
  patch?: InputMaybe<Scalars['String']['input']>;
  /** To be used with POST requests */
  post?: InputMaybe<Scalars['String']['input']>;
  /** To be used with PUT requests */
  put?: InputMaybe<Scalars['String']['input']>;
};

/** Fee represents an individual fee */
export type QontoPricingBillerFeesFirstpartyV1_Fee = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_Fee';
  /** Base amount of the fees (all fee items summed up) */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Comment set on the fee, most likely by a human */
  comment?: Maybe<Scalars['String']['output']>;
  /** Datetime in ISO 8601 */
  createdAt: Scalars['String']['output'];
  /** A superset of fee_type; includes more specific domain fee types */
  eventType: Scalars['String']['output'];
  /** Translated, human readable variant of what this fee is */
  feeLabel: Scalars['String']['output'];
  /** Sums provided for a single fee's fee payments */
  feePaymentSums?: Maybe<QontoPricingBillerFeesFirstpartyV1_FeePaymentSums>;
  /** Status of the Fee */
  feeStatus: QontoPricingBillerFeesFirstpartyV1_FeeStatus;
  /** Type if the Fee, */
  feeType: QontoPricingBillerFeesFirstpartyV1_FeeType;
  /** Id of the fee */
  id: Scalars['String']['output'];
  /** Organization ID the fee is associated with */
  organizationId: Scalars['String']['output'];
  /** Subscription ID the fee is associated with */
  subscriptionId: Scalars['String']['output'];
  /** Base amount of the fee with discounts applied */
  totalAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Total amount of fee with discounts applied, including VAT */
  totalAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Datetime in ISO 8601 */
  updatedAt: Scalars['String']['output'];
  /** VAT amount of the fee, based on the totalAmount */
  vatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** The fees VAT, where e.g. 20% VAT is represented as 20.0 in this field. 0.0 is a valid value. */
  vatRate: Scalars['Float']['output'];
};

/** Fee represents an individual fee */
export type QontoPricingBillerFeesFirstpartyV1_FeeInput = {
  /** Base amount of the fees (all fee items summed up) */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Comment set on the fee, most likely by a human */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Datetime in ISO 8601 */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** A superset of fee_type; includes more specific domain fee types */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Translated, human readable variant of what this fee is */
  feeLabel?: InputMaybe<Scalars['String']['input']>;
  /** Sums provided for a single fee's fee payments */
  feePaymentSums?: InputMaybe<QontoPricingBillerFeesFirstpartyV1_FeePaymentSumsInput>;
  /** Status of the Fee */
  feeStatus?: InputMaybe<QontoPricingBillerFeesFirstpartyV1_FeeStatus>;
  /** Type if the Fee, */
  feeType?: InputMaybe<QontoPricingBillerFeesFirstpartyV1_FeeType>;
  /** Id of the fee */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID the fee is associated with */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Subscription ID the fee is associated with */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  /** Base amount of the fee with discounts applied */
  totalAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Total amount of fee with discounts applied, including VAT */
  totalAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Datetime in ISO 8601 */
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  /** VAT amount of the fee, based on the totalAmount */
  vatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** The fees VAT, where e.g. 20% VAT is represented as 20.0 in this field. 0.0 is a valid value. */
  vatRate?: InputMaybe<Scalars['Float']['input']>;
};

/** FeePaymentSums are sums of the individual FeePayments by their status. */
export type QontoPricingBillerFeesFirstpartyV1_FeePaymentSums = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_FeePaymentSums';
  /** Amount that was forgiven (without VAT) */
  cancelledAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  cancelledAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was forgiven (with VAT) */
  cancelledAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount that was forgiven (VAT only) */
  cancelledVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount that was already paid (without VAT) */
  completedAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  completedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was already paid (with VAT) */
  completedAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount that was already paid (VAT only) */
  completedVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Total amount the customer has paid or will pay (without VAT) */
  expectedAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  expectedAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount the customer has paid or will pay (with VAT) */
  expectedAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Total amount the customer has paid or will pay (VAT only) */
  expectedVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount we are currently collecting (without VAT) */
  orderedAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  orderedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we are currently collecting (with VAT) */
  orderedAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount we are currently collecting (VAT only) */
  orderedVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount we will attempt to collect soon (without VAT) */
  pendingAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  pendingAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we will attempt to collect soon (with VAT) */
  pendingAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount we will attempt to collect soon (VAT only) */
  pendingVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Total amount that we still expect to collect (without VAT) */
  unsettledAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  unsettledAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount that we still expect to collect (with VAT) */
  unsettledAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Total amount that we still expect to collect (VAT only) */
  unsettledVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount that we are waiting to collect (without VAT) */
  waitingFundsAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Convenience to detect zero amounts without comparing money objects */
  waitingFundsAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that we are waiting to collect (with VAT) */
  waitingFundsAmountVatIncluded?: Maybe<QontoCommon_CurrencyAmount>;
  /** Amount that we are waiting to collect (VAT only) */
  waitingFundsVatAmount?: Maybe<QontoCommon_CurrencyAmount>;
};

/** FeePaymentSums are sums of the individual FeePayments by their status. */
export type QontoPricingBillerFeesFirstpartyV1_FeePaymentSumsInput = {
  /** Amount that was forgiven (without VAT) */
  cancelledAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  cancelledAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount that was forgiven (with VAT) */
  cancelledAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount that was forgiven (VAT only) */
  cancelledVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount that was already paid (without VAT) */
  completedAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  completedAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount that was already paid (with VAT) */
  completedAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount that was already paid (VAT only) */
  completedVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Total amount the customer has paid or will pay (without VAT) */
  expectedAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  expectedAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total amount the customer has paid or will pay (with VAT) */
  expectedAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Total amount the customer has paid or will pay (VAT only) */
  expectedVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount we are currently collecting (without VAT) */
  orderedAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  orderedAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount we are currently collecting (with VAT) */
  orderedAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount we are currently collecting (VAT only) */
  orderedVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount we will attempt to collect soon (without VAT) */
  pendingAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  pendingAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount we will attempt to collect soon (with VAT) */
  pendingAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount we will attempt to collect soon (VAT only) */
  pendingVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Total amount that we still expect to collect (without VAT) */
  unsettledAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  unsettledAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total amount that we still expect to collect (with VAT) */
  unsettledAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Total amount that we still expect to collect (VAT only) */
  unsettledVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount that we are waiting to collect (without VAT) */
  waitingFundsAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Convenience to detect zero amounts without comparing money objects */
  waitingFundsAmountIsZero?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount that we are waiting to collect (with VAT) */
  waitingFundsAmountVatIncluded?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Amount that we are waiting to collect (VAT only) */
  waitingFundsVatAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
};

/**
 * FeeStatus represents the status of a fee
 * buf:lint:ignore ENUM_VALUE_PREFIX
 * buf:lint:ignore COMMENT_ENUM_VALUE
 */
export enum QontoPricingBillerFeesFirstpartyV1_FeeStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CompletedOffered = 'COMPLETED_OFFERED',
  FeeStatusUnspecified = 'FEE_STATUS_UNSPECIFIED',
  Pending = 'PENDING',
  WaitingFunds = 'WAITING_FUNDS'
}

/**
 * FeeType represents the type of fee
 * buf:lint:ignore ENUM_VALUE_PREFIX
 * buf:lint:ignore COMMENT_ENUM_VALUE
 */
export enum QontoPricingBillerFeesFirstpartyV1_FeeType {
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  AccountClosed = 'ACCOUNT_CLOSED',
  AdditionalUser = 'ADDITIONAL_USER',
  AdvertisingCard = 'ADVERTISING_CARD',
  Atm = 'ATM',
  AtmPlus = 'ATM_PLUS',
  CapitalIncrease = 'CAPITAL_INCREASE',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashFlowManagement = 'CASH_FLOW_MANAGEMENT',
  Cheque = 'CHEQUE',
  ConfirmationLetter = 'CONFIRMATION_LETTER',
  DepositInterest = 'DEPOSIT_INTEREST',
  DirectDebitCollectionActivation = 'DIRECT_DEBIT_COLLECTION_ACTIVATION',
  DirectDebitCollectionRefund = 'DIRECT_DEBIT_COLLECTION_REFUND',
  DirectDebitCollectionRefundLate = 'DIRECT_DEBIT_COLLECTION_REFUND_LATE',
  DirectDebitCollectionReturn = 'DIRECT_DEBIT_COLLECTION_RETURN',
  DirectDebitCollectionSend = 'DIRECT_DEBIT_COLLECTION_SEND',
  EckertLaw = 'ECKERT_LAW',
  ExpenseSpendManagement = 'EXPENSE_SPEND_MANAGEMENT',
  FeeTypeUnspecified = 'FEE_TYPE_UNSPECIFIED',
  FlashCard = 'FLASH_CARD',
  Fraud = 'FRAUD',
  FxCard = 'FX_CARD',
  FxCardPlus = 'FX_CARD_PLUS',
  FxInboundTransfer = 'FX_INBOUND_TRANSFER',
  FxOutboundTransfer = 'FX_OUTBOUND_TRANSFER',
  FxOutboundTransferEurSwiftOur = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_OUR',
  FxOutboundTransferEurSwiftSha = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_SHA',
  FxOutboundTransferLocalNonStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY',
  FxOutboundTransferLocalNonStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalNonStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalNonStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalNonStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferLocalStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY',
  FxOutboundTransferLocalStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftOur = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR',
  FxOutboundTransferOnlyVariableSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftSha = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA',
  FxOutboundTransferOnlyVariableSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_50',
  FxOutboundTransferSwiftOur = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR',
  FxOutboundTransferSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferSwiftSha = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA',
  FxOutboundTransferSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_50',
  FxRefund = 'FX_REFUND',
  GenericFee = 'GENERIC_FEE',
  JudicialRequisition = 'JUDICIAL_REQUISITION',
  Other = 'OTHER',
  Pagopa = 'PAGOPA',
  PhysicalCard = 'PHYSICAL_CARD',
  PhysicalCardDelivery = 'PHYSICAL_CARD_DELIVERY',
  PhysicalCardMetal = 'PHYSICAL_CARD_METAL',
  PhysicalCardMirror = 'PHYSICAL_CARD_MIRROR',
  PhysicalCardPlus = 'PHYSICAL_CARD_PLUS',
  RejectedDebit = 'REJECTED_DEBIT',
  RejectedFxTransfer = 'REJECTED_FX_TRANSFER',
  RejectedTransfer = 'REJECTED_TRANSFER',
  ReturnedCheque = 'RETURNED_CHEQUE',
  Satd = 'SATD',
  SciNumberObtention = 'SCI_NUMBER_OBTENTION',
  SeizureForeclosure = 'SEIZURE_FORECLOSURE',
  SepaInboundTransfer = 'SEPA_INBOUND_TRANSFER',
  SepaOutboundTransfer = 'SEPA_OUTBOUND_TRANSFER',
  Shortfall = 'SHORTFALL',
  Subscription = 'SUBSCRIPTION',
  SwiftIncome = 'SWIFT_INCOME',
  SwiftIncomeFree = 'SWIFT_INCOME_FREE',
  ThirdPartyNotice = 'THIRD_PARTY_NOTICE',
  UnpaidCheque = 'UNPAID_CHEQUE',
  VirtualCard = 'VIRTUAL_CARD'
}

/** GroupedFees contains the list of fees found for the parentMovementId */
export type QontoPricingBillerFeesFirstpartyV1_GroupedFees = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_GroupedFees';
  /** Sums provided for all fees and their fee payments */
  feePaymentSums?: Maybe<QontoPricingBillerFeesFirstpartyV1_FeePaymentSums>;
  /** Individual fee details. */
  fees: Array<QontoPricingBillerFeesFirstpartyV1_Fee>;
  /** The movement ID given by the domain event that triggered creation of the fees */
  parentMovementId: Scalars['String']['output'];
  /** Provider object ID (deprecated - use parent_movement_id instead) */
  providerObjectId: Scalars['String']['output'];
};

/** GroupedFees contains the list of fees found for the parentMovementId */
export type QontoPricingBillerFeesFirstpartyV1_GroupedFeesInput = {
  /** Sums provided for all fees and their fee payments */
  feePaymentSums?: InputMaybe<QontoPricingBillerFeesFirstpartyV1_FeePaymentSumsInput>;
  /** Individual fee details. */
  fees?: InputMaybe<Array<QontoPricingBillerFeesFirstpartyV1_FeeInput>>;
  /** The movement ID given by the domain event that triggered creation of the fees */
  parentMovementId?: InputMaybe<Scalars['String']['input']>;
  /** Provider object ID (deprecated - use parent_movement_id instead) */
  providerObjectId?: InputMaybe<Scalars['String']['input']>;
};

/** Custom application error codes when searching */
export type QontoPricingBillerFeesFirstpartyV1_SearchErrors = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_SearchErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes when searching */
export type QontoPricingBillerFeesFirstpartyV1_SearchErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom application error codes for 422 HTTP errors. */
export enum QontoPricingBillerFeesFirstpartyV1_SearchErrors_UnprocessableEntity {
  /** Returned when any of the fee payments isn't using the allowed currency */
  UnprocessableEntityDisallowedCurrency = 'UNPROCESSABLE_ENTITY_DISALLOWED_CURRENCY',
  /** No or unknown application specific error code was given, fallback using the error's status field as guidance. */
  UnprocessableEntityUnspecified = 'UNPROCESSABLE_ENTITY_UNSPECIFIED'
}

/** Request message for listing cost center categories. */
export type QontoPricingBillerFeesFirstpartyV1_SearchRequest = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_SearchRequest';
  /** List of parent movement IDs to search by */
  parentMovementIds: Array<Scalars['String']['output']>;
};

/** Request message for listing cost center categories. */
export type QontoPricingBillerFeesFirstpartyV1_SearchRequestInput = {
  /** List of parent movement IDs to search by */
  parentMovementIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response message for fee search operations */
export type QontoPricingBillerFeesFirstpartyV1_SearchResponse = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_SearchResponse';
  /** List of fee search results */
  groupedFees: Array<QontoPricingBillerFeesFirstpartyV1_GroupedFees>;
};

/** Response message for fee search operations */
export type QontoPricingBillerFeesFirstpartyV1_SearchResponseInput = {
  /** List of fee search results */
  groupedFees?: InputMaybe<Array<QontoPricingBillerFeesFirstpartyV1_GroupedFeesInput>>;
};

/** Message for customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_Customer = {
  __typename?: 'QontoRegistrationApiCustomerFirstpartyV1_Customer';
  /** Timestamp when the contract was signed. */
  contractSignedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Nature of operations. */
  natureOfOperations: Array<Scalars['String']['output']>;
};

/** Message for customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_CustomerInput = {
  /** Timestamp when the contract was signed. */
  contractSignedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Nature of operations. */
  natureOfOperations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Request for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerRequest = {
  __typename?: 'QontoRegistrationApiCustomerFirstpartyV1_GetCustomerRequest';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Request for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerResponse = {
  __typename?: 'QontoRegistrationApiCustomerFirstpartyV1_GetCustomerResponse';
  /** Customer attributes. */
  customer?: Maybe<QontoRegistrationApiCustomerFirstpartyV1_Customer>;
};

/** Response for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerResponseInput = {
  /** Customer attributes. */
  customer?: InputMaybe<QontoRegistrationApiCustomerFirstpartyV1_CustomerInput>;
};

/** Represents a membership. */
export type QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership = {
  __typename?: 'QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership';
  avatar?: Maybe<UserAvatar>;
  /** Unique identifier of the membership. */
  id: Scalars['String']['output'];
  invitation?: Maybe<Invite>;
  kyc: MembershipKycStatus;
  /** Organization ID this membership belongs to */
  organizationId: Scalars['String']['output'];
  person?: Maybe<Person>;
  /** Role assigned to the membership */
  role: QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole;
  /** Status of the membership */
  status: QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus;
  /** Team ID this membership belongs to (optional) */
  teamId?: Maybe<Scalars['String']['output']>;
  /** Name of the team (optional) */
  teamName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  /** Unique identifier of the user. */
  userId?: Maybe<Scalars['String']['output']>;
};

/** Represents a membership. */
export type QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipInput = {
  /** Unique identifier of the membership. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID this membership belongs to */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Role assigned to the membership */
  role?: InputMaybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole>;
  /** Status of the membership */
  status?: InputMaybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus>;
  /** Team ID this membership belongs to (optional) */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the team (optional) */
  teamName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the user. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents all possible membership roles */
export enum QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole {
  /** The role has not been specified */
  MembershipRoleUnspecified = 'MEMBERSHIP_ROLE_UNSPECIFIED',
  /**
   * Accountant role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Accountant = 'accountant',
  /**
   * Administrator
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Admin = 'admin',
  /**
   * Employee role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Employee = 'employee',
  /**
   * Manager role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Manager = 'manager',
  /**
   * Organization owner
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Owner = 'owner'
}

/** Represents all possible membership statuses */
export enum QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus {
  /** The status has not been specified */
  MembershipStatusUnspecified = 'MEMBERSHIP_STATUS_UNSPECIFIED',
  /**
   * Membership is active
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Active = 'active',
  /**
   * Membership is in invited state
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Invited = 'invited',
  /**
   * Membership is revoked
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Revoked = 'revoked'
}

/** Type of client for the mandate. */
export enum QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind {
  /** Company client. */
  ClientKindCompany = 'CLIENT_KIND_COMPANY',
  /** Freelancer client. */
  ClientKindFreelancer = 'CLIENT_KIND_FREELANCER',
  /** Individual client. */
  ClientKindIndividual = 'CLIENT_KIND_INDIVIDUAL',
  /** Unspecified client kind. */
  ClientKindUnspecified = 'CLIENT_KIND_UNSPECIFIED'
}

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshot';
  /** Client street address. */
  address: Scalars['String']['output'];
  /** Client city. */
  city: Scalars['String']['output'];
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode: Scalars['String']['output'];
  /** Client email address. */
  email: Scalars['String']['output'];
  /** Client first name (for individuals). */
  firstName: Scalars['String']['output'];
  /** Client unique identifier. */
  id: Scalars['String']['output'];
  /** Client type (individual, company, freelancer). */
  kind: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind;
  /** Client last name (for individuals). */
  lastName: Scalars['String']['output'];
  /** Client preferred locale (e.g., "en", "fr"). */
  locale: Scalars['String']['output'];
  /** Client display name (company name or full name). */
  name: Scalars['String']['output'];
  /** Client province/state code (required for Italy). */
  provinceCode: Scalars['String']['output'];
  /** Client postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshotInput = {
  /** Client street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name (for individuals). */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Client type (individual, company, freelancer). */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind>;
  /** Client last name (for individuals). */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client preferred locale (e.g., "en", "fr"). */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Client display name (company name or full name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Client province/state code (required for Italy). */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Client postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Status of an SDD mandate. */
export enum QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus {
  /**
   * Mandate is active and can be used for collections.
   * Either approved, imported or pending amendment mandates.
   */
  MandateStatusApproved = 'MANDATE_STATUS_APPROVED',
  /** Mandate has been canceled. */
  MandateStatusCanceled = 'MANDATE_STATUS_CANCELED',
  /** Mandate has been declined. */
  MandateStatusDeclined = 'MANDATE_STATUS_DECLINED',
  /** Mandate has been suspended. */
  MandateStatusExpired = 'MANDATE_STATUS_EXPIRED',
  /** Mandate is pending signature. */
  MandateStatusPendingSignature = 'MANDATE_STATUS_PENDING_SIGNATURE',
  /** Unspecified mandate status. */
  MandateStatusUnspecified = 'MANDATE_STATUS_UNSPECIFIED'
}

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshot';
  /** Address line 1. */
  addressLine_1: Scalars['String']['output'];
  /** Address line 2. */
  addressLine_2: Scalars['String']['output'];
  /** Address line 3. */
  addressLine_3: Scalars['String']['output'];
  /** Organization city. */
  city: Scalars['String']['output'];
  /** Organization country. */
  country: Scalars['String']['output'];
  /** Organization identifier (UUID). */
  id: Scalars['String']['output'];
  /** Organization logo URL. */
  logoUrl: Scalars['String']['output'];
  /** Organization name. */
  name: Scalars['String']['output'];
  /** Organization ZIP code. */
  zipCode: Scalars['String']['output'];
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshotInput = {
  /** Address line 1. */
  addressLine_1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2. */
  addressLine_2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3. */
  addressLine_3?: InputMaybe<Scalars['String']['input']>;
  /** Organization city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Organization country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization identifier (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization logo URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Organization name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization ZIP code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for batch fetching mandates by their IDs.
 * Used by GraphQL gateway dataloaders for efficient mandate resolution.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequest = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequest';
  /** Mandate IDs to fetch. Maximum 100 IDs per request. */
  ids: Array<Scalars['String']['output']>;
};

/**
 * Request for batch fetching mandates by their IDs.
 * Used by GraphQL gateway dataloaders for efficient mandate resolution.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequestInput = {
  /** Mandate IDs to fetch. Maximum 100 IDs per request. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Response containing the requested mandates.
 * Only mandates that exist and are accessible are returned.
 * The GraphQL gateway dataloader handles missing results.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse';
  /** List of found mandates. */
  mandates: Array<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate>;
};

/**
 * Response containing the requested mandates.
 * Only mandates that exist and are accessible are returned.
 * The GraphQL gateway dataloader handles missing results.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponseInput = {
  /** List of found mandates. */
  mandates?: InputMaybe<Array<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_MandateInput>>;
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot';
  /** Client street address. */
  address: Scalars['String']['output'];
  /** Client city. */
  city: Scalars['String']['output'];
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode: Scalars['String']['output'];
  /** Client email address. */
  email: Scalars['String']['output'];
  /** Client first name (for individuals). */
  firstName: Scalars['String']['output'];
  /** Client unique identifier. */
  id: Scalars['String']['output'];
  /** Client type (individual, company, freelancer). */
  kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind;
  /** Client last name (for individuals). */
  lastName: Scalars['String']['output'];
  /** Client preferred locale (e.g., "en", "fr"). */
  locale: Scalars['String']['output'];
  /** Client display name (company name or full name). */
  name: Scalars['String']['output'];
  /** Client province/state code (required for Italy). */
  provinceCode: Scalars['String']['output'];
  /** Client postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshotInput = {
  /** Client street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name (for individuals). */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Client type (individual, company, freelancer). */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind>;
  /** Client last name (for individuals). */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client preferred locale (e.g., "en", "fr"). */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Client display name (company name or full name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Client province/state code (required for Italy). */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Client postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** First payment details. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment';
  /** Payment amount. */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Collection date. Format: YYYY-MM-DD. */
  collectionDate: Scalars['String']['output'];
  /** Whether the first payment date has passed. */
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** Payment reference/description. */
  reference: Scalars['String']['output'];
};

/** First payment details. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPaymentInput = {
  /** Payment amount. */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Collection date. Format: YYYY-MM-DD. */
  collectionDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the first payment date has passed. */
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment reference/description. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Full mandate snapshot optimized for GraphQL gateway consumption. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate';
  /** Client's Bank Identifier Code. */
  clientBic: Scalars['String']['output'];
  /** Last 4 digits of client IBAN (masked). */
  clientIbanLastDigits: Scalars['String']['output'];
  /** Client ID associated with this mandate. */
  clientId: Scalars['String']['output'];
  /** Snapshot of client data at mandate creation. */
  clientSnapshot?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot>;
  /** Creditor Scheme Identifier (CSI). */
  creditorIdentifier: Scalars['String']['output'];
  /** Unique mandate identifier (UUID). */
  id: Scalars['String']['output'];
  /** Payment link URL for mandate signing. */
  link: Scalars['String']['output'];
  /** Date when mandate was signed. Format: YYYY-MM-DD. */
  mandateSignatureDate: Scalars['String']['output'];
  /** Organization ID that owns this mandate. */
  organizationId: Scalars['String']['output'];
  /** Snapshot of organization data at mandate creation. */
  organizationSnapshot?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot>;
  /** Payment configuration if mandate has scheduled payments. */
  paymentInfo?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo>;
  /** Recurrence type (recurring or one-off). */
  recurrenceType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType;
  /** Current mandate status. */
  status: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus;
  /** SEPA scheme type (CORE or B2B). */
  type: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType;
  /** Unique Mandate Reference (UMR) for SEPA. */
  uniqueMandateReference: Scalars['String']['output'];
};

/** Full mandate snapshot optimized for GraphQL gateway consumption. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_MandateInput = {
  /** Client's Bank Identifier Code. */
  clientBic?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of client IBAN (masked). */
  clientIbanLastDigits?: InputMaybe<Scalars['String']['input']>;
  /** Client ID associated with this mandate. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot of client data at mandate creation. */
  clientSnapshot?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshotInput>;
  /** Creditor Scheme Identifier (CSI). */
  creditorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Unique mandate identifier (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Payment link URL for mandate signing. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Date when mandate was signed. Format: YYYY-MM-DD. */
  mandateSignatureDate?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID that owns this mandate. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot of organization data at mandate creation. */
  organizationSnapshot?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshotInput>;
  /** Payment configuration if mandate has scheduled payments. */
  paymentInfo?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfoInput>;
  /** Recurrence type (recurring or one-off). */
  recurrenceType?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType>;
  /** Current mandate status. */
  status?: InputMaybe<QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus>;
  /** SEPA scheme type (CORE or B2B). */
  type?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType>;
  /** Unique Mandate Reference (UMR) for SEPA. */
  uniqueMandateReference?: InputMaybe<Scalars['String']['input']>;
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot';
  /** Address line 1. */
  addressLine_1: Scalars['String']['output'];
  /** Address line 2. */
  addressLine_2: Scalars['String']['output'];
  /** Address line 3. */
  addressLine_3: Scalars['String']['output'];
  /** City. */
  city: Scalars['String']['output'];
  /** Country name. */
  country: Scalars['String']['output'];
  /** Organization unique identifier. */
  id: Scalars['String']['output'];
  /** Organization logo URL (empty if using default). */
  logoUrl: Scalars['String']['output'];
  /** Organization legal name. */
  name: Scalars['String']['output'];
  /** Postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshotInput = {
  /** Address line 1. */
  addressLine_1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2. */
  addressLine_2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3. */
  addressLine_3?: InputMaybe<Scalars['String']['input']>;
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country name. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization logo URL (empty if using default). */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Organization legal name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Payment schedule configuration. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo';
  /** First payment details. */
  firstPayment?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment>;
  /** Custom schedule interval (for custom schedules). */
  interval: Scalars['Int']['output'];
  /** Whether to notify client before collections. */
  notifyClient: Scalars['Boolean']['output'];
  /** Custom schedule unit (for custom schedules). */
  scheduleCustomUnit: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit;
  /** Total number of collections (0 = unlimited). */
  scheduleTotalCollectionCount: Scalars['Int']['output'];
  /** Schedule type (one_off, weekly, monthly, etc.). */
  scheduleType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType;
};

/** Payment schedule configuration. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfoInput = {
  /** First payment details. */
  firstPayment?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPaymentInput>;
  /** Custom schedule interval (for custom schedules). */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to notify client before collections. */
  notifyClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom schedule unit (for custom schedules). */
  scheduleCustomUnit?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit>;
  /** Total number of collections (0 = unlimited). */
  scheduleTotalCollectionCount?: InputMaybe<Scalars['Int']['input']>;
  /** Schedule type (one_off, weekly, monthly, etc.). */
  scheduleType?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType>;
};

/** Type of client for the mandate. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind {
  /** Company client. */
  ClientKindCompany = 'CLIENT_KIND_COMPANY',
  /** Freelancer client. */
  ClientKindFreelancer = 'CLIENT_KIND_FREELANCER',
  /** Individual client. */
  ClientKindIndividual = 'CLIENT_KIND_INDIVIDUAL',
  /** Unspecified client kind. */
  ClientKindUnspecified = 'CLIENT_KIND_UNSPECIFIED'
}

/** Custom application error codes for the CreatePublicMandate endpoint. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes for the CreatePublicMandate endpoint. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors_BadRequestError {
  /** The request has an invalid format, source and detail fields contain more information. */
  BadRequestErrorCodeFormatError = 'BAD_REQUEST_ERROR_CODE_FORMAT_ERROR',
  /** Missing required field. */
  BadRequestErrorCodeMissingRequiredField = 'BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD',
  /** Unspecified validation error. */
  BadRequestErrorCodeUnspecified = 'BAD_REQUEST_ERROR_CODE_UNSPECIFIED'
}

/** Request for creating a mandate via public invitation link. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequest = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequest';
  /** Client's street address. */
  address: Scalars['String']['output'];
  /** Client's city. */
  city: Scalars['String']['output'];
  /** Client's first name. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Client's country code (ISO 3166-1 alpha-2 e.g., "fr", "en"). */
  countryCode: Scalars['String']['output'];
  /** Client's email address. */
  email: Scalars['String']['output'];
  /** Client's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Client's IBAN for the mandate. */
  iban: Scalars['String']['output'];
  /**
   * Unique identifier for the invitation link from URL path.
   *
   * @gotags: validate:"uuid"
   */
  invitationLinkId: Scalars['String']['output'];
  /** Type of client. */
  kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind;
  /** Client's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Client's city. */
  province?: Maybe<Scalars['String']['output']>;
  /** Client's postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Request for creating a mandate via public invitation link. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequestInput = {
  /** Client's street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client's city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client's first name. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Client's country code (ISO 3166-1 alpha-2 e.g., "fr", "en"). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client's IBAN for the mandate. */
  iban?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique identifier for the invitation link from URL path.
   *
   * @gotags: validate:"uuid"
   */
  invitationLinkId?: InputMaybe<Scalars['String']['input']>;
  /** Type of client. */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind>;
  /** Client's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client's city. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** Client's postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response for successful mandate creation.
 * Empty response for successful creation (200 OK).
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponse = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Response for successful mandate creation.
 * Empty response for successful creation (200 OK).
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponseInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Mandate recurrence type. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType {
  /** One-off mandate (non-recurring collection) */
  MandateRecurrenceTypeOneOff = 'MANDATE_RECURRENCE_TYPE_ONE_OFF',
  /** Recurring mandate (multiple collections allowed). */
  MandateRecurrenceTypeRecurring = 'MANDATE_RECURRENCE_TYPE_RECURRING',
  /** Unspecified recurrence type. */
  MandateRecurrenceTypeUnspecified = 'MANDATE_RECURRENCE_TYPE_UNSPECIFIED'
}

/** Mandate type (SEPA scheme). */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType {
  /** SEPA B2B Direct Debit scheme. */
  MandateTypeB2B = 'MANDATE_TYPE_B2B',
  /** SEPA Core Direct Debit scheme. */
  MandateTypeCore = 'MANDATE_TYPE_CORE',
  /** Unspecified mandate type. */
  MandateTypeUnspecified = 'MANDATE_TYPE_UNSPECIFIED'
}

/** Schedule type. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType {
  /** Custom interval collections. */
  ScheduleTypeCustom = 'SCHEDULE_TYPE_CUSTOM',
  /** Monthly collections. */
  ScheduleTypeMonthly = 'SCHEDULE_TYPE_MONTHLY',
  /** Single collection only. */
  ScheduleTypeOneOff = 'SCHEDULE_TYPE_ONE_OFF',
  /** Quarterly collections. */
  ScheduleTypeQuarterly = 'SCHEDULE_TYPE_QUARTERLY',
  /** Unspecified schedule type. */
  ScheduleTypeUnspecified = 'SCHEDULE_TYPE_UNSPECIFIED',
  /** Weekly collections. */
  ScheduleTypeWeekly = 'SCHEDULE_TYPE_WEEKLY',
  /** Yearly collections. */
  ScheduleTypeYearly = 'SCHEDULE_TYPE_YEARLY'
}

/** Schedule unit for custom schedules. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit {
  /** Monthly interval. */
  ScheduleUnitMonths = 'SCHEDULE_UNIT_MONTHS',
  /** Unspecified schedule unit. */
  ScheduleUnitUnspecified = 'SCHEDULE_UNIT_UNSPECIFIED',
  /** Weekly interval. */
  ScheduleUnitWeeks = 'SCHEDULE_UNIT_WEEKS',
  /** Yearly interval. */
  ScheduleUnitYears = 'SCHEDULE_UNIT_YEARS'
}

/** Request for listing SDD mandates with pagination. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsRequest = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsRequest';
  /** IDs of mandates to fetch */
  ids: Array<Scalars['String']['output']>;
};

/** Request for listing SDD mandates with pagination. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsRequestInput = {
  /** IDs of mandates to fetch */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response containing the list of mandates and metadata. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsResponse = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsResponse';
  /** List of mandates. */
  mandates: Array<QontoTransfersSddMandatesFirstpartyV2_Mandate>;
};

/** Response containing the list of mandates and metadata. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsResponseInput = {
  /** List of mandates. */
  mandates?: InputMaybe<Array<QontoTransfersSddMandatesFirstpartyV2_MandateInput>>;
};

/** A single SDD mandate */
export type QontoTransfersSddMandatesFirstpartyV2_Mandate = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_Mandate';
  /** Attachment IDs linked to the mandate */
  attachmentIds: Array<Scalars['String']['output']>;
  /** Creditor identifier */
  creditorIdentifier: Scalars['String']['output'];
  /** Debtor IBAN */
  iban: Scalars['String']['output'];
  /** Unique identifier of the mandate */
  id: Scalars['String']['output'];
  /** Mandate type (string representation) */
  mandateType: Scalars['String']['output'];
  /** Whether the mandate is recurrent */
  recurrent: Scalars['Boolean']['output'];
  /** Current status of the mandate (string representation) */
  status: Scalars['String']['output'];
  /** Unique Mandate Reference (UMR) */
  umr?: Maybe<Scalars['String']['output']>;
};

/** A single SDD mandate */
export type QontoTransfersSddMandatesFirstpartyV2_MandateInput = {
  /** Attachment IDs linked to the mandate */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Creditor identifier */
  creditorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Debtor IBAN */
  iban?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the mandate */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Mandate type (string representation) */
  mandateType?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mandate is recurrent */
  recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current status of the mandate (string representation) */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Unique Mandate Reference (UMR) */
  umr?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  getAccounts?: Maybe<QontoAccountingAccountsFirstpartyV2_ListAccountsResponse>;
  getJournals: QontoAccountingJournalsFirstpartyV2_ListJournalsResponse;
  getLedgerEntries?: Maybe<QontoAccountingEntriesFirstpartyV2_GetEntriesResponse>;
  getMyBankDetails: MyBankDetailsResult;
  getSingleMembership?: Maybe<Membership>;
  getSingleReceivableInvoice?: Maybe<ReceivableInvoice>;
  searchCards: SearchCardsResult;
  searchMemberships: SearchMembershipsResult;
  searchOrganization: SearchOrganizationResult;
  searchSingleExpenseReport: SearchSingleExpenseReportResult;
  searchSingleRequestExpenseReport: SearchSingleRequestExpenseReportResult;
  searchSingleSupplierInvoice: SearchSingleSupplierInvoiceResult;
  searchSingleSupplierSubscription: SearchSingleSupplierSubscriptionResult;
  searchSupplierInvoices: SearchSupplierInvoicesResult;
  searchSupplierSubscriptions: SearchSupplierSubscriptionsResult;
  searchThreads: Array<Thread>;
  searchTransactions: SearchTransactionsResult;
  searchTransactionsV2?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse>;
};


export type QueryGetAccountsArgs = {
  input?: InputMaybe<QontoAccountingAccountsFirstpartyV2_ListAccountsRequestInput>;
};


export type QueryGetJournalsArgs = {
  input?: InputMaybe<QontoAccountingJournalsFirstpartyV2_ListJournalsRequestInput>;
};


export type QueryGetLedgerEntriesArgs = {
  input?: InputMaybe<QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput>;
};


export type QueryGetMyBankDetailsArgs = {
  input?: InputMaybe<MyBankDetailsSearch>;
};


export type QueryGetSingleMembershipArgs = {
  input?: InputMaybe<SingleMembershipsSearch>;
};


export type QueryGetSingleReceivableInvoiceArgs = {
  input?: InputMaybe<SingleReceivableInvoicesSearch>;
};


export type QuerySearchCardsArgs = {
  input?: InputMaybe<CardsSearch>;
};


export type QuerySearchMembershipsArgs = {
  input?: InputMaybe<MembershipsSearch>;
};


export type QuerySearchOrganizationArgs = {
  input?: InputMaybe<OrganizationsSearch>;
};


export type QuerySearchSingleExpenseReportArgs = {
  input?: InputMaybe<SingleExpenseReportsSearch>;
};


export type QuerySearchSingleRequestExpenseReportArgs = {
  input?: InputMaybe<SingleRequestExpenseReportsSearch>;
};


export type QuerySearchSingleSupplierInvoiceArgs = {
  input?: InputMaybe<SingleSupplierInvoicesSearch>;
};


export type QuerySearchSingleSupplierSubscriptionArgs = {
  input?: InputMaybe<SingleSupplierSubscriptionsSearch>;
};


export type QuerySearchSupplierInvoicesArgs = {
  input?: InputMaybe<SupplierInvoicesSearch>;
};


export type QuerySearchSupplierSubscriptionsArgs = {
  input?: InputMaybe<SupplierSubscriptionsSearch>;
};


export type QuerySearchThreadsArgs = {
  input?: InputMaybe<ThreadsSearch>;
};


export type QuerySearchTransactionsArgs = {
  input?: InputMaybe<TransactionsSearch>;
};


export type QuerySearchTransactionsV2Args = {
  input?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput>;
};

export type ReceivableInvoice = {
  __typename?: 'ReceivableInvoice';
  accountingRecordedAt?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Amount>;
  amountPaid?: Maybe<Amount>;
  attachmentId: Scalars['String']['output'];
  balanceInvoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerSnapshot?: Maybe<ReceivableInvoiceCustomerSnapshot>;
  debtCollection?: Maybe<ReceivableInvoiceDebtCollection>;
  depositAmount?: Maybe<Amount>;
  depositInvoiceId?: Maybe<Scalars['String']['output']>;
  directDebitCollectionMandate?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate>;
  directDebitCollectionMandateId?: Maybe<Scalars['String']['output']>;
  directDebitEnabled: Scalars['Boolean']['output'];
  directDebitSubscriptionId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceDiscount>;
  dueDate?: Maybe<Scalars['String']['output']>;
  einvoicingLifecycleEvents?: Maybe<Array<ReceivableInvoiceEinvoicingLifecycleEvent>>;
  einvoicingStatus?: Maybe<ReceivableInvoiceEinvoicingStatus>;
  fileName?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hasDuplicates: Scalars['Boolean']['output'];
  header?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importAnalyzedAt?: Maybe<Scalars['String']['output']>;
  imported: Scalars['Boolean']['output'];
  intermediaryBankBic?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoiceSubscription?: Maybe<ReceivableInvoiceSubscription>;
  invoiceSubscriptionId?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<ReceivableInvoiceType>;
  isDeposit: Scalars['Boolean']['output'];
  isEinvoice: Scalars['Boolean']['output'];
  isHiddenFromClientPortal: Scalars['Boolean']['output'];
  isPdfGenerated: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  lastPartialInvoiceId?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  nextReminderDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationSnapshot?: Maybe<ReceivableInvoiceOrganizationSnapshot>;
  overdue: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  partialInvoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  payment?: Maybe<ReceivableInvoicePayment>;
  paymentLink?: Maybe<ReceivableInvoicePaymentLink>;
  paymentLinkDetails?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
  performanceDate?: Maybe<Scalars['String']['output']>;
  performanceEndDate?: Maybe<Scalars['String']['output']>;
  performanceStartDate?: Maybe<Scalars['String']['output']>;
  previousPartialInvoiceId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<ReceivableInvoiceProgress>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  receivableCreditNoteIds?: Maybe<Array<Scalars['String']['output']>>;
  receivableInvoicingUploadId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referralLink?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<ReceivableInvoiceSection>>;
  stampDutyAmount?: Maybe<Amount>;
  status: ReceivableInvoiceStatus;
  subtotal?: Maybe<Amount>;
  subtotalBeforeDiscount?: Maybe<Amount>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  termsConditionsUploadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Amount>;
  welfareFund?: Maybe<ReceivableInvoiceWelfareFund>;
  withholdingTax?: Maybe<ReceivableInvoiceWithholdingTax>;
};

export type ReceivableInvoiceBillingAddress = {
  __typename?: 'ReceivableInvoiceBillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceCustomerKind {
  Company = 'COMPANY',
  Freelancer = 'FREELANCER',
  Individual = 'INDIVIDUAL'
}

export type ReceivableInvoiceCustomerSnapshot = {
  __typename?: 'ReceivableInvoiceCustomerSnapshot';
  address?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ReceivableInvoiceBillingAddress>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<ReceivableInvoiceCustomerKind>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tinNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceDebtCollection = {
  __typename?: 'ReceivableInvoiceDebtCollection';
  actionNeeded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ReceivableInvoiceDiscount = {
  __typename?: 'ReceivableInvoiceDiscount';
  amount?: Maybe<Amount>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceEinvoicingLifecycleEvent = {
  __typename?: 'ReceivableInvoiceEinvoicingLifecycleEvent';
  createdAt?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceEinvoicingStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  NotDelivered = 'NOT_DELIVERED',
  Pending = 'PENDING',
  SubmissionFailed = 'SUBMISSION_FAILED',
  Submitted = 'SUBMITTED'
}

export type ReceivableInvoiceOrganizationSnapshot = {
  __typename?: 'ReceivableInvoiceOrganizationSnapshot';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  companyLeadership?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  districtCourt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalCapitalShare?: Maybe<Amount>;
  legalCountry?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNumber?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatPaymentCondition?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoicePayment = {
  __typename?: 'ReceivableInvoicePayment';
  conditions?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoicePaymentLink = {
  __typename?: 'ReceivableInvoicePaymentLink';
  methods?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReceivableInvoiceProgress = {
  __typename?: 'ReceivableInvoiceProgress';
  cumulativeAmount?: Maybe<Amount>;
  cumulativePercentage?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSection = {
  __typename?: 'ReceivableInvoiceSection';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ReceivableInvoiceSectionItem>>;
};

export type ReceivableInvoiceSectionItem = {
  __typename?: 'ReceivableInvoiceSectionItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceDiscount>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<ReceivableInvoiceSectionItemLink>>;
  productId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<ReceivableInvoiceSectionItemProgress>;
  quantity?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Amount>;
  title?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
  totalVat?: Maybe<Amount>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Amount>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatExemptionCode?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSectionItemLink = {
  __typename?: 'ReceivableInvoiceSectionItemLink';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSectionItemProgress = {
  __typename?: 'ReceivableInvoiceSectionItemProgress';
  amount?: Maybe<Amount>;
  cumulativeAmount?: Maybe<Amount>;
  cumulativePercentage?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceStatus {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type ReceivableInvoiceSubscription = {
  __typename?: 'ReceivableInvoiceSubscription';
  amountDue?: Maybe<Amount>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  directDebitCollectionMandateId?: Maybe<Scalars['String']['output']>;
  directDebitEnabled?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<ReceivableInvoiceSubscriptionDiscount>;
  emailTemplate?: Maybe<ReceivableInvoiceSubscriptionEmailTemplate>;
  endDate?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<ReceivableInvoiceSubscriptionFrequency>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceStatus?: Maybe<ReceivableInvoiceSubscriptionInvoiceStatus>;
  isEinvoice?: Maybe<Scalars['Boolean']['output']>;
  nextInvoiceDate?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<ReceivableInvoiceSubscriptionPayment>;
  paymentLink?: Maybe<ReceivableInvoiceSubscriptionPaymentLink>;
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId?: Maybe<Scalars['String']['output']>;
  receivableInvoicingUploadId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<ReceivableInvoiceSubscriptionSection>>;
  stampDutyAmount?: Maybe<Amount>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReceivableInvoiceSubscriptionStatus>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  welfareFund?: Maybe<ReceivableInvoiceSubscriptionWelfareFund>;
  withholdingTax?: Maybe<ReceivableInvoiceSubscriptionWithholdingTax>;
};

export type ReceivableInvoiceSubscriptionDiscount = {
  __typename?: 'ReceivableInvoiceSubscriptionDiscount';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionEmailTemplate = {
  __typename?: 'ReceivableInvoiceSubscriptionEmailTemplate';
  copyToSelf?: Maybe<Scalars['Boolean']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailTitle?: Maybe<Scalars['String']['output']>;
  sendTo?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReceivableInvoiceSubscriptionFrequency = {
  __typename?: 'ReceivableInvoiceSubscriptionFrequency';
  recurrence?: Maybe<ReceivableInvoiceSubscriptionRecurrence>;
  value?: Maybe<Scalars['Int']['output']>;
};

export enum ReceivableInvoiceSubscriptionInvoiceStatus {
  Draft = 'DRAFT',
  Unpaid = 'UNPAID'
}

export type ReceivableInvoiceSubscriptionPayment = {
  __typename?: 'ReceivableInvoiceSubscriptionPayment';
  conditions?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionPaymentLink = {
  __typename?: 'ReceivableInvoiceSubscriptionPaymentLink';
  methods?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ReceivableInvoiceSubscriptionRecurrence {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ReceivableInvoiceSubscriptionSection = {
  __typename?: 'ReceivableInvoiceSubscriptionSection';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ReceivableInvoiceSubscriptionSectionItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionSectionItem = {
  __typename?: 'ReceivableInvoiceSubscriptionSectionItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceSubscriptionDiscount>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<ReceivableInvoiceSubscriptionSectionItemLink>>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Amount>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatExemptionCode?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionSectionItemLink = {
  __typename?: 'ReceivableInvoiceSubscriptionSectionItemLink';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED'
}

export type ReceivableInvoiceSubscriptionWelfareFund = {
  __typename?: 'ReceivableInvoiceSubscriptionWelfareFund';
  rate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionWithholdingTax = {
  __typename?: 'ReceivableInvoiceSubscriptionWithholdingTax';
  rate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceType {
  Balance = 'BALANCE',
  Deposit = 'DEPOSIT',
  Partial = 'PARTIAL',
  Standard = 'STANDARD'
}

export type ReceivableInvoiceWelfareFund = {
  __typename?: 'ReceivableInvoiceWelfareFund';
  rate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceWithholdingTax = {
  __typename?: 'ReceivableInvoiceWithholdingTax';
  rate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RelatedFees = {
  __typename?: 'RelatedFees';
  /** Sums provided for all fees and their fee payments */
  feePaymentSums: FeePaymentSums;
  /** Individual fee details. Fees with expectedAmountIsZero=true are excluded. */
  fees: Array<Fee>;
  /** The movement ID given by the domain event that triggered creation of the fee. */
  parentMovementID: Scalars['String']['output'];
};

export type RelatedInvoice = {
  __typename?: 'RelatedInvoice';
  attachmentId: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issueDate: Scalars['String']['output'];
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type RequestExpenseReport = {
  __typename?: 'RequestExpenseReport';
  amount: Amount;
  approvalWorkflowStateId?: Maybe<Scalars['String']['output']>;
  approverId?: Maybe<Scalars['String']['output']>;
  attachmentIds: Array<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  bankless?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  declinedNote?: Maybe<Scalars['String']['output']>;
  expenseReport: ExpenseReport;
  expenseReportId: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId: Scalars['String']['output'];
  lastStep: Scalars['Boolean']['output'];
  membership: Membership;
  note: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vatAmount?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type RibaPayment = {
  __typename?: 'RibaPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  ribaNumber: Scalars['String']['output'];
};

export type SearchCardsMeta = {
  __typename?: 'SearchCardsMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCardsResult = {
  __typename?: 'SearchCardsResult';
  cards: Array<Card>;
  meta: SearchCardsMeta;
};

export type SearchMembershipsMeta = {
  __typename?: 'SearchMembershipsMeta';
  currentPage: Scalars['Int']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMembershipsResult = {
  __typename?: 'SearchMembershipsResult';
  memberships: Array<Membership>;
  meta: SearchMembershipsMeta;
};

export type SearchOrganizationResult = {
  __typename?: 'SearchOrganizationResult';
  organization: Organization;
};

export type SearchSingleExpenseReportResult = {
  __typename?: 'SearchSingleExpenseReportResult';
  expenseReport: ExpenseReport;
};

export type SearchSingleRequestExpenseReportResult = {
  __typename?: 'SearchSingleRequestExpenseReportResult';
  requestExpenseReport: RequestExpenseReport;
};

export type SearchSingleSupplierInvoiceResult = {
  __typename?: 'SearchSingleSupplierInvoiceResult';
  supplierInvoice: SupplierInvoice;
};

export type SearchSingleSupplierSubscriptionResult = {
  __typename?: 'SearchSingleSupplierSubscriptionResult';
  subscription: SupplierSubscription;
};

export type SearchSupplierInvoicesMeta = {
  __typename?: 'SearchSupplierInvoicesMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSupplierInvoicesResult = {
  __typename?: 'SearchSupplierInvoicesResult';
  meta: SearchSupplierInvoicesMeta;
  supplierInvoices: Array<SupplierInvoice>;
};

export type SearchSupplierSubscriptionsMeta = {
  __typename?: 'SearchSupplierSubscriptionsMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSupplierSubscriptionsResult = {
  __typename?: 'SearchSupplierSubscriptionsResult';
  meta: SearchSupplierSubscriptionsMeta;
  subscriptions: Array<SupplierSubscription>;
};

export type SearchTransactionsMeta = {
  __typename?: 'SearchTransactionsMeta';
  currentPage: Scalars['Int']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTransactionsResult = {
  __typename?: 'SearchTransactionsResult';
  meta: SearchTransactionsMeta;
  transactions: Array<Transaction>;
};

export enum Side {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type SingleExpenseReportsSearch = {
  id: Scalars['String']['input'];
};

export type SingleMembershipsSearch = {
  id: Scalars['String']['input'];
};

export type SingleReceivableInvoicesSearch = {
  id: Scalars['String']['input'];
};

export type SingleRequestExpenseReportsSearch = {
  id: Scalars['String']['input'];
};

export type SingleSupplierInvoicesSearch = {
  id: Scalars['String']['input'];
};

export type SingleSupplierSubscriptionsSearch = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum SolutionInstanceStatus {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Enabled = 'ENABLED',
  Failed = 'FAILED',
  MarkedForDeletion = 'MARKED_FOR_DELETION',
  MarkedForEnablement = 'MARKED_FOR_ENABLEMENT',
  /** Supported invoice collector is not in-house integration or has not been installed yet - we don't know its status */
  NotAvailable = 'NOT_AVAILABLE',
  Pending = 'PENDING'
}

export type Sort = {
  direction?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Reversed = 'REVERSED'
}

export type StatusHistory = {
  __typename?: 'StatusHistory';
  createdAt: Scalars['String']['output'];
  status: StatusHistoryStatus;
};

export enum StatusHistoryStatus {
  Authorized = 'AUTHORIZED',
  Settled = 'SETTLED'
}

export enum SubjectType {
  AccountRemuneration = 'ACCOUNT_REMUNERATION',
  BillingTransfer = 'BILLING_TRANSFER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  Cashback = 'CASHBACK',
  Check = 'CHECK',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitCollection = 'DIRECT_DEBIT_COLLECTION',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  F24Payment = 'F24_PAYMENT',
  FinancingIncome = 'FINANCING_INCOME',
  FinancingInstallment = 'FINANCING_INSTALLMENT',
  Income = 'INCOME',
  NrcPayment = 'NRC_PAYMENT',
  PagopaPayment = 'PAGOPA_PAYMENT',
  SwiftIncome = 'SWIFT_INCOME',
  Transfer = 'TRANSFER',
  WalletToWallet = 'WALLET_TO_WALLET'
}

export enum SubscriptionPaymentMethod {
  PaymentMethodCard = 'PAYMENT_METHOD_CARD',
  PaymentMethodDirectDebit = 'PAYMENT_METHOD_DIRECT_DEBIT',
  PaymentMethodUnspecified = 'PAYMENT_METHOD_UNSPECIFIED'
}

export type SuggestedCategory = {
  __typename?: 'SuggestedCategory';
  id?: Maybe<Scalars['ID']['output']>;
  transactionID: Scalars['String']['output'];
};

export type SupplierInvoice = {
  __typename?: 'SupplierInvoice';
  analyzedAt?: Maybe<Scalars['String']['output']>;
  approvalWorkflow?: Maybe<SupplierInvoiceApprovalWorkflow>;
  attachmentCategory: SupplierInvoiceAttachmentCategory;
  attachmentId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  declinedNote?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discrepancies?: Maybe<Array<Discrepancy>>;
  displayAttachmentId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  einvoiceFormat?: Maybe<Scalars['String']['output']>;
  einvoicingLifecycleEvents?: Maybe<Array<EinvoicingLifecycleEvent>>;
  fileName: Scalars['String']['output'];
  hasDuplicates: Scalars['Boolean']['output'];
  hasSuggestedCreditNotes: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAttachmentInvoice: Scalars['Boolean']['output'];
  isEinvoice: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  markedAsRead?: Maybe<Scalars['Boolean']['output']>;
  matchedTransactions?: Maybe<Array<SupplierInvoicePayment>>;
  matchedTransferIds?: Maybe<Array<Scalars['String']['output']>>;
  meta?: Maybe<SupplierInvoiceMeta>;
  organizationId: Scalars['String']['output'];
  payableAmount?: Maybe<Amount>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  relatedInvoices?: Maybe<Array<RelatedInvoice>>;
  requestTransferId?: Maybe<Scalars['String']['output']>;
  requestTransferInitiatorId?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['String']['output']>;
  selfInvoiceId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  status: SupplierInvoiceStatus;
  suggestedTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
  suggestedTransactions?: Maybe<Array<Transaction>>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  supplierSnapshot?: Maybe<SupplierSnapshot>;
  taxes?: Maybe<Array<InvoiceTax>>;
  thread?: Maybe<Thread>;
  tinNumber?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
  totalAmountExcludingTaxesCents?: Maybe<Scalars['Int']['output']>;
  totalTaxAmountCents?: Maybe<Scalars['Int']['output']>;
  transferIds?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['String']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type SupplierInvoiceApprovalWorkflow = {
  __typename?: 'SupplierInvoiceApprovalWorkflow';
  approverIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastApprovedBy?: Maybe<Scalars['String']['output']>;
  supplierInvoiceId: Scalars['ID']['output'];
  supplierInvoiceRequestId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export enum SupplierInvoiceAttachmentCategory {
  CardReceipt = 'CARD_RECEIPT',
  CreditCardReceipt = 'CREDIT_CARD_RECEIPT',
  CreditNote = 'CREDIT_NOTE',
  ExpenseReceipt = 'EXPENSE_RECEIPT',
  Invoice = 'INVOICE',
  OtherFinancialDocument = 'OTHER_FINANCIAL_DOCUMENT',
  OtherNonFinancialDocument = 'OTHER_NON_FINANCIAL_DOCUMENT',
  Unknown = 'UNKNOWN'
}

export type SupplierInvoiceMeta = {
  __typename?: 'SupplierInvoiceMeta';
  accountingRecordedAt?: Maybe<Scalars['String']['output']>;
  accountingRecordedSource?: Maybe<Scalars['String']['output']>;
  connector?: Maybe<Scalars['String']['output']>;
  emailedBy?: Maybe<Scalars['String']['output']>;
  emailedTo?: Maybe<Scalars['String']['output']>;
  integrationName?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  matchedSupplierId?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<Membership>;
  resolvedById?: Maybe<Scalars['String']['output']>;
};

export type SupplierInvoicePayment = {
  __typename?: 'SupplierInvoicePayment';
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localAmountCents: Scalars['Int']['output'];
  localAmountCurrency: Scalars['String']['output'];
  scheduledAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  supplierInvoiceId: Scalars['ID']['output'];
  transactionId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum SupplierInvoiceStatus {
  Archived = 'ARCHIVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Discarded = 'DISCARDED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  ToApprove = 'TO_APPROVE',
  ToPay = 'TO_PAY',
  ToReview = 'TO_REVIEW'
}

export enum SupplierInvoiceView {
  DocumentReviewSectionPendingReview = 'DOCUMENT_REVIEW_SECTION_PENDING_REVIEW',
  DocumentReviewSectionResolved = 'DOCUMENT_REVIEW_SECTION_RESOLVED',
  SupplierInvoicesSection = 'SUPPLIER_INVOICES_SECTION'
}

export type SupplierInvoicesFilters = {
  attachmentCategory?: InputMaybe<Array<SupplierInvoiceAttachmentCategory>>;
  hasDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  markedAsRead?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  view?: InputMaybe<SupplierInvoiceView>;
};

export type SupplierInvoicesPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierInvoicesSearch = {
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  sort?: InputMaybe<Sort>;
};

export type SupplierSnapshot = {
  __typename?: 'SupplierSnapshot';
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: SupplierStatus;
  tin?: Maybe<Scalars['String']['output']>;
};

export enum SupplierStatus {
  Archived = 'ARCHIVED',
  Unarchived = 'UNARCHIVED'
}

export type SupplierSubscription = {
  __typename?: 'SupplierSubscription';
  amount: Amount;
  bankAccount: BankAccount;
  bankAccountId: Scalars['String']['output'];
  counterpartyName: Scalars['String']['output'];
  frequency: Frequency;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  nextPaymentDate: Scalars['String']['output'];
  paymentMethod: SubscriptionPaymentMethod;
  recentTransactionIds: Array<Scalars['String']['output']>;
  recentTransactions: Array<Transaction>;
  transactionIds: Array<Scalars['String']['output']>;
  transactions: Array<Transaction>;
};

export type SupplierSubscriptionMeta = {
  __typename?: 'SupplierSubscriptionMeta';
  counterpartyName: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  isCounterpartyBlocked: Scalars['Boolean']['output'];
};

export type SupplierSubscriptionsPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierSubscriptionsSearch = {
  pagination?: InputMaybe<SupplierSubscriptionsPagination>;
  sort?: InputMaybe<Sort>;
};

export type SupportedInvoiceCollector = {
  __typename?: 'SupportedInvoiceCollector';
  counterpartyName: Scalars['String']['output'];
  integrationName: Scalars['String']['output'];
  integrationSlug: Scalars['String']['output'];
  solutionInstanceStatus: SolutionInstanceStatus;
  type: SupportedInvoiceCollectorType;
};

export enum SupportedInvoiceCollectorType {
  /** Right now this corresponds to Twin's Invoice Collector */
  InvoiceCollector = 'INVOICE_COLLECTOR',
  /** Invoice collector built by Qonto as Tray integration */
  InHouseCollector = 'IN_HOUSE_COLLECTOR',
  /** The transaction's counterparty is not supported */
  NotAvailable = 'NOT_AVAILABLE'
}

export type SwiftIncome = {
  __typename?: 'SwiftIncome';
  amount: Amount;
  emitterAccountIdentifier?: Maybe<Scalars['String']['output']>;
  emitterAddress?: Maybe<Scalars['String']['output']>;
  emitterBankIdentifier?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  emitterNameAddress?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  localAmount: Amount;
  reference?: Maybe<Scalars['String']['output']>;
};

export type TaxFinancialAccount = {
  __typename?: 'TaxFinancialAccount';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  rate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Thread = {
  __typename?: 'Thread';
  attachedToId: Scalars['ID']['output'];
  attachedToType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  messages: Array<Message>;
  organizationId: Scalars['ID']['output'];
  participants: Array<Participant>;
};

export type ThreadsSearch = {
  attachedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  fileUrl: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  accountRemuneration?: Maybe<AccountRemuneration>;
  accountRemunerationId?: Maybe<Scalars['String']['output']>;
  activityTag?: Maybe<ActivityTag>;
  amount: Amount;
  attachmentIds: Array<Scalars['String']['output']>;
  attachmentLost: Scalars['Boolean']['output'];
  attachmentRequested: Scalars['Boolean']['output'];
  attachmentRequestedAt?: Maybe<Scalars['String']['output']>;
  attachmentRequestedById?: Maybe<Scalars['String']['output']>;
  attachmentRequired: Scalars['Boolean']['output'];
  attachmentSuggestionIds: Array<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  authorizationType?: Maybe<AuthorizationType>;
  automaticallyAddedAttachmentIds: Array<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId: Scalars['String']['output'];
  billingTransfer?: Maybe<BillingTransfer>;
  billingTransferId?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Card>;
  cardAcquirerPayout?: Maybe<CardAcquirerPayout>;
  cardId?: Maybe<Scalars['String']['output']>;
  cardTransaction?: Maybe<CardTransaction>;
  cardTransactionMovementId?: Maybe<Scalars['String']['output']>;
  cardTransactionStatus?: Maybe<CardTransactionStatus>;
  cashback?: Maybe<Cashback>;
  cashbackId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CashFlowCategory>;
  categoryAssignment?: Maybe<CategoryAssignment>;
  check?: Maybe<Check>;
  checkId?: Maybe<Scalars['String']['output']>;
  childTransactions: Array<Transaction>;
  cleanCounterpartyName?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<Counterparty>;
  counterpartyName: Scalars['String']['output'];
  declinedReason?: Maybe<DeclinedReason>;
  deferredDebitCardRepayment?: Maybe<DeferredDebitCardRepayment>;
  description?: Maybe<Scalars['String']['output']>;
  directDebit?: Maybe<DirectDebit>;
  directDebitCollection?: Maybe<DirectDebitCollection>;
  directDebitCollectionId?: Maybe<Scalars['String']['output']>;
  directDebitHold?: Maybe<DirectDebitHold>;
  directDebitHoldId?: Maybe<Scalars['String']['output']>;
  directDebitId?: Maybe<Scalars['String']['output']>;
  displayAt: Scalars['String']['output'];
  disputes: Array<Dispute>;
  emittedAt: Scalars['String']['output'];
  enrichmentData: EnrichmentData;
  excludedFromAnalytics: Scalars['Boolean']['output'];
  f24Payment?: Maybe<F24Payment>;
  financingInstallment?: Maybe<FinancingInstallment>;
  financingInstallmentId?: Maybe<Scalars['String']['output']>;
  fx: Scalars['Boolean']['output'];
  fxPaymentPurpose?: Maybe<Scalars['String']['output']>;
  fxPaymentPurposeUnstructured?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  hasAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['String']['output']>;
  initiator?: Maybe<LegacyMembership>;
  initiatorId?: Maybe<Scalars['String']['output']>;
  isAtm: Scalars['Boolean']['output'];
  isEnriched: Scalars['Boolean']['output'];
  isExternalTransaction: Scalars['Boolean']['output'];
  isPos: Scalars['Boolean']['output'];
  isProxied?: Maybe<Scalars['Boolean']['output']>;
  labelIds: Array<Scalars['String']['output']>;
  labels: Array<Label>;
  localAmount?: Maybe<Amount>;
  mergedFees?: Maybe<RelatedFees>;
  mergedFeesId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  nrcPayment?: Maybe<NrcPayment>;
  nrcPaymentId?: Maybe<Scalars['String']['output']>;
  operationMethod: OperationMethod;
  operationType: OperationType;
  organizationId: Scalars['String']['output'];
  overdraftInterestPayment?: Maybe<OverdraftInterestPayment>;
  pagopaPayment?: Maybe<PagopaPayment>;
  pagopaPaymentId?: Maybe<Scalars['String']['output']>;
  parentTransactions: Array<Transaction>;
  providerObjectId: Scalars['String']['output'];
  qualifiedForAccounting: Scalars['Boolean']['output'];
  rawCounterpartyName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This was part of the V1 which is being cleaned up on the clients, we don't need to aggregate this anymore as the data is not used */
  relatedFees?: Maybe<RelatedFees>;
  relatedMovementId?: Maybe<Scalars['String']['output']>;
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  ribaPayment?: Maybe<RibaPayment>;
  ribaPaymentId?: Maybe<Scalars['String']['output']>;
  settledAt?: Maybe<Scalars['String']['output']>;
  settledBalance?: Maybe<Amount>;
  side: Side;
  slug: Scalars['String']['output'];
  status: Status;
  statusHistory: Array<StatusHistory>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<SubjectType>;
  suggestedCategory?: Maybe<SuggestedCategory>;
  supplierInvoices: Array<SupplierInvoice>;
  supplierSubscription?: Maybe<SupplierSubscription>;
  supplierSubscriptionMeta?: Maybe<SupplierSubscriptionMeta>;
  supportedInvoiceCollector?: Maybe<SupportedInvoiceCollector>;
  swiftIncome?: Maybe<SwiftIncome>;
  swiftIncomeId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<Thread>;
  transfer?: Maybe<Transfer>;
  transferId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  vat: Vat;
  walletToWallet?: Maybe<WalletToWallet>;
  walletToWalletId?: Maybe<Scalars['String']['output']>;
};

export type TransactionsSearch = {
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterGroup?: InputMaybe<FilterGroupOne>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type Transfer = {
  __typename?: 'Transfer';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  attachmentIds: Array<Scalars['String']['output']>;
  attachmentVisible: Scalars['Boolean']['output'];
  beneficiary?: Maybe<Beneficiary>;
  beneficiaryId?: Maybe<Scalars['ID']['output']>;
  bic: Scalars['String']['output'];
  cancelable: Scalars['Boolean']['output'];
  clientsSortDateLast?: Maybe<Scalars['String']['output']>;
  clientsSortDateNext?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<TransferCounterparty>;
  createdAt: Scalars['String']['output'];
  cutoffAt?: Maybe<Scalars['String']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  fixedAmount?: Maybe<FixedAmountType>;
  fx: Scalars['Boolean']['output'];
  fxPaymentPurpose?: Maybe<Scalars['String']['output']>;
  fxPaymentPurposeUnstructured?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  fxSettlementStatus?: Maybe<Scalars['String']['output']>;
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['ID']['output']>;
  instant: Scalars['Boolean']['output'];
  internal: Scalars['Boolean']['output'];
  internalInOrganization: Scalars['Boolean']['output'];
  labelIds: Array<Scalars['String']['output']>;
  lastRecursionDate?: Maybe<Scalars['String']['output']>;
  localAmount: Scalars['Float']['output'];
  localAmountCents: Scalars['Int']['output'];
  localAmountCurrency: Scalars['String']['output'];
  nextRecursionDate?: Maybe<Scalars['String']['output']>;
  notEditableReason?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteVisible: Scalars['Boolean']['output'];
  notifyByEmail: Scalars['Boolean']['output'];
  operationType: Scalars['String']['output'];
  proofPdfUrl?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Purpose>;
  qontoBankAccount: Scalars['Boolean']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['String']['output']>;
  sequentialId?: Maybe<Scalars['Int']['output']>;
  settlementDate?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  standingEndingDate?: Maybe<Scalars['String']['output']>;
  standingFrequency?: Maybe<Scalars['String']['output']>;
  standingOn: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type TransferCounterparty = {
  __typename?: 'TransferCounterparty';
  accountIdentifier?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  bankIdentifier?: Maybe<Scalars['String']['output']>;
  branchIdentifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  fileUrl: Scalars['String']['output'];
  thumbUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Vat = {
  __typename?: 'Vat';
  items: Array<VatItem>;
  status?: Maybe<VatStatus>;
  totalAmount: Amount;
};

export type VatItem = {
  __typename?: 'VatItem';
  amount?: Maybe<Amount>;
  amountExcludingVat?: Maybe<Amount>;
  id: Scalars['String']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
};

export enum VatStatus {
  VatAuto = 'VAT_AUTO',
  VatConfirmed = 'VAT_CONFIRMED',
  VatDetecting = 'VAT_DETECTING',
  VatDetectionError = 'VAT_DETECTION_ERROR',
  VatInheritedFromBeneficiary = 'VAT_INHERITED_FROM_BENEFICIARY',
  VatManual = 'VAT_MANUAL',
  VatNotFound = 'VAT_NOT_FOUND',
  VatOverridden = 'VAT_OVERRIDDEN',
  VatSuggested = 'VAT_SUGGESTED'
}

export type Vehicle = {
  __typename?: 'Vehicle';
  electric?: Maybe<Scalars['Boolean']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type WalletToWallet = {
  __typename?: 'WalletToWallet';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operationSubtype?: Maybe<Scalars['String']['output']>;
  operationType: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatAmountCents?: Maybe<Scalars['Int']['output']>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type SearchSingleSupplierSubscriptionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SearchSingleSupplierSubscriptionQuery = { __typename?: 'Query', searchSingleSupplierSubscription: { __typename?: 'SearchSingleSupplierSubscriptionResult', subscription: { __typename?: 'SupplierSubscription', id: string, counterpartyName: string, frequency: Frequency, nextPaymentDate: string, paymentMethod: SubscriptionPaymentMethod, logoUrl?: string | null, amount: { __typename?: 'Amount', value: string, currency: string }, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null }, recentTransactions: Array<{ __typename?: 'Transaction', id: string, emittedAt: string, isExternalTransaction: boolean, amount: { __typename?: 'Amount', value: string, currency: string }, card?: { __typename?: 'Card', id: string, nickname: string, embossedName?: string | null, last4: string, cardLevel: CardLevel, cardDesign?: string | null, status: CardStatus, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string } | null } | null }> } } };

export type SearchSupplierSubscriptionsQueryVariables = Exact<{
  pagination: SupplierSubscriptionsPagination;
  sort: Sort;
}>;


export type SearchSupplierSubscriptionsQuery = { __typename?: 'Query', searchSupplierSubscriptions: { __typename?: 'SearchSupplierSubscriptionsResult', meta: { __typename?: 'SearchSupplierSubscriptionsMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, subscriptions: Array<{ __typename?: 'SupplierSubscription', id: string, counterpartyName: string, frequency: Frequency, nextPaymentDate: string, paymentMethod: SubscriptionPaymentMethod, logoUrl?: string | null, amount: { __typename?: 'Amount', value: string, currency: string }, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null }, recentTransactions: Array<{ __typename?: 'Transaction', id: string, emittedAt: string, isExternalTransaction: boolean, amount: { __typename?: 'Amount', value: string, currency: string }, card?: { __typename?: 'Card', id: string, nickname: string, embossedName?: string | null, last4: string, cardLevel: CardLevel, cardDesign?: string | null, status: CardStatus, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string } | null } | null }> }> } };

export type SearchOrganizationQueryVariables = Exact<{
  input?: InputMaybe<OrganizationsSearch>;
  includeFinancialDetail: Scalars['Boolean']['input'];
}>;


export type SearchOrganizationQuery = { __typename?: 'Query', searchOrganization: { __typename?: 'SearchOrganizationResult', organization: { __typename?: 'Organization', id: string, name: string, slug: string, status: OrganizationStatus, createdAt: string, suspensionReason?: string | null, avatar: { __typename?: 'OrganizationAvatar', url?: string | null, thumbUrl?: string | null, isDefault?: boolean | null }, company: { __typename?: 'Company', legalName: string, legalCountry: string, legalForm?: string | null, legalNumber?: string | null, legalSector?: string | null, legalCode?: string | null, legalRegistrationDate?: string | null, legalTvaNumber?: string | null, tradeName?: string | null, contactEmail: string, websiteUrl?: string | null, activityDescription?: string | null, addresses?: Array<{ __typename?: 'Address', type: CompanyAddressType, firstLine?: string | null, secondLine?: string | null, thirdLine?: string | null, zipCode?: string | null, city?: string | null, country?: string | null } | null> | null, taxResidence?: { __typename?: 'CompanyTaxResidence', country?: string | null, taxIdentificationNumber?: string | null } | null, financialDetail?: { __typename?: 'FinancialDetail', annualTurnover?: string | null, estimatedAnnualTurnover?: string | null, estimatedYearlyIncome?: string | null, maxSinglePaymentAmount?: string | null, yearlyTransactionVolume?: string | null } | null }, customer: { __typename?: 'Customer', contractSignedAt?: string | null, natureOfOperations?: Array<string | null> | null }, kyb?: { __typename?: 'OrganizationKyb', kybStatus: KybStatus, flexKybStatus?: FlexKybStatus | null, unreferenced: boolean, ongoingKycKybUpdateProcessId?: string | null, typeformUrl?: string | null, associationTypeformUrl?: string | null, associationTypeformFileFilledAt?: string | null } | null, features?: { __typename?: 'OrganizationFeature', features?: Array<string | null> | null } | null, onboardingPartner?: { __typename?: 'OnboardingPartner', code: string, type: OnboardingPartnerType } | null } } };

export type SearchMembershipsQueryVariables = Exact<{
  input: MembershipsSearch;
}>;


export type SearchMembershipsQuery = { __typename?: 'Query', searchMemberships: { __typename?: 'SearchMembershipsResult', memberships: Array<{ __typename?: 'Membership', id: string, organizationId: string, userId?: string | null, status: MembershipStatus, role: MembershipRole, teamId?: string | null, teamName?: string | null, invitation?: { __typename?: 'Invite', id: string, recipientId: string, firstName: string, lastName: string, fullName: string, email: string } | null, kyc: { __typename?: 'MembershipKycStatus', membershipId: string, kycStatus: KycStatus }, avatar?: { __typename?: 'UserAvatar', userId: string, fileUrl: string, thumbUrl: string } | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, firstName: string, lastName: string, fullName: string, userId: string } | null, user?: { __typename?: 'User', id: string, email: string } | null }>, meta: { __typename?: 'SearchMembershipsMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number, cursor?: string | null } } };

export type GetSingleMembershipQueryVariables = Exact<{
  input: SingleMembershipsSearch;
}>;


export type GetSingleMembershipQuery = { __typename?: 'Query', getSingleMembership?: { __typename?: 'Membership', id: string, organizationId: string, userId?: string | null, status: MembershipStatus, role: MembershipRole, teamId?: string | null, teamName?: string | null, invitation?: { __typename?: 'Invite', id: string, recipientId: string, firstName: string, lastName: string, fullName: string, email: string } | null, kyc: { __typename?: 'MembershipKycStatus', membershipId: string, kycStatus: KycStatus }, avatar?: { __typename?: 'UserAvatar', userId: string, fileUrl: string, thumbUrl: string } | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, firstName: string, lastName: string, fullName: string, userId: string } | null, user?: { __typename?: 'User', id: string, email: string } | null } | null };

export type FetchExpenseReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchExpenseReportQuery = { __typename?: 'Query', expenseReport: { __typename?: 'SearchSingleExpenseReportResult', expenseReport: { __typename?: 'ExpenseReport', id: string, title: string, status: string, updatedAt: string, feedback?: string | null, amount: { __typename?: 'Amount', value: string, currency: string }, totalVatAmount: { __typename?: 'Amount', value: string, currency: string }, items: Array<{ __typename?: 'ExpenseItem', id: string, type: string, attachmentId?: string | null, merchantName?: string | null, distanceMeters?: number | null, vatRate?: number | null, date?: string | null, note: string, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', value: string, currency: string }, attachment?: { __typename?: 'Attachment', file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, multiVat: Array<{ __typename?: 'ExpenseItemMultiVat', rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }> }> } }, myBankDetails: { __typename?: 'MyBankDetailsResult', bankDetails?: { __typename?: 'MyBankDetails', iban: string } | null } };

export type FetchExpenseReportRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchExpenseReportRequestQuery = { __typename?: 'Query', searchSingleRequestExpenseReport: { __typename?: 'SearchSingleRequestExpenseReportResult', requestExpenseReport: { __typename?: 'RequestExpenseReport', id: string, vatRate?: number | null, approverId?: string | null, iban?: string | null, note: string, organizationId: string, reference: string, requestType: string, processedAt?: string | null, declinedNote?: string | null, status: string, requestId: string, approvalWorkflowStateId?: string | null, lastStep: boolean, amount: { __typename?: 'Amount', currency: string, value: string }, vatAmount?: { __typename?: 'Amount', currency: string, value: string } | null, attachments: Array<{ __typename?: 'Attachment', id: string, file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileName: string, fileContentType: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }>, membership: { __typename?: 'Membership', id: string, person?: { __typename?: 'Person', fullName: string, displayName?: string | null } | null }, expenseReport: { __typename?: 'ExpenseReport', id: string, title: string, status: string, initiatorID: string, feedback?: string | null, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', currency: string, value: string }, totalVatAmount: { __typename?: 'Amount', currency: string, value: string }, items: Array<{ __typename?: 'ExpenseItem', id: string, type: string, merchantName?: string | null, distanceMeters?: number | null, vatRate?: number | null, date?: string | null, note: string, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', value: string, currency: string }, attachment?: { __typename?: 'Attachment', id: string, file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', fileContentType: string, fileUrl: string, status: string, downloadUrl: string } | null } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, multiVat: Array<{ __typename?: 'ExpenseItemMultiVat', rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }> }> } } }, myBankDetails: { __typename?: 'MyBankDetailsResult', bankDetails?: { __typename?: 'MyBankDetails', iban: string } | null } };

export type GetTransactionByIdQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
  sort: Sort;
  filterGroup?: InputMaybe<FilterGroupOne>;
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetTransactionByIdQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'SearchTransactionsResult', transactions: Array<{ __typename?: 'Transaction', activityTag?: ActivityTag | null, attachmentLost: boolean, attachmentRequired: boolean, attachmentRequestedAt?: string | null, automaticallyAddedAttachmentIds: Array<string>, note?: string | null, qualifiedForAccounting: boolean, isEnriched: boolean, labels: Array<{ __typename?: 'Label', id: string, name: string, listId: string, labelList: { __typename?: 'LabelList', id: string, name: string, color: string, rank: number } }>, attachments: Array<{ __typename?: 'Attachment', slug: string, id: string, downloadUrl: string, createdAt: string, attachmentType: string, thumbnail?: { __typename?: 'Thumbnail', fileUrl: string } | null, file?: { __typename?: 'AttachedFile', name: string, contentType: string, size: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileContentType: string, fileName: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }> }> } };

export type SearchTransactionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
  sort?: InputMaybe<Sort>;
  filterGroup?: InputMaybe<FilterGroupOne>;
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchTransactionsQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'SearchTransactionsResult', meta: { __typename?: 'SearchTransactionsMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, transactions: Array<{ __typename?: 'Transaction', id: string, activityTag?: ActivityTag | null, counterpartyName: string, emittedAt: string, fx: boolean, rawCounterpartyName?: string | null, operationMethod: OperationMethod, operationType: OperationType, description?: string | null, note?: string | null, settledAt?: string | null, side: Side, slug: string, status: Status, subjectType?: SubjectType | null, qualifiedForAccounting: boolean, attachmentLost: boolean, attachmentRequired: boolean, attachmentIds: Array<string>, attachmentSuggestionIds: Array<string>, automaticallyAddedAttachmentIds: Array<string>, attachmentRequested: boolean, attachmentRequestedAt?: string | null, excludedFromAnalytics: boolean, isEnriched: boolean, accountRemuneration?: { __typename?: 'AccountRemuneration', id: string, remuneratedMonthStartDate: string } | null, cashback?: { __typename?: 'Cashback', referenceMonthStartDate: string } | null, deferredDebitCardRepayment?: { __typename?: 'DeferredDebitCardRepayment', id: string, paidAt?: string | null, repaymentStatus: DdcStatus, scheduledAt?: string | null } | null, overdraftInterestPayment?: { __typename?: 'OverdraftInterestPayment', periodStartDate: string, periodEndDate: string } | null, disputes: Array<{ __typename?: 'Dispute', claim: { __typename?: 'Claim', id: string, status: string, type: string } }>, amount: { __typename?: 'Amount', value: string, currency: string }, billingTransfer?: { __typename?: 'BillingTransfer', operationSubtype: string, operationType: string } | null, categoryAssignment?: { __typename?: 'CategoryAssignment', id: string, source: string, ruleId?: string | null } | null, initiator?: { __typename?: 'LegacyMembership', id: string, fullName: string, firstName: string, lastName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } | null, enrichmentData: { __typename?: 'EnrichmentData', logo?: { __typename?: 'Logo', small: string, medium: string } | null }, localAmount?: { __typename?: 'Amount', value: string, currency: string } | null, vat: { __typename?: 'Vat', status?: VatStatus | null, totalAmount: { __typename?: 'Amount', value: string, currency: string }, items: Array<{ __typename?: 'VatItem', id: string, transactionId: string, rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }> }, suggestedCategory?: { __typename?: 'SuggestedCategory', id?: string | null } | null, settledBalance?: { __typename?: 'Amount', value: string, currency: string } | null, statusHistory: Array<{ __typename?: 'StatusHistory', status: StatusHistoryStatus, createdAt: string }>, mergedFees?: { __typename?: 'RelatedFees', feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } }, fees: Array<{ __typename?: 'Fee', id: string, eventType: string, feeLabel: string, feeStatus: FeeStatus, feeType: FeeType, vatRate: number, amount: { __typename?: 'Amount', value: string, currency: string }, totalAmount: { __typename?: 'Amount', value: string, currency: string }, totalAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, vatAmount: { __typename?: 'Amount', value: string, currency: string }, feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } } }> } | null, supportedInvoiceCollector?: { __typename?: 'SupportedInvoiceCollector', type: SupportedInvoiceCollectorType, solutionInstanceStatus: SolutionInstanceStatus, integrationName: string, integrationSlug: string } | null, financingInstallment?: { __typename?: 'FinancingInstallment', createdAt: string, currentInstallmentNumber: number, totalInstallmentsNumber: number, accumulatedFeesAmount: { __typename?: 'Amount', value: string, currency: string }, capitalAmount: { __typename?: 'Amount', value: string, currency: string }, interestAmount: { __typename?: 'Amount', value: string, currency: string } } | null, attachments: Array<{ __typename?: 'Attachment', slug: string, id: string, downloadUrl: string, createdAt: string, attachmentType: string, thumbnail?: { __typename?: 'Thumbnail', fileUrl: string } | null, file?: { __typename?: 'AttachedFile', name: string, contentType: string, size: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileContentType: string, fileName: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }>, bankAccount?: { __typename?: 'BankAccount', id: string, bic: string, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null } | null, card?: { __typename?: 'Card', id: string, last4: string, nickname: string, cardDesign?: string | null, cardType: CardType, cardLevel: CardLevel, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string, firstName: string, lastName: string } | null, appearance?: { __typename?: 'CardAppearance', assets: { __typename?: 'CardAppearanceAssets', frontSmall: string } } | null } | null, labels: Array<{ __typename?: 'Label', id: string, name: string, listId: string, labelList: { __typename?: 'LabelList', id: string, name: string, color: string, rank: number } }>, thread?: { __typename?: 'Thread', id: string, attachedToId: string, attachedToType: string, createdAt: string, messages: Array<{ __typename?: 'Message', id: string, createdAt: string, content: string, author?: { __typename?: 'Participant', id: string, lastReadAt?: string | null, membership: { __typename?: 'LegacyMembership', fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } } | null }>, participants: Array<{ __typename?: 'Participant', id: string, lastReadAt?: string | null, membershipId: string, membership: { __typename?: 'LegacyMembership', firstName: string, fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } }> } | null, transfer?: { __typename?: 'Transfer', status: string } | null, directDebit?: { __typename?: 'DirectDebit', emitterBic?: string | null, emitterIban?: string | null, emitterName?: string | null, governmentOrder?: boolean | null, id: string, reference?: string | null, refundRequestedAt?: string | null, refundable: boolean, mandate?: { __typename?: 'QontoTransfersSddMandatesFirstpartyV2_Mandate', umr?: string | null } | null } | null }> } };

export type GetLedgerEntriesQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput>;
}>;


export type GetLedgerEntriesQuery = { __typename?: 'Query', getLedgerEntries?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesResponse', entries: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched', id: string, organizationId: string, accountingPeriodId: string, internalReference?: string | null, accountingDate: string, postingDate?: string | null, recordDate: string, attachmentId?: string | null, documentNumber?: string | null, documentDate?: string | null, documentDueDate?: string | null, documentCurrency?: string | null, documentType: string, counterPartyName: string, entryTitle?: string | null, reference?: string | null, status: QontoAccountingEntriesFirstpartyV2_EntryStatus, validatedAt?: any | null, validatedBy?: string | null, createdAt?: any | null, updatedAt?: any | null, documentTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, documentNetAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, documentGrossAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, documentIncludingTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, accountingTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, accountingIncludingTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, journal?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Journal', id: string, code: string, name: string, type: string, isDeleted?: boolean | null, createdAt?: any | null, updatedAt?: any | null } | null, lines: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched', id: string, way: string, label?: string | null, taxCodeId?: string | null, taxRatePercent?: string | null, amount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, taxBaseAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, account?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean, isPostable: boolean } | null, auxiliaryAccount?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean, isPostable: boolean } | null }>, displayedAccounts: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean, isPostable: boolean }>, integrationStatus?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry', id: string, state: QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState, ackValidation: boolean, rejectionLog?: string | null, createdAt?: any | null, rejectionType?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType', label: string, howToFix?: string | null } | null } | null }>, meta?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Meta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } | null } | null };

export type GetJournalsQueryVariables = Exact<{
  includeAccount: Scalars['Boolean']['input'];
  includeBankAccount: Scalars['Boolean']['input'];
}>;


export type GetJournalsQuery = { __typename?: 'Query', getJournals: { __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsResponse', journals: Array<{ __typename?: 'QontoAccountingJournalsFirstpartyV2_Journal', id: string, code: string, name: string, type: string, bankAccount?: { __typename?: 'BankAccount', id: string, iban: string, bic: string, name: string, logo?: { __typename?: 'Logo', small: string } | null } | null, account?: { __typename?: 'QontoAccountingAccountsFirstpartyV2_Account', id: string, code: string, label: string } | null }> } };

export type GetSingleReceivableInvoiceQueryVariables = Exact<{
  input?: InputMaybe<SingleReceivableInvoicesSearch>;
  includePaymentLinkDetails: Scalars['Boolean']['input'];
  includeInvoiceSubscription: Scalars['Boolean']['input'];
  includeDirectDebitMandate: Scalars['Boolean']['input'];
}>;


export type GetSingleReceivableInvoiceQuery = { __typename?: 'Query', getSingleReceivableInvoice?: { __typename?: 'ReceivableInvoice', id: string, attachmentId: string, invoiceNumber: string, number?: string | null, locale?: string | null, issueDate?: string | null, dueDate?: string | null, currency?: string | null, status: ReceivableInvoiceStatus, einvoicingStatus?: ReceivableInvoiceEinvoicingStatus | null, fileName?: string | null, reference?: string | null, beneficiaryName?: string | null, contactEmail?: string | null, termsAndConditions?: string | null, purchaseOrder?: string | null, referralLink?: string | null, intermediaryBankBic?: string | null, iban?: string | null, bic?: string | null, header?: string | null, footer?: string | null, overdue: boolean, isPdfGenerated: boolean, isHiddenFromClientPortal: boolean, directDebitEnabled: boolean, hasDuplicates: boolean, imported: boolean, isEinvoice: boolean, isDeposit: boolean, createdAt?: string | null, updatedAt?: string | null, paidAt?: string | null, nextReminderDate?: string | null, performanceDate?: string | null, performanceStartDate?: string | null, performanceEndDate?: string | null, accountingRecordedAt?: string | null, importAnalyzedAt?: string | null, invoiceType?: ReceivableInvoiceType | null, organizationId?: string | null, customerId?: string | null, bankAccountId?: string | null, quoteId?: string | null, invoiceSubscriptionId?: string | null, directDebitSubscriptionId?: string | null, directDebitCollectionMandateId?: string | null, depositInvoiceId?: string | null, receivableInvoicingUploadId?: string | null, termsConditionsUploadId?: string | null, previousPartialInvoiceId?: string | null, lastPartialInvoiceId?: string | null, receivableCreditNoteIds?: Array<string> | null, balanceInvoiceIds?: Array<string> | null, partialInvoiceIds?: Array<string> | null, subtotalBeforeDiscount?: { __typename?: 'Amount', value: string, currency: string } | null, subtotal?: { __typename?: 'Amount', value: string, currency: string } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, amountDue?: { __typename?: 'Amount', value: string, currency: string } | null, amountPaid?: { __typename?: 'Amount', value: string, currency: string } | null, depositAmount?: { __typename?: 'Amount', value: string, currency: string } | null, stampDutyAmount?: { __typename?: 'Amount', value: string, currency: string } | null, payment?: { __typename?: 'ReceivableInvoicePayment', conditions?: string | null, method?: string | null } | null, discount?: { __typename?: 'ReceivableInvoiceDiscount', type?: string | null, value?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, welfareFund?: { __typename?: 'ReceivableInvoiceWelfareFund', type?: string | null, rate?: string | null } | null, withholdingTax?: { __typename?: 'ReceivableInvoiceWithholdingTax', type?: string | null, rate?: string | null, reason?: string | null } | null, progress?: { __typename?: 'ReceivableInvoiceProgress', mode?: string | null, cumulativePercentage?: string | null, cumulativeAmount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, customerSnapshot?: { __typename?: 'ReceivableInvoiceCustomerSnapshot', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null, kind?: ReceivableInvoiceCustomerKind | null, tinNumber?: string | null, vatNumber?: string | null, locale?: string | null, currency?: string | null, billingAddress?: { __typename?: 'ReceivableInvoiceBillingAddress', streetAddress?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null, organizationSnapshot?: { __typename?: 'ReceivableInvoiceOrganizationSnapshot', id: string, slug?: string | null, legalName?: string | null, legalForm?: string | null, legalNumber?: string | null, legalCountry?: string | null, vatNumber?: string | null, districtCourt?: string | null, companyLeadership?: string | null, commercialRegisterNumber?: string | null, vatPaymentCondition?: string | null, transactionType?: string | null, taxNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressZipcode?: string | null, addressCity?: string | null, addressCountry?: string | null, type?: string | null, contactEmail?: string | null, locale?: string | null, legalCapitalShare?: { __typename?: 'Amount', value: string, currency: string } | null } | null, paymentLink?: { __typename?: 'ReceivableInvoicePaymentLink', methods?: Array<string> | null } | null, sections?: Array<{ __typename?: 'ReceivableInvoiceSection', id: string, items?: Array<{ __typename?: 'ReceivableInvoiceSectionItem', id: string, title?: string | null, description?: string | null, quantity?: string | null, unit?: string | null, vatRate?: string | null, vatExemptionCode?: string | null, productId?: string | null, createdAt?: string | null, updatedAt?: string | null, unitPrice?: { __typename?: 'Amount', value: string, currency: string } | null, totalVat?: { __typename?: 'Amount', value: string, currency: string } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null, subtotal?: { __typename?: 'Amount', value: string, currency: string } | null, discount?: { __typename?: 'ReceivableInvoiceDiscount', type?: string | null, value?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, progress?: { __typename?: 'ReceivableInvoiceSectionItemProgress', type?: string | null, percentage?: string | null, cumulativePercentage?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, cumulativeAmount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, links?: Array<{ __typename?: 'ReceivableInvoiceSectionItemLink', title?: string | null, url?: string | null }> | null }> | null }> | null, einvoicingLifecycleEvents?: Array<{ __typename?: 'ReceivableInvoiceEinvoicingLifecycleEvent', type?: string | null, status?: string | null, message?: string | null, createdAt?: string | null }> | null, debtCollection?: { __typename?: 'ReceivableInvoiceDebtCollection', id: string, status: string, actionNeeded: boolean } | null, paymentLinkDetails?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink', id: string, name: string, status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus, recurrenceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType, createdAt: string, expirationDate?: string | null, organizationName?: string | null, debitorName?: string | null, latestPaymentMethod?: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod | null, potentialPaymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>, amount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, paymentInitiator?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator', resourceId: string, resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType, resourceNumber?: string | null } | null, settings?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings', redirectUrl?: string | null, limit?: number | null } | null, items: Array<{ __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem', id?: string | null, title: string, type?: QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType | null, description?: string | null, quantity: number, measureUnit?: string | null, vatRate: string, unitPrice?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null }>, recurrenceSettings?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings', frequencyRecurrence: QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence, frequencyValue: number, times?: number | null } | null } | null, invoiceSubscription?: { __typename?: 'ReceivableInvoiceSubscription', id: string, startDate?: string | null, endDate?: string | null, nextInvoiceDate?: string | null, currency?: string | null, invoiceStatus?: ReceivableInvoiceSubscriptionInvoiceStatus | null, customerName?: string | null, paymentTermsDays?: number | null, purchaseOrder?: string | null, beneficiaryName?: string | null, termsAndConditions?: string | null, status?: ReceivableInvoiceSubscriptionStatus | null, createdAt?: string | null, updatedAt?: string | null, header?: string | null, footer?: string | null, directDebitEnabled?: boolean | null, isEinvoice?: boolean | null, organizationId?: string | null, customerId?: string | null, bankAccountId?: string | null, discount?: { __typename?: 'ReceivableInvoiceSubscriptionDiscount', type?: string | null, value?: string | null } | null, frequency?: { __typename?: 'ReceivableInvoiceSubscriptionFrequency', value?: number | null, recurrence?: ReceivableInvoiceSubscriptionRecurrence | null } | null, emailTemplate?: { __typename?: 'ReceivableInvoiceSubscriptionEmailTemplate', emailTitle?: string | null, emailBody?: string | null, sendTo?: Array<string> | null, copyToSelf?: boolean | null } | null, payment?: { __typename?: 'ReceivableInvoiceSubscriptionPayment', conditions?: string | null, method?: string | null } | null, welfareFund?: { __typename?: 'ReceivableInvoiceSubscriptionWelfareFund', type?: string | null, rate?: string | null } | null, withholdingTax?: { __typename?: 'ReceivableInvoiceSubscriptionWithholdingTax', type?: string | null, rate?: string | null, reason?: string | null } | null, stampDutyAmount?: { __typename?: 'Amount', value: string, currency: string } | null, amountDue?: { __typename?: 'Amount', value: string, currency: string } | null, paymentLink?: { __typename?: 'ReceivableInvoiceSubscriptionPaymentLink', methods?: Array<string> | null } | null, sections?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSectionItem', id: string, title?: string | null, description?: string | null, quantity?: string | null, unit?: string | null, vatRate?: string | null, vatExemptionCode?: string | null, productId?: string | null, createdAt?: string | null, updatedAt?: string | null, unitPrice?: { __typename?: 'Amount', value: string, currency: string } | null, discount?: { __typename?: 'ReceivableInvoiceSubscriptionDiscount', type?: string | null, value?: string | null } | null, links?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSectionItemLink', title?: string | null, url?: string | null }> | null }> | null }> | null } | null, directDebitCollectionMandate?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate', id: string, status: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus, uniqueMandateReference: string, creditorIdentifier: string, mandateSignatureDate: string, type: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType, recurrenceType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType, link: string, clientIbanLastDigits: string, clientBic: string, organizationId: string, clientId: string, clientSnapshot?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot', id: string, name: string, firstName: string, lastName: string, kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind, email: string, locale: string, address: string, city: string, zipCode: string, provinceCode: string, countryCode: string } | null, organizationSnapshot?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot', id: string, name: string, logoUrl: string, addressLine_1: string, addressLine_2: string, addressLine_3: string, city: string, zipCode: string, country: string } | null, paymentInfo?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo', notifyClient: boolean, scheduleCustomUnit: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit, interval: number, scheduleTotalCollectionCount: number, scheduleType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType, firstPayment?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment', collectionDate: string, isOverdue?: boolean | null, reference: string, amount?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null } | null } | null } | null } | null };

export type SearchSupplierInvoicesQueryVariables = Exact<{
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  sort?: InputMaybe<Sort>;
}>;


export type SearchSupplierInvoicesQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string, issuerName?: string | null, invoiceNumber?: string | null, status: SupplierInvoiceStatus, source: string, attachmentCategory: SupplierInvoiceAttachmentCategory, createdAt: string, meta?: { __typename?: 'SupplierInvoiceMeta', integrationType?: string | null, integrationName?: string | null, connector?: string | null, emailedBy?: string | null, resolvedBy?: { __typename?: 'Membership', id: string, person?: { __typename?: 'Person', id: string, fullName: string } | null } | null } | null, supplierSnapshot?: { __typename?: 'SupplierSnapshot', id: string, name: string } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } };

export type SearchSingleSupplierInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SearchSingleSupplierInvoiceQuery = { __typename?: 'Query', searchSingleSupplierInvoice: { __typename?: 'SearchSingleSupplierInvoiceResult', supplierInvoice: { __typename?: 'SupplierInvoice', id: string, attachmentId: string, issuerName?: string | null, invoiceNumber?: string | null, fileName: string, status: SupplierInvoiceStatus, source: string, attachmentCategory: SupplierInvoiceAttachmentCategory, markedAsRead?: boolean | null, createdAt: string, supplierSnapshot?: { __typename?: 'SupplierSnapshot', id: string, name: string } | null, meta?: { __typename?: 'SupplierInvoiceMeta', integrationType?: string | null, integrationName?: string | null, connector?: string | null, emailedBy?: string | null } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null, suggestedTransactions?: Array<{ __typename?: 'Transaction', id: string, counterpartyName: string, emittedAt: string, operationMethod: OperationMethod, amount: { __typename?: 'Amount', value: string, currency: string } }> | null } } };

export type CountSupplierInvoicesQueryVariables = Exact<{
  markedAsRead?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>> | InputMaybe<Scalars['Boolean']['input']>>;
}>;


export type CountSupplierInvoicesQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', totalCount: number } } };

export type SearchOrganizationSlugQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchOrganizationSlugQuery = { __typename?: 'Query', searchOrganization: { __typename?: 'SearchOrganizationResult', organization: { __typename?: 'Organization', slug: string } } };


export const SearchSingleSupplierSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSingleSupplierSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleSupplierSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"embossedName"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSingleSupplierSubscriptionQuery, SearchSingleSupplierSubscriptionQueryVariables>;
export const SearchSupplierSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSupplierSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierSubscriptionsPagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"embossedName"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSupplierSubscriptionsQuery, SearchSupplierSubscriptionsQueryVariables>;
export const SearchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinancialDetail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"suspensionReason"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"legalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"legalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalSector"}},{"kind":"Field","name":{"kind":"Name","value":"legalCode"}},{"kind":"Field","name":{"kind":"Name","value":"legalRegistrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"legalTvaNumber"}},{"kind":"Field","name":{"kind":"Name","value":"tradeName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activityDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstLine"}},{"kind":"Field","name":{"kind":"Name","value":"secondLine"}},{"kind":"Field","name":{"kind":"Name","value":"thirdLine"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxResidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"taxIdentificationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialDetail"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinancialDetail"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualTurnover"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedAnnualTurnover"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedYearlyIncome"}},{"kind":"Field","name":{"kind":"Name","value":"maxSinglePaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyTransactionVolume"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignedAt"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfOperations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kybStatus"}},{"kind":"Field","name":{"kind":"Name","value":"flexKybStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unreferenced"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingKycKybUpdateProcessId"}},{"kind":"Field","name":{"kind":"Name","value":"typeformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"associationTypeformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"associationTypeformFileFilledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboardingPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrganizationQuery, SearchOrganizationQueryVariables>;
export const SearchMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipsSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<SearchMembershipsQuery, SearchMembershipsQueryVariables>;
export const GetSingleMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSingleMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleMembershipsSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}}]}}]} as unknown as DocumentNode<GetSingleMembershipQuery, GetSingleMembershipQueryVariables>;
export const FetchExpenseReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchExpenseReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"expenseReport"},"name":{"kind":"Name","value":"searchSingleExpenseReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"distanceMeters"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"myBankDetails"},"name":{"kind":"Name","value":"getMyBankDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}}]}}]}}]} as unknown as DocumentNode<FetchExpenseReportQuery, FetchExpenseReportQueryVariables>;
export const FetchExpenseReportRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchExpenseReportRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleRequestExpenseReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestExpenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approverId"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedNote"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"approvalWorkflowStateId"}},{"kind":"Field","name":{"kind":"Name","value":"lastStep"}},{"kind":"Field","name":{"kind":"Name","value":"expenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiatorID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"distanceMeters"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"myBankDetails"},"name":{"kind":"Name","value":"getMyBankDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}}]}}]}}]} as unknown as DocumentNode<FetchExpenseReportRequestQuery, FetchExpenseReportRequestQueryVariables>;
export const GetTransactionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTransactionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterGroupOne"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activityTag"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentLost"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"automaticallyAddedAttachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedForAccounting"}},{"kind":"Field","name":{"kind":"Name","value":"isEnriched"}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"labelList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>;
export const SearchTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterGroupOne"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRemuneration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remuneratedMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deferredDebitCardRepayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"repaymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overdraftInterestPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"periodEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityTag"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrichmentData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawCounterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"settledAt"}},{"kind":"Field","name":{"kind":"Name","value":"settledBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subjectType"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedForAccounting"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentLost"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentSuggestionIds"}},{"kind":"Field","name":{"kind":"Name","value":"automaticallyAddedAttachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequested"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mergedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"feeLabel"}},{"kind":"Field","name":{"kind":"Name","value":"feeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"feeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"excludedFromAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"isEnriched"}},{"kind":"Field","name":{"kind":"Name","value":"supportedInvoiceCollector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"solutionInstanceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"integrationSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financingInstallment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accumulatedFeesAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capitalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentInstallmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"interestAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalInstallmentsNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frontSmall"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"labelList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToId"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emitterBic"}},{"kind":"Field","name":{"kind":"Name","value":"emitterIban"}},{"kind":"Field","name":{"kind":"Name","value":"emitterName"}},{"kind":"Field","name":{"kind":"Name","value":"governmentOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mandate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"umr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"refundRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"refundable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsQuery, SearchTransactionsQueryVariables>;
export const GetLedgerEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLedgerEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLedgerEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"accountingPeriodId"}},{"kind":"Field","name":{"kind":"Name","value":"internalReference"}},{"kind":"Field","name":{"kind":"Name","value":"accountingDate"}},{"kind":"Field","name":{"kind":"Name","value":"postingDate"}},{"kind":"Field","name":{"kind":"Name","value":"recordDate"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"documentDate"}},{"kind":"Field","name":{"kind":"Name","value":"documentDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"documentCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"counterPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"entryTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"validatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"validatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentNetAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentGrossAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"journal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"way"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"taxCodeId"}},{"kind":"Field","name":{"kind":"Name","value":"taxRatePercent"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxBaseAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}},{"kind":"Field","name":{"kind":"Name","value":"isPostable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auxiliaryAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}},{"kind":"Field","name":{"kind":"Name","value":"isPostable"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}},{"kind":"Field","name":{"kind":"Name","value":"isPostable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"ackValidation"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionLog"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"howToFix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetLedgerEntriesQuery, GetLedgerEntriesQueryVariables>;
export const GetJournalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJournals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeBankAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJournals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBankAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJournalsQuery, GetJournalsQueryVariables>;
export const GetSingleReceivableInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSingleReceivableInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleReceivableInvoicesSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePaymentLinkDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInvoiceSubscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectDebitMandate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleReceivableInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"einvoicingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"referralLink"}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryBankBic"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"overdue"}},{"kind":"Field","name":{"kind":"Name","value":"isPdfGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenFromClientPortal"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"imported"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"nextReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountingRecordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"importAnalyzedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitCollectionMandateId"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"receivableInvoicingUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"termsConditionsUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"previousPartialInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"lastPartialInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"receivableCreditNoteIds"}},{"kind":"Field","name":{"kind":"Name","value":"balanceInvoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"partialInvoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalBeforeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stampDutyAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"welfareFund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withholdingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"tinNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"legalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"districtCourt"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadership"}},{"kind":"Field","name":{"kind":"Name","value":"commercialRegisterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalCapitalShare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatPaymentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"addressZipcode"}},{"kind":"Field","name":{"kind":"Name","value":"addressCity"}},{"kind":"Field","name":{"kind":"Name","value":"addressCountry"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"methods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatExemptionCode"}},{"kind":"Field","name":{"kind":"Name","value":"totalVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cumulativePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"einvoicingLifecycleEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actionNeeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLinkDetails"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePaymentLinkDetails"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"debitorName"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"potentialPaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"resourceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"measureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequencyRecurrence"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSubscription"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInvoiceSubscription"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTitle"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"sendTo"}},{"kind":"Field","name":{"kind":"Name","value":"copyToSelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}},{"kind":"Field","name":{"kind":"Name","value":"welfareFund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withholdingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stampDutyAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"methods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatExemptionCode"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebitCollectionMandate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectDebitMandate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueMandateReference"}},{"kind":"Field","name":{"kind":"Name","value":"creditorIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"mandateSignatureDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceType"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"clientIbanLastDigits"}},{"kind":"Field","name":{"kind":"Name","value":"clientBic"}},{"kind":"Field","name":{"kind":"Name","value":"clientSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"provinceCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_2"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isOverdue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyClient"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleCustomUnit"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleTotalCollectionCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}}]}}]}}]}}]} as unknown as DocumentNode<GetSingleReceivableInvoiceQuery, GetSingleReceivableInvoiceQueryVariables>;
export const SearchSupplierInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSupplierInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesPagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<SearchSupplierInvoicesQuery, SearchSupplierInvoicesQueryVariables>;
export const SearchSingleSupplierInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSingleSupplierInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleSupplierInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"markedAsRead"}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSingleSupplierInvoiceQuery, SearchSingleSupplierInvoiceQueryVariables>;
export const CountSupplierInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countSupplierInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"markedAsRead"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"markedAsRead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"markedAsRead"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<CountSupplierInvoicesQuery, CountSupplierInvoicesQueryVariables>;
export const SearchOrganizationSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrganizationSlug"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrganizationSlugQuery, SearchOrganizationSlugQueryVariables>;